// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/Blue_cap.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/sesame_cap.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/images/gray_cap.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/images/admin_blue_background.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/images/backgroundforEmaillogin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/images/red_capsule.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 24 24%27 stroke=%27%239ca3af%27%3E%3Cpath stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M8 7V3m8 4V3m-9 8h10m-12 9h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ben-gray-color: #bcbec0;
  --ben-radio-size: 18px;
  --text-color: #ffffff;
  --blue-text-color: #3D79F3;
  --ben-text-sesame-color: #baa38b;
  --div-padding: 24px;
  --font-family: "Inter", sans-serif;
  --background-color: #3D79F3;
  --border-color: #3D79F3;
  --focus-shadow: #3D79F3;
  --btn-color-gray: var(--ben-gray-color);
  --btn-padding: 10px 15px;
  --btn-line-height: 15px;
  --btn-sm-padding: 5px 10px;
  --btn-sm-lh: 8px;
  --btn-box-shadow: 0px 2px 10px rgba(161, 161, 161, 0.493);
  --btn-letter-spacing: 0.3px;
  --btn-font-size: 12px;
  --btn-font-weight: 700;
  --h1-font-size: 24px;
  --h1-font-weight: 400;
  --h1-line-height: 29px;
  --h3-font-size: 14px;
  --h3-font-weight: 700;
  --h5-font-size: 14px;
  --h5-font-weight: 500;
  --ptag-font-size: 12px;
  --ptag-font-color: #bcbec0;
  --gray-text-color: var(--ben-gray-color);
  --ptag-font-weight: 700;
  --article-font-size: 12px;
  --article-font-weight: 400;
  --span-font-weight: 400;
  --span-font-size: 12px;
  --btn-hover-background-color: #3D79F3;
  --gray-btn-hover-background-color: #bcbec0;
  --upload-btn-color: #bcbec0;
  --sesame-color: var(--ben-text-sesame-color);
  --ben-btn-border-radius: 8px;
  --ben-bg-color: #3D79F3;
  --ben-drpdn-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  --btn-color-graytwo: #F2F3F3;
  --table-outline: 0.3px solid rgba(211, 211, 211, 0.281);
  --blue-capsule-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --sesame-capsule-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --gray-capsule-img: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  /* BenneFin brand palette: grading badges, funding bars and Fund Now icons */
  --ben-navy: #0D1D54;
  --ben-blue: #3D79F3;
  --ben-sesame: #BAA38B;
  /* darker sesame for text on white (#BAA38B is only 2.4:1) */
  --ben-sesame-dark: #7A6449;
  --ben-grey: #BCBEC0;
  --ben-grey-dark: #7C8495;
  --ben-track: #E5E7EB;
  --ben-grade-a: var(--ben-navy);
  --ben-grade-b: var(--ben-blue);
  --ben-grade-c: var(--ben-sesame);
  --ben-grade-d: var(--ben-grey);

}

h1,
h2,
h3,
h4,
h5,
h6,
span,
p,
article,
select,
input,
textarea,
b,
option,
label,
link,
a {
  font-family: "Inter", sans-serif !important;
}

h5 {
  margin-bottom: 0 !important;
}

input[type="date"] {
  display: flex;
  text-align: start !important;
}

textarea::placeholder {
  opacity: 50% !important;
  color: var(gray-text-color) !important;
}

.minus_btn {
  border-radius: 50%;
  width: 20px;
  padding: 5px;
  align-items: center;
  display: inline-flex;
  margin-left: 10px;
  height: 20px;
  text-align: center;
  color: white;
}

textarea:disabled {
  background-color: rgba(128, 128, 128, 0.098) !important;
}

.bg-ben {
  background-color: var(--ben-bg-color);
}

.shadow-ben {
  box-shadow: var(--ben-drpdn-shadow);
}

::placeholder {
  padding-left: 5px !important;
  padding-right: 5px !important;
  font-size: 13px;
  opacity: 45%;
}

.btn {
  --bs-btn-border-color: none !important;
  --bs-btn-border-radius: var(--ben-btn-border-radius) !important;
  --bs-btn-font-weight: 400 !important;
  --btn-padding-x: 2px !important;
  --btn-padding-y: 2px !important;

}

p {
  font-size: var(--ptag-font-size);
  font-weight: var(--ptag-font-weight);
  color: var(--ptag-font-color);
  margin-bottom: 0px !important;
  line-height: 14.5px;
}

article {
  font-size: var(--article-font-size);
  font-weight: var(--article-font-weight);
}

h1 {
  font-size: var(--h1-font-size) !important;
  font-weight: var(--h1-font-weight) !important;
}

h3 {
  font-size: var(--h3-font-size) !important;
  font-weight: var(--h3-font-weight) !important;
}

span {
  font-size: var(--span-font-size);
  font-weight: var(--span-font-weight);
}

.eye-color {
  color: blue;
}

.pagestyle {
  height: calc(100vh - 83px);
  overflow: auto;
}

.bus_notific_main {
  display: flex;
  position: absolute;
  margin-bottom: 0px !important;
}

.blue_txt {
  color: var(--blue-text-color);
}

.emaillogintxtdstyl {
  width: 746px;
  height: 64px;
  left: calc(50% - 746px/2);
  top: 120px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}

.show_password_eye {
  position: absolute;
  top: 55%;
  left: 90%;
  cursor: pointer;
}

.emailmaindiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  gap: 30px;
}

.emaillogintxtdstyl span {
  width: 746px;
  height: 64px;
  left: calc(50% - 746px/2);
  top: 120px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}

.blue_btn {
  background-color: var(--background-color) !important;
  height: var(--btn-height);
  width: var(--btn-width);
  font-family: var(--font-family);
  color: var(--text-color) !important;
  border: var(--border-color);
  padding: var(--btn-padding) !important;
  border-radius: var(--ben-btn-border-radius);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  line-height: var(--btn-line-height);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: var(--focus-shadow);
  font-size: var(--btn-font-size);
  font-weight: var(--btn-font-weight);
  letter-spacing: var(--btn-letter-spacing);
  display: inline-block;
  line-height: 1.5;
  cursor: pointer;
}

.blue_btn_btn {
  background-color: var(--background-color) !important;
  height: var(--btn-height);
  width: var(--btn-width);
  font-family: var(--font-family);
  color: var(--text-color) !important;
  border: var(--border-color);
  padding: var(--btn-padding) !important;
  border-radius: var(--ben-btn-border-radius);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  line-height: var(--btn-line-height);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: var(--focus-shadow);
  font-size: var(--btn-font-size);
  font-weight: var(--btn-font-weight);
  letter-spacing: var(--btn-letter-spacing);
  display: inline-block;
  line-height: 1.5;
  cursor: pointer;
}



.kyc-primary-btn:hover {
  background-color: #3D79F3;
}

.blue_btn:disabled {
  opacity: 0.5;
  color: #ebebeb;
  cursor: default;
}

.blue_btn:hover {
  background-color: var(--btn-hover-background-color);
  box-shadow: var(--btn-box-shadow);
}

.disclaimer-message {
  /* QA #42: was sticky with z-index 1000 and covered Confirm Investment on long schedules; now it sits below the cards. */
  background-color: white;
  font-size: 14px;
  font-weight: 600;
}

.gray_btn {
  background-color: var(--btn-color-gray) !important;
  height: var(--btn-height);
  width: var(--btn-width);
  font-family: var(--font-family);
  color: var(--text-color) !important;
  border: var(--border-color);
  padding: var(--btn-padding) !important;
  border-radius: var(--ben-btn-border-radius);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  line-height: var(--btn-line-height);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: var(--focus-shadow);
  font-size: var(--btn-font-size);
  font-weight: var(--btn-font-weight);
  letter-spacing: var(--btn-letter-spacing);
  display: inline-block;
  line-height: 1.5;
  cursor: pointer;
}

.graytwo_btn {
  background-color: var(--btn-color-graytwo) !important;
  height: var(--btn-height);
  width: var(--btn-width);
  font-family: var(--font-family);
  color: var(--blue-text-color) !important;
  border: var(--border-color);
  padding: var(--btn-padding) !important;
  border-radius: var(--ben-btn-border-radius);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  line-height: var(--btn-line-height);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: var(--focus-shadow);
  font-size: var(--btn-font-size);
  font-weight: 400 !important;
  letter-spacing: var(--btn-letter-spacing);
  display: inline-block;
  line-height: 1.5;
  cursor: pointer;
}

.upload_btn {
  background-color: var(--upload-btn-color) !important;
  height: var(--btn-height);
  width: var(--btn-width);
  font-family: var(--font-family);
  color: black !important;
  border: var(--border-color);
  padding: var(--btn-padding) !important;
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  line-height: var(--btn-line-height);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: var(--focus-shadow);
  font-size: var(--btn-font-size);
  font-weight: var(--btn-font-weight);
  letter-spacing: var(--btn-letter-spacing);
  display: inline-block;
  line-height: 1.5;
  cursor: pointer;
}

.black_btn {
  background: var(--gray-text-color);
  height: var(--btn-height);
  width: var(--btn-width);
  font-family: var(--font-family);
  color: var(--text-color);
  border: var(--border-color);
  padding: var(--btn-padding);
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  line-height: 15px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: var(--focus-shadow);
  cursor: pointer;
}

.black_btn:disabled {
  opacity: 0.5;
  color: #ebebeb;
}

.black_btn:hover {
  background: var(--gray-text-color);
  box-shadow: 0px 5px 7px rgba(161, 161, 161, 0.493);
}

.singlInvImage {
  display: flex;
  width: 210px !important;
}

.singlInvImage img {
  width: 190px;
  border-radius: 15px 0px 0px 15px;
}

.gray_btn:disabled {
  padding: var(--btn-padding) !important;
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: var(--focus-shadow);
  font-size: var(--btn-font-size);
  font-weight: var(--btn-font-weight);
  letter-spacing: var(--btn-letter-spacing);
  display: inline-block;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.gray_btn:disabled {
  opacity: 0.5;
  color: #ebebeb;
}

.gray_btn:hover {
  background-color: var(--gray-btn-hover-background-color);
  box-shadow: var(--btn-box-shadow);
}

input {
  border-radius: 0% !important;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  background-color: var(--background-color) !important;
  transition: none;
  /* border-radius: 0%; */
  color: white !important;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;

  /* text-decoration: underline; */
}

.nav-tabs .nav-link[data-rr-ui-event-key="investor_login"] {
  color: white !important;
}

.nav-tabs .nav-link[data-rr-ui-event-key="investor_login"]:not(.active) {
  color: var(--ben-gray-color) !important;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link {
  color: var(--ben-gray-color) !important;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link:hover {
  /* border-radius: 0%; */
}

.css-dip3t8 {
  background-color: var(--blue-text-color) !important;
  left: 0 !important;
  top: 0 !important;
  height: 100vh !important;
}

/* .css-dip3t8-open {
  background-color: #64ba01 !important;
  position: fixed !important;
} */

.css-1bdadyq:hover {
  background-color: #d8d8d800 !important;
}

.menu_items span {
  font-size: 14px;
  font-weight: 400;
  line-height: 15px;
}

.login_main {
  background: #000000;
  height: 100vh;
}

.login_main_img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.main_nav {
  height: 70px;
  width: auto;
  left: 250px;
  right: 0;
  background-color: #fff;
  position: fixed;
  z-index: 10;
  top: 0;
  transition-duration: 300ms;
}

.admin_bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  height: 100vh;
  background-size: cover;
}

.loginTruemail {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  height: 100vh !important;
  background-repeat: no-repeat !important;
  background-size: cover;
}

.emailloginSave {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  justify-content: center;
}

.admin_login_label_email label {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #292929;

}

.admin_login_label label {
  color: white !important;
}

/* .nav_collapsed {
  height: 70px;
  width: auto;
  left: 79px;
  right: 0;
  background-color: #fff;
  position: fixed;
  z-index: 10;
  top: 0;
  transition-duration: 300ms;

} */

.db_collapsed {
  width: auto;
  left: 5%;
  right: 0;
  position: absolute;
  transition-duration: 300ms;
  top: 20%;
}

.bashboard {
  height: 70px;
  width: auto;
  left: 250px;
  right: 0;
  position: absolute;
  transition-duration: 300ms;
  top: 20%;
}

.sidebar_img {
  margin-left: 15px;
  margin-right: 15px;
}

.sidebar_right_arrow {
  margin: 10px 0;
}

.login_input_space {
  min-width: 400px;
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-color: transparent !important;
  isolation: isolate;
}

.nav-tabs {
  --bs-nav-tabs-link-hover-border-color: transparent !important;
  --bs-nav-tabs-border-width: 0px !important;
}

.login_txt {
  margin-left: -49px !important;
  top: 0;
  bottom: 0;
  margin: auto;
}

.ben_card_cls_main {
  display: flex;
  gap: 20px;
}

.card {
  border: none !important;
}

.ben_card_cls {
  padding: 32px;
}

.innercard_content {
  display: flex;
  justify-content: space-between;
  margin-top: 23px;
}

.innercard_content p {
  font-size: 12px !important;
}

.innercard_content h5 {
  font-weight: 800;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 0px;
}

.ben_progress_bar_main {
  border-radius: 0% !important;
  margin: 0 15px;
  /* min-width: 180px; */
  min-height: 22px;
  margin-top: 2px;
}

#yesRadio {
  height: var(--ben-radio-size);
  width: var(--ben-radio-size);
}

#noRadio {
  height: var(--ben-radio-size);
  width: var(--ben-radio-size);
}

.is_pep_div {
  align-items: center;
  display: flex;
  margin-bottom: 8px;
}

.pep_radio {
  align-items: center !important;
}

.pep_radio input {
  height: 2em !important;
  width: 2em !important;
  border-radius: 50% !important;
  transform: translate(100%);
}


.ben_progress_bar {
  background-color: var(--ben-text-sesame-color) !important;
}

.ben_progress_bar_blue {
  background-color: var(--ben-bg-color) !important;

}

.bd_amt_styl b {
  color: #7C8495;
}

.bd_amt_styl span {
  color: var(--blue-text-color);
  font-size: 21px;
  font-weight: 500;
}

.business_db_title {
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.02em;
  color: #292929;
}

.inv_db_currency {
  height: 15px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: #7C8495;

  justify-content: space-between;

}

.btn a {
  text-decoration: none !important;
  color: white;
}

.view_all_Link a {
  text-decoration: none !important;
  color: black;
}

.btn a:hover {
  color: white;
}

.inv_db_currency ol {
  /* padding-left: 2.25rem !important; */
  justify-content: space-between;
}

.inv_db_tinv {
  width: 99px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  left: 45px;

  color: #7C8495;

}

.ben_progress_bar_gray {
  background-color: var(--gray-text-color) !important;
  height: 20px;

}

.ben_progress_bar_main_inv .progress {
  height: 20px;
}

.inv_db_txt {
  font-size: 12px;
  font-weight: 700;
  color: #7C8495;

}

.inv_db_txt1 {
  font-size: 20px;
  font-weight: 700;
  color: #7C8495;

}

.ben_card_cls h6 {
  margin-bottom: 20px;
}

input:disabled {
  background-color: rgba(128, 128, 128, 0.098) !important;
}

.nav {
  display: block !important;
}

/* .form-group label {
  margin-bottom: 5px;
} */

.form-group span {
  color: red;
  font-size: large;
  margin-left: 2px;
}

.first ul ol {
  padding-left: 0px;
}

.cos_main .second ul {
  padding-left: 0;
}

.cos_main .third ul {
  padding-left: 0;
}

.ben_select_cls {
  min-width: fit-content;
}

.loan_page {
  position: absolute;
  left: 20%;
  margin-bottom: 16px;
  max-height: 100vh;
  width: auto;
}

.modal_title {
  padding: 5px 15px !important;
}

.APNL_option_flds {
  padding: 2px 10px !important;
  width: -webkit-fill-available;
}

.fa-eye-font {
  font-size: 15px;
}

/* .ben_select_cls select {
  padding: 4px auto 4px 10px !important;
} */

.css-ybys5z.ps-collapsed {
  width: 80px;
  min-width: 80px;
}

.css-ybys5z {
  position: fixed !important;
}

.custom-file-input::-webkit-file-upload-button {
  transition-delay: 2000ms;
  display: none;
}

input[type="file" i] {
  border: none !important;
  text-align: center;
  border-color: #fff !important;
  color: red;
  display: none;
}

i.fa-solid {
  overflow: hidden;
  /* Ensure the icon does not cause overflow */
  display: inline-block;
  /* Ensures the icon behaves like text */
}

input[type="file" i]:focus-visible {
  border: #fff;
}

input[type="date"] {
  padding: 5px;
  border: none !important;
  text-align: center;
  border-color: #fff !important;
}

.input_filname {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: black !important;
}

.upload_cls {
  margin-top: 10px;
}

.upload_cls img {
  height: 15px;
  margin: 3px;
  cursor: pointer;
}

.label_style {
  width: 165px;
  height: 32px;
  background: var(--ben-gray-color);
  border-radius: 8px;
}

.attach_doc {
  width: 135px;
  height: 32px;
  left: 43px;
  top: 73px;
  background: var(--sesame-color);
  border-radius: 8px;
  color: white;
}

.cust_placeholder_styl input::placeholder {
  font-weight: 700;
  color: rgb(7, 7, 7) !important;
}

.pending_link_modal_docs_div {
  max-height: 45vh;
  overflow: auto;
  margin-right: 10px;
}

.kyc_table th {
  position: static;
}

.compliance_pending_status {
  font-weight: 700;
  color: var(--blue-text-color);
  cursor: pointer;
}

.onboarding_pending_status {
  font-weight: 700;
  color: var(--blue-text-color);

}

.compliance_inv_pending_status {
  font-weight: 700;
  color: var(--blue-text-color);
  cursor: pointer;
}

.compliance_inv_pending_status:hover {
  text-decoration: underline;
}

.compliance_pending_status:hover {
  text-decoration: underline;
}

.compliance_inv_approved_status {
  font-weight: 700;
  color: #059669;
}

.compliance_approved_status {
  font-weight: 700;
  color: #059669;
  cursor: pointer;
}

.onboarding_approved_status {
  font-weight: 700;
  color: #059669;

}

.text_area_placeholder textarea::placeholder {
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #7C8495;
}

.text_area_placeholder_settings textarea {
  font-size: 14px;
  line-height: 17px;
  padding: 10px !important;
}

.text_area_placeholder_settings {
  margin: 10px;
}

.compliance_approved_status:hover {
  text-decoration: underline green;
}

.compliance_rejected_status {
  font-weight: 700;
  color: #ED5151;
}

.upload_report_btn {
  width: fit-content;
  padding: 10px 25px;
  background: var(--sesame-color);
  border-radius: 8px;
  color: white;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  align-items: center;
  text-align: center;
  cursor: pointer;
}

.upload_report_btn_newloanRequest {
  width: fit-content;
  padding: 6px 12px;
  background: var(--sesame-color);
  border-radius: 8px;
  color: white;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  align-items: center;
  text-align: center;
  cursor: pointer;
}




.text_styles_new {
  font-weight: bold;
  font-size: 12px;
  color: #000000;
}

.mand_doc_child_div {
  max-height: 60vh;
  overflow: auto;
}

.padding_style {
  margin-top: 2px !important;
}

.singleInvColrTabs {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  width: 30%;
}

.kyc_close_to_expry_txt {
  position: absolute;
  top: 90%;
  bottom: 16.78%;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  /* Importance indicate star mark */

  color: #ED5151;
}

.notift_btn_txtsize button {
  font-size: 13px;
}

.upload_cls label {
  color: var(--blue-text-color);
  text-align: end;
  cursor: pointer;
  font-weight: 400;
  font-size: 15px;
  align-items: center;
}

.upload_cls article {
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}

.upload_cls span {
  font-size: 15px;
}

.custom-file-input:active {
  outline: 0;
}

.custom-file-input:active::before {
  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

.ANLtextarea {
  border: 1px solid #e5e3e3 !important;
  box-shadow: 0px 2px 10px rgb(0 0 0 / 5%);
}

.comp_pending_radio_styl {
  font-weight: 700;
  font-size: 13px;
  color: #7C8495;
}

.settingsSavebtn button {
  margin-right: 16px;
  padding: 8px 24px !important;

}

.settingsSavebtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  margin-bottom: 16px;
}

.complaince_pendingLink_notes {
  border: none !important;
  box-shadow: 0px 2px 10px rgb(0 0 0 / 5%);
  height: 12vh;

}

.plus-icon {
  width: 18px;
  height: 18px;
}

.upload-text {
  color: var(--blue-text-color) !important;
  font-size: 15px;
  margin: 5px
}

textarea:focus {
  outline: none !important;
  border-color: #d3d3d3 !important;
  box-shadow: 0 0 2px 2px #d1d1d14d !important;
  caret-color: var(--ben-gray-color);
}

.message-box {
  height: 50px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  color: #292929;
}

input:focus {
  outline: none !important;
  cursor: pointer;
}

.ANL_options {
  position: relative;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
}

.dropbtn {
  color: white;
  padding: 0px 16px;
  font-size: 16px;
  border: none;
}

.navIcon {
  padding: 10px;
}

.dropdown {
  position: relative;
  display: inline-block;
  align-content: center;
  cursor: pointer;
}

.bell_styl {
  align-self: center;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  right: 35%;
  top: 85%;
  border-radius: 10px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: rgb(238, 238, 238);
  border-radius: 10px;
}

.dropdown:hover .dropdown-content {
  display: block;
  border-radius: 10px;
}

.mar-0 {
  margin-left: 0px !important;
}

.mar-270 {
  margin-left: 270px !important;
}

/* .sidenav_txt_span {
  display: none;
} */

.sidenav_logo img {
  width: 100%;
  padding: 10px;
  width: 220px;
}

.row {
  --bs-gutter-x: 0rem !important;
}

.row-no-gutter {
  --bs-gutter-x: 0rem !important;
}

.row.allow-gutter {
  --bs-gutter-x: 3rem !important;
}

.nav_first_child {
  display: contents;
}

.nav_first_child p {
  margin-top: 8px;
}

.investor_img_upload {
  font-size: 12px;
  padding: 5px !important;
}

span.blue_btn.investor_img_upload {
  min-width: 130px;
}

.navbarTop {
  background-color: white;
  height: 71px;
  top: 0;
  z-index: 1;
  position: sticky !important;
  padding: 0 !important;
  z-index: 999;
}

.form-label {
  font-weight: 700;
}

.btn_style {
  text-align: end;
  align-self: self-end;
}

.b_style_new {
  background-image: var(--blue-capsule-img);
  padding-left: 10px;
  color: white;
  margin-left: 5px;
  background-repeat: no-repeat;
  width: 80%;
  height: 56px;
  border-radius: 12px;
}

.b_inv_prof_tabs {
  background-image: var(--blue-capsule-img);
  padding-left: 10px;
  color: white;
  margin-left: 5px;
  background-repeat: no-repeat;
  width: 160px;
  height: 56px;
  border-radius: 12px;
}

.b_style_modal {
  background-image: var(--blue-capsule-img);
  padding-left: 10px;
  background-repeat: no-repeat;
  color: white;
  margin-left: 5px;
  width: 80%;
  height: 46px;
  border-radius: 12px;
}

.blue_style_new {
  background-image: var(--blue-capsule-img);
  padding-left: 10px;
  background-repeat: no-repeat;
  padding-right: 10px;
  color: white;
  margin-left: 5px;
  width: fit-content;
  border-radius: 12px;
  max-width: 210px
}

.gray_style_new {
  background-image: var(--sesame-capsule-img);
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  margin-left: 5px;
  width: fit-content;
  border-radius: 12px;
  background-repeat: no-repeat;
  max-width: 210px
}

.n_style_new {
  background-image: var(--sesame-capsule-img);
  background-repeat: no-repeat;
  padding-left: 10px;
  color: white;
  width: 80%;
  height: 56px;
  border-radius: 12px;
}

.n_inv_prof_tabs {
  background-image: var(--sesame-capsule-img);
  background-repeat: no-repeat;
  padding-left: 10px;
  color: white;
  width: 160px;
  height: 56px;
  border-radius: 12px;
}

.n_style_modal {
  background-image: var(--sesame-capsule-img);
  background-repeat: no-repeat;
  padding-left: 10px;
  color: white;
  width: 80%;
  height: 46px;
  border-radius: 12px;
}

.g_style_new {
  background-image: var(--gray-capsule-img);
  background-repeat: no-repeat;
  padding-left: 10px;
  color: white;
  width: 80%;
  height: 56px;
  border-radius: 12px;
}

.g_inv_prof_tabs {
  background-image: var(--gray-capsule-img);
  background-repeat: no-repeat;
  padding-left: 10px;
  color: white;
  width: 160px;
  height: 56px;
  border-radius: 12px;
}

.r_style_new {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  padding-left: 10px;
  color: white;
  width: 80%;
  height: 56px;
  border-radius: 12px;
}

.p_style_new {
  background-image: var(--gray-capsule-img);
  background-repeat: no-repeat;
  padding-left: 10px;
  color: white;
  width: 80%;
  height: 56px;
  border-radius: 12px;
}

.p_style_comp_pending_pills {
  font-weight: 400;
  font-size: 20px;
  line-height: 18px;
  color: #ffffff;
}

.r_style_new {
  background-color: #ed5151;
  padding-left: 10px;
  color: white;
  width: 80%;
  height: 56px;
  border-radius: 12px;
}

.p_style {
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  color: #ffffff;
}

.AllInv_top_tab {
  position: sticky;
  top: 114px;
  z-index: 2;
}

.allservicereq_tab_styl {
  border-radius: 15px !important;
  max-height: 58vh;
  overflow: auto;
}

.allservicereq_tab_styl th {
  position: sticky;
  top: 0;
  background-color: white !important;

}

.allservicereq_tab_styl td {
  background-color: white !important;
}


.compliance_top_tab {
  top: 80px;
  z-index: 2;
}

.compliance_tab_height {
  max-height: 350px;
  overflow: auto;
  border-radius: 15px;
  outline: var(--table-outline);

}

.compliance_tab_height th {
  position: sticky;
  top: 0;
  background-color: white !important;

}

.all_inv_table_head {
  position: sticky;
  top: -0.02px;
  background-color: white;
  z-index: 3;
  outline: 1px solid lightgray;
  font-size: 14px;
}

.all_inv_newinv_table th {
  position: sticky;
  top: 0;
  background-color: white !important;
  font-size: 15px;
}

.cmp_onb_bus_tab th {
  position: sticky;
  top: 0;
  background-color: white !important;
  font-size: 15px;
}

.all_inv_newinv_table_mod {
  max-height: 30vh;
  overflow: auto;
}

.no_histry_txt {
  position: absolute;
  top: 50%;
  left: 50%;
}

.allinv_inv_table {
  height: 45vh;
  overflow: auto;
  border-radius: 15px;
}

.kyc_tab {
  display: flex;
  justify-content: space-evenly;
  align-items: self-end;
}

.my_serv_custm_notes {
  max-height: 230px;
  overflow: auto;
}

.view_inv_notes {
  max-height: 150px;
}

.newloan_notes {
  max-height: 40px;
  overflow: auto;
}

.servreq_notes {
  height: 40px;
  overflow: auto;
}

.loan_type_servicereq {
  max-height: 12vh;
  overflow: auto;
}

.payemnt_details_BS_form_conrtl input::placeholder {
  font-size: 15px !important;
  font-weight: 600;
}

.historyLoader {
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
}

.settings_YOE label {
  margin-bottom: 6px !important;
}

.settings_BS_form_conrtl input::placeholder {
  font-size: 12px !important;
  font-weight: 400;
}

.investor_table_headers th {
  position: sticky !important;
  top: 0 !important;
  background-color: white !important;
}

.navbarTopAdmin {
  top: 0;
  width: 100% !important;
  background-color: rgb(245, 245, 245);
  z-index: 1000;
  padding: 0 !important;
}

.admin_body_main {
  position: sticky !important;
  top: 0 !important;
  background-color: white;
  z-index: 1;
  padding: 0px 48px;
}

.admin_serv {
  font-size: 24px;
  margin: 5px;
  cursor: pointer;
  color: var(--gray-text-color);
}

/* .mar_top {
  margin-top: 100px !important;
} */

.indiv_loan_dtls {
  cursor: pointer;
}

.indiv_loan_dtls {
  width: 15px;
  align-items: center;
  margin-bottom: 5px;
}

.hidden_eye_style {
  width: 15px;
  align-items: center;
  margin-bottom: 5px;
}

.indiv_loan_dtls_eye {
  cursor: pointer;
  width: 24px;
}

.admin-cards {
  min-height: 230px;
  cursor: pointer;
  width: 300px !important;
  background-color: rgb(255, 255, 255) !important;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  margin-top: 20px !important;
}

.text_st1 {
  font-weight: 500;
  font-size: 13px;
  color: #292929;
}

.exp_date {
  color: #7c8495;
  font-weight: 700;
  font-size: 14px;
  margin-top: 1px;
}

.up_new {
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  text-decoration-line: underline;
  cursor: pointer;
  color: var(--blue-text-color);
}

.card_paragraph {
  font-weight: 450;
  margin-top: 5px;
  font-size: 14px !important;
  text-align: center !important;
  color: #7c8495 !important;
}

.rejected_reason span {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}

.disable-link {
  pointer-events: none;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: var(--sesame-color);
  border-radius: 10px;

}

::-webkit-scrollbar-track-piece {
  background: #e4e3e3;
  border-radius: 10px;
}

.db_rp_table th {
  font-size: small;
  font-weight: 400;
  padding: 0px -10px;
  position: sticky;
  top: 0;
  background-color: #F8F6F3 !important;
}

.db_rp_table td {
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 15px;
  color: #292929;
}

.my_loan_table {
  max-height: 55vh;
  overflow: auto;
  background-color: white;
  border-radius: 15px !important;

}

.my_loan_table td {
  text-align: center;
}

.fin tbody td {
  font-weight: 500;
}

.loan_purpose_field {
  max-height: 8.5vh;
  overflow: auto;
}

.inv_my_servicereq_table {
  max-height: 58vh;
  overflow: auto;
  background-color: white;
  border-radius: 15px !important;
}

.inv_my_servicereq_table td {
  text-align: center;
}

.busns_histry_table_main {
  max-height: 75vh;
  overflow: auto;
  border-radius: 15px;
  box-shadow: inset 0px -1px 0px rgba(102, 102, 102, 0.08);
}

.busns_histry_table td {
  background-color: white !important;
  padding-left: 25px !important;

}

.busns_histry_table th {
  position: sticky;
  top: 0;
  background-color: white !important;
  padding-left: 25px !important;

}

.cmp_onb_bus_tab {
  border-radius: 15px;
  outline: var(--table-outline);
}

.all_inv_newinv_table {
  max-height: 58vh !important;
  overflow: auto;
  border-radius: 15px;
  outline: var(--table-outline);

}

.adminall_inv_newinv_table {
  height: 58vh !important;
  overflow: auto;
  border-radius: 15px;
}
/* Cells line up under the centred headers (a global \`td { text-align: left }\` pulled them left, QA #29). */
.adminall_inv_newinv_table td {
  text-align: center;
}

.invfullproftable {
  height: 40vh !important;
  overflow: auto;
  border-radius: 15px;
  outline: var(--table-outline);

  width: 80%;
}

.invfulprflabout {
  max-height: 40vh;
  overflow: auto;
}

.aboutInvfulprfl {
  height: 55px;
  min-width: 50rem;
}

.document_tab_modal {
  max-height: 250px;
  overflow: auto;
}

.bus_doc_modal_tabl {
  max-height: 250px;
  overflow: auto;
}

.doc_repo_inv_table {
  max-height: 47vh;
  overflow: auto;
  border-radius: 15px;
}

.doc_repo_inv_table th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.admin_all_busns_tabl {
  height: 58vh;
  overflow: auto;
  border-radius: 15px;
  outline: var(--table-outline);

}

.admin_all_busns_tabl th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.admin_each_ln_pop {
  height: 45px;
}

.busns_each_ln_pop {
  height: 35px;
}

.my_loan_table th {
  text-align: center;
  vertical-align: middle;
  position: relative;
}

.inv_kyc_table {
  max-height: 65vh;
  overflow: auto;
  border-radius: 15px !important;
}

.inv_kyc_table th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.inv_profile_kyc_table {
  max-height: 50vh;
  overflow: auto;
  border-radius: 15px !important;
}

.inv_profile_kyc_tablepop {
  max-height: 40vh;
  overflow: auto;
  border-radius: 15px !important;
}

.inv_profile_kyc_table th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.inv_profile_kyc_tablepop th {
  position: sticky;
  top: 0;
  background-color: white !important;
}


@media screen and (min-width: 1860px) {
  .table-responsive {
    max-height: 68vh;
  }

  .inv_opp_table {
    max-height: 25vh !important;
  }

  .emailmaindiv {
    gap: 80px;
    margin-top: 3rem;
  }

  .password_msg {
    right: 15% !important;
    top: 34% !important;
  }

  .notif_main_div {
    max-height: 80vh;
  }

  .line_height_settings {
    max-height: 75vh !important;
    overflow: auto;
  }

  .singl_inv_tabl {
    max-height: 60vh !important;
  }

  .inv_my_servicereq_table {
    max-height: 70vh !important;
  }

  .mytrx_myrecpts {
    max-height: 75vh;
  }

  .allservicereq_tab_styl {
    max-height: 68vh !important;
  }

  .compliance_tab_height {
    max-height: 68vh;
  }

  .typ_of_feclty_labels {
    max-height: 20vh !important;
  }

  .percent_first {
    height: 5vh !important;
  }

  .bus_dashboard_width {
    max-height: 35vh;
    min-height: 31vh;
  }


  .myinvestmts_table_div {
    max-height: 75vh !important;
  }

  .my_loan_table {
    max-height: 63vh;
  }

  .eachloan_table {
    max-height: 50vh;
  }

  .myservice_table_div {
    max-height: 74vh !important;
  }

  .doc_repo_inv_table {
    max-height: 65vh;
  }

  .perticlr_bus_table {
    max-height: 70vh !important;
  }

  .all_inv_newinv_table {
    max-height: 69vh !important
  }

  .adminall_inv_newinv_table {
    height: 69vh !important;
  }

  .admin_all_busns_tabl {
    height: 70vh !important;
  }

  .allinv_inv_table {
    height: 65vh !important;
  }

  .bar_chart_inv_db canvas {
    width: 680px !important;
    height: 250px !important;
  }

  .inv_db_currency {
    height: 15px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    color: #7C8495;


  }

  .inv_db_tinv {
    width: 100px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    margin-left: 53px;

    color: #7C8495;

  }

  .inv_db_currency {
    height: 15px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    color: #7C8495;
    padding-left: 60px;


  }

  .inv_db_currency ol {
    /* padding-left: 30px!important; */
    justify-content: space-between;
  }


  .inv_db_currency ol {
    padding-left: 15px !important;
    padding-right: 9px !important;
  }

  .confirm_inv_btn {
    left: 0;
    right: 0;
    text-align: center;
    margin: 15px !important;
  }

  .bar_chart_inv_db {
    height: 250px !important;
  }

  .InvOpp_right_tab {
    max-height: 730px !important;
  }

  .blue_tab {
    padding: 18px;
  }

  .sesame_tab {
    padding: 18px;
  }
}

@media screen and (max-width: 920px) {
  /* * {
    opacity: 60%;
  } */

  .inv_opp_table {
    max-height: 38vh !important;
  }

  .blue_btn {
    padding: var(--btn-sm-padding);
    width: 160px;
    line-height: 8px;
    font-size: 12px;
    font-weight: 400;
  }

  .gray_btn {
    padding: var(--btn-sm-padding);
    line-height: var(--btn-sm-lh);
    font-size: 12px;
    font-weight: 700;
  }

  .login_main_img {
    object-fit: cover;
    max-width: 100%;
    height: 100%;
  }

  .login_main {
    background: none;
    max-width: 100%;
    height: auto;
  }

  .login_input_space {
    min-width: 100%;
  }

  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 20px;
  }

  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 20px;
  }

  .login_txt {
    display: flex;
    z-index: 10;
    transform: rotate(90deg);
    height: 200px;
    margin: auto;
    left: 50%;
  }

  .sidenavbar_cls {
    display: none;
  }

  .dropdown-content {
    right: -100%;
  }

  .admin_body_main {
    position: sticky !important;
    top: 0 !important;
    background-color: white;
    z-index: 1;
    padding: 0px 14px 0px 14px;
  }

  .sidenavbar {
    display: none !important;
  }
}

.Financials_tab .table-responsive {
  max-height: 450px !important;
  overflow-y: auto !important;

}

.h6_style {
  font-weight: 400;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}

.modal-footer {
  padding: 5px 10px !important;
}

.forgot_pwd {
  color: var(--ben-gray-color) !important;
  float: end !important;
  cursor: pointer;
}

select,
input {
  border: none !important;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05) !important;
  border-radius: 5px !important;
  border: 1px solid #f8f8f8 !important;
}

.percent_symbol {
  padding: 0px 10px !important;
  background-color: white !important;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #f8f8f8 !important;

}

.paymnt_details_amt {
  padding: 0px 10px !important;
  background-color: white !important;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #f8f8f8 !important;
}

.kycFiledstyle {
  border: 1px solid lightgray;
  padding: 8px;
  border-radius: 5px;
  background-color: #f0efef;
}

.kyc_upload_cls {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.kyc_upload_cls tr {
  display: flex;
  justify-content: space-between;
}

.upload_cls input {
  box-shadow: none !important;
}

.gray-text {
  color: var(--gray-text-color);
}

.sesame-color {
  color: var(--sesame-color);
}

.bg-sesame {
  background-color: var(--sesame-color) !important;
}

.forgot_pwd_main {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
  margin: auto;
}

.reset_third_modal .forgot_pwd_main {
  padding: 0px 15px !important;

}

.forgot_pwd_main h5 {
  text-align: center;
  height: 24px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: #292929;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: auto;
}

.forgot_pwd_main p {
  height: 12px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: -0.02em;
  color: #7C8495;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.forgot_pwd_main .input_email {
  border: 0.5px solid #BABABA !important;
  border-radius: 6px;
}

.forgot_pwd_main .reset_btn {
  width: 230px;
  height: 30px;
  background: var(--blue-text-color);
  border: 0.5px solid var(--blue-text-color);
  border-radius: 6px;
  flex: none;
  order: 1;
  flex-grow: 0;
  color: white;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
}

.forgot_pwd_main .reset_btn:disabled {
  opacity: 50%;

}

.new_password_crossmark {
  position: absolute;
  right: 4%;
  top: 4%;
  cursor: pointer;
}

.forgot_pwd_main .reset_txt {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #FFFFFF;

}

.newpwd_min_height {
  height: 33vh !important;
}

.compl_bus_actions_td {
  min-width: 130px;
  display: flex;
  justify-content: center;
}

.compl_bus_actions_td_business_kyc {
  min-width: 130px;
  display: flex;
  justify-content: flex-end;
}

.hide_pwd_icon {
  position: absolute;
  right: 8%;
  bottom: 58%;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.passwd_criteria {
  color: red;
  font-size: 15px;
  font-weight: 500;
}

.passwd_crit_reset {
  color: red;
  font-size: 11px;
}

.newpswd_btn_styl {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  bottom: 0;
  width: 100%;
  margin-top: 20px;
}

.opt_field_boxes {
  justify-content: space-evenly;
  margin: 25px 15px 8px 15px;
}

.opt_field_boxes input {
  width: 30px;
  height: 30px;
  border: 0.5px solid #BABABA !important;
  border-radius: 6px;
  flex: none;
  order: 1;
  flex-grow: 0;
  text-align: center;
}

.resend_main {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  gap: 11px;
  align-items: center;
  margin-bottom: 20px
}

.resend_otp_txt {
  display: flex;
  justify-content: center;
  gap: 3px;
  text-align: center;
  margin-bottom: 30px;

  height: 12px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: -0.02em;
  color: #7C8495;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.resend_style {
  color: #ED5151;
  font-weight: 600;
  font-size: 11px;
  cursor: pointer;
  border: none;
  outline: none;
  background-color: transparent;

}

.resend_style:hover {
  text-decoration: underline #ED5151;
}

.resend_style:disabled:hover {
  text-decoration: none;
  cursor: default;
}

.sesam_color_backto {
  display: flex;
  justify-content: center;
  gap: 5px;
  height: 12px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.02em;
  color: var(--sesame-color);
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: 25px;
  cursor: pointer;

}

.ml_lrn {
  color: var(--gray-text-color);
  font-weight: 600;
  font-size: 24px;
}

.Cpointer {
  cursor: pointer;
}

.buttons-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 20px;
}

.button-wrapper {
  margin: 5px;
  width: max-content;
}

.table-responsive {
  max-height: 58vh;
  overflow: auto;
}

.sidebarprohead a {
  text-decoration: none !important;
  color: white !important;
}

.sidebarimg {
  padding: 20px 0px 20px 20px;
  cursor: pointer;
}

.brand_logo_styl {
  height: 70px;
  padding: 10px 0px 10px 27px;
  margin: auto;
  transition: cubic-bezier(0.075, 0.82, 0.165, 1);
  cursor: pointer;
}

.ps-menu-icon {
  width: 20px;
  font-size: larger;
}

.css-kvqf1i {
  background-color: var(--ben-text-sesame-color) !important;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  margin-right: 20px;
}

.sidebar_li_styl>.ps-active {
  background-color: var(--ben-text-sesame-color) !important;
  border-bottom-right-radius: 10px !important;
  border-top-right-radius: 10px !important;
  margin-right: 20px !important;
}

.ps-menu-button:hover {
  background-color: transparent !important;
}

.sidebar_li_styl>.ps-active:hover {
  background-color: var(--ben-text-sesame-color) !important;
  border-bottom-right-radius: 10px !important;
  border-top-right-radius: 10px !important;
  margin-right: 20px !important;
}

.db_body {
  max-height: 88vh;
  overflow-y: auto;
  /* max-width: 1670px; */
}

.content_main_body {
  padding: 20px 35px;
}

.bus_dashboard_width {
  max-width: 1400px;
  min-height: 43vh;
}

.totl_repaid_div .totl_repaid {
  color: #7C8495;
  font-weight: 700;
  font-size: 11px;
  line-height: 8px;
}

.card_footer_color .TOA {
  font-weight: 600;
  font-size: 11px;
  line-height: 21px;
  color: var(--blue-text-color);
}

.totl_repaid_div b {
  color: var(--ben-text-sesame-color);
  font-weight: 400;
  font-size: 11px;
  line-height: 16px
}

.totl_outstng {
  font-weight: 700;
  font-size: 11.5px;
  color: var(--blue-text-color);
  text-align: center;
}

.db_first_card_footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.db_hr_polygon_div img {
  position: absolute;
  left: 50%;
  margin-top: -2px;
}

.datepickermom_report input {
  height: 30px;
}

.momreport_details_popup span {
  font-weight: 700;
  font-size: 14px;
  padding-left: 0px !important;
}

.admin_eachloan_modal_main {
  height: 35rem !important;
}

.eachloan_table {
  max-height: 30vh;
  overflow-y: auto;
  border-radius: 15px !important;
  outline: var(--table-outline);
}

.gray_border {
  height: 1px;
  border: 1px solid var(--ben-text-sesame-color);
}

.card_footer_color {
  background-color: #f8f6f3 !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.db_hr_styl {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.typ_of_feclty_labels {
  max-height: 23.5vh;
  overflow: auto;
  align-self: center;
}

.kyc_confirmation {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-left: 10px;
}

.db_cos_card_main h6 {
  color: var(--blue-text-color);
}

.Admin_eachL_popup {
  background-color: #F8F6F3;
  padding-left: 3rem !important;
  padding-right: 3rem !important;

}

.invSubtextareafont .form-control {
  font-size: 16px !important;
}

.card_title_txt article {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #292929;
}

.doughnut_div canvas {
  padding-bottom: 10px;
}

.secondrowcard_height {
  height: 250px !important;
}

.bus_db_secondrowcard_height {
  height: 260px !important;
}

.dash_b_RRP_table_div {
  max-height: 29vh;
  overflow: auto;
}

.no_doc_styl {
  margin-left: -50px;
}

.bd_viewall {
  cursor: pointer;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}

.doughnut_card {
  max-width: 450px !important;

}

.inv_db_Card_Size {
  max-width: max-content;
}

.inv_db_Card_Size article {
  width: 83px;
  height: 24px;
  left: 337px;
  top: 624px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 20.0853px;
  line-height: 24px;
  color: #292929;

}

.secondrowcard_height article {
  height: 24px;
  left: 862.96px;
  top: 624.96px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 20.0853px;
  line-height: 24px;
  color: #292929;
}

.dropdn_select_cls {
  display: block !important;
  padding-left: 12px !important;
  padding-right: 31px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.settings_YOE .dropdn_select_cls_settings {
  height: 40px;
  border: 1px solid #e5e3e3 !important;
}

.dropdn_select_cls_settings {
  display: block !important;
  padding-left: 12px !important;
  padding-right: 31px !important;
  padding-top: 2px !important;
  padding-bottom: 4px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.modal-header {
  padding: 10px 15px !important;
}

.modal-body {
  padding: 0px 10px !important;
}

.modal-footer {
  padding: 2px 5px !important;
}

hr {
  margin: 10px 0px !important;

}

.form-control {
  padding: 3px 5px !important;


}

.field-control {
  padding: 7px 5px !important;
  width: 95% !important;
  border: 2px solid hsl(220, 13%, 91%);
  border-radius: 6px;
  outline: none;
}

.field-control-name {
  padding: 7px 5px !important;
  width: 98% !important;
  border: 2px solid #e5e7eb;
  border-radius: 6px;
  outline: none;
}

.prefooter {
  margin-bottom: 5px !important;
}

.skeleton_mrgn {
  margin: 10px;
}


.notif_main {
  display: flex !important;
  justify-content: flex-end !important;
  margin-bottom: 15px !important;
  padding-right: 24px;

}

.notifCount {
  background-color: var(--blue-text-color);
  position: absolute;
  border-radius: 50px;
  min-width: 17px;
  min-height: 17px;
  color: white;
  text-align: center;
  align-content: center;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  right: -5px;
  padding: 1px;
  top: -5px;

}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  isolation: initial !important;
}

.belldotblue {
  background-color: var(--blue-text-color);
  position: absolute;
  border-radius: 50px;
  width: 10px;
  height: 10px;
  top: 30%;
  right: 100%;

}

.toast_main_div {
  z-index: 100 !important;
}

.toast_viewdetails {
  width: 71px;
  height: 12px;
  cursor: pointer;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  letter-spacing: -0.02em;
  color: var(--blue-text-color);

}

.toast_viewdetails:hover {
  text-decoration: underline var(--blue-text-color);

}

.offcanvas-header {
  padding-bottom: 0px !important;
}

.toast_dismiss {
  width: 45px;
  height: 12px;
  cursor: pointer;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  letter-spacing: -0.02em;
  color: rgba(207, 24, 24, 0.808);

}

.notifpanestyl .notif_time {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  padding-left: 15px;
}

.notifpanestyl .notif_txt {
  padding: 10px;
  margin-right: 10px;
  align-self: center;
}

.notif_main_active_home {
  background: var(--ben-text-sesame-color) ! important;
  border: 1px solid var(--ben-text-sesame-color) ! important;
  border-radius: 6px 0px 0px 6px ! important;
  color: white ! important;
  cursor: pointer;
  width: 78px;
  text-align: center;
}

.notif_main_active_profile {
  background: var(--ben-text-sesame-color) ! important;
  border: 1px solid var(--ben-text-sesame-color) ! important;
  border-radius: 0px 6px 6px 0px ! important;
  color: white ! important;
  cursor: pointer;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .notif_main_active_home {
  color: white ! important;
  font-size: 12px;
  font-weight: 700;
  line-height: 13px;

}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .notif_main_active_profile {
  color: white ! important;
  font-size: 12px;
  font-weight: 700;
  line-height: 13px;
}

.notifpanestyl {
  background: #FFFFFF;
  border-radius: 6px;
  min-height: 74px;
  display: flex !important;
  margin-bottom: 20px !important;
}

.notif_date {
  left: 2.03%;
  right: 86.15%;
  top: 29.73%;
  bottom: 50%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 15px;
  color: #292929;
}

.notif_time p {
  left: 2.03%;
  right: 93.07%;
  top: 54.05%;
  bottom: 29.73%;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  color: #7C8495;

}

.nodataStyl {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px !important;
  font-weight: 700 !important;

}

.notif_main_div {
  max-height: 72vh;
  overflow: auto;
}

.notifinactivestyle_home {
  background: white ! important;
  border: 1px solid white ! important;
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
  color: #7C8495 ! important;
  cursor: pointer;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 13px !important;
  width: 78px;
  text-align: center;

}

.notifinactivestyle_profile {
  background: white ! important;
  border: 1px solid white ! important;
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
  color: #7C8495 ! important;
  cursor: pointer;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 13px !important;
}

.box {
  display: flex;
  height: 150px;
  width: 50px;
  border: 1px solid black;

}

.Indiv_notif_styl {
  border: 1px solid #ececec;
  padding: 10px;
  margin-bottom: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
}

.notif_msg_heigt {
  line-height: 20px;
}

.notification_menu {
  min-width: 500px !important;
  max-height: 85vh;
  overflow: auto;
  padding: 15px;
}

.admin_notif_sidebar {
  max-height: 95vh;
  top: 0.5% !important;
  overflow: auto;
  border-radius: 5px;
  right: 0.5% !important;
  width: 445px !important;
}

.inv_notif {
  height: max-content;
  top: 1% !important;
  right: 1% !important;
  border: 1px solid rgb(124, 122, 122);
}

.slide-in {
  background-color: var(--ben-gray-color);
  color: white;
  width: 200px;
  margin-left: -480px;
  transition-property: margin-left;
  transition-duration: 500ms;
  z-index: 10;
}


.expirydangerstyl {
  color: #ED5151;
  font-weight: 700;

}

.onClickApplyLoaderStyl {
  position: absolute;
  left: 0;
  right: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.048);
}

.loader_style {
  position: absolute;
  left: 0;
  right: 0;
  top: 57%;
  justify-content: center;
  display: flex;
  align-items: center;
  color: var(--blue-text-color);
}

.titleplusedit {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.titleplusedit h1 {
  margin-bottom: 0px !important;
  align-self: end;
}

.profileBusDetailstab {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px !important;
  min-height: 50vh !important;

}

.settingsmaindiv {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 12px 18px;
  margin-top: 16px !important;
}

.image_uploadbtndiv {
  position: relative;
  width: 100%;
  max-width: 400px;
  display: flex;
  justify-content: center;
}

.image_uploadbtndiv .blue_btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.image_uploadbtndiv .blue_btn img {
  width: 18px !important;
  height: 18px !important;
  margin-right: 5px;
  width: 100%;
  height: auto;

}

.inv_image_uploadbtndiv .blue_btn {
  position: absolute;
}

.inv_image_uploadbtndiv .blue_btn img {
  width: 18px !important;
  height: 18px !important;
  width: 100%;

}

.inv_image_uploadbtndiv label {
  margin-bottom: 25px;

}

.inv_image_uploadbtndiv {
  padding-left: 0px !important;
}

.inv_image_uploadbtndiv img {
  margin-right: 5px;
  width: 180px;
  height: 160px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;

}

.profile_maindiv2 .col img {
  width: 547px;
  height: 155px;
  border-radius: 5px;
}

.profMainDiv {
  max-height: 85vh;
  overflow: auto;
}

.expiredtxt {
  color: #ED5151;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
}

.bus_summary {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #7C8495;

}

.bus_summary b {
  color: black;
}

.bus_summary p {
  max-height: 12vh;
  overflow: auto;
}





.text_styles {
  text-align: center;
  width: 180px;
  height: 19px;
  color: var(--ben-text-sesame-color);
  font-size: 18px;
  font-weight: 700;

}

.text_st {
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: #7c8495;
}

.text_ststrong {
  font-weight: 700;
  font-size: 14px;
  line-height: 15px;
  color: #7c8495;
}

.gray_btn_lg {
  align-items: center;
  padding: 8px 24px;
  width: 426px;
  height: 54px;
  background: var(--ben-text-sesame-color);
  border-radius: 6px;
  flex: none;
  order: 1;
  flex-grow: 0;
  border: none;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #FFFFFF;
}

.gray_btn_lg:disabled {
  opacity: 60%;
}

.text_st_status {
  line-height: 15px;
  color: #7c8495;
  font-weight: 700;
  font-size: 16px;
}

.text_st_new {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  /* Titles */
  color: #292929;
}

.text_bolder {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: var(--blue-text-color);
}

.text_bolder_sr {
  font-weight: 700;
  font-size: 15px;
  line-height: 17px;
  color: var(--blue-text-color);
  cursor: pointer;
}

.text_bolder_business {
  font-weight: 700;
  font-size: 15px;
  line-height: 17px;
  color: #178f17;
  cursor: pointer;
}

.text_bolder_business_v1 {
  font-weight: 700;
  font-size: 15px;
  line-height: 17px;
  color: #059669;
}

.text_bolder_investor {
  font-size: 14px;
  line-height: 17px;
  text-decoration-line: underline;
  color: var(--blue-text-color);
  cursor: pointer;
}

.text_bolde_doc {
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: var(--blue-text-color);
  justify-content: right;

}

.doc_tab_height {
  max-height: 100px !important;
  overflow: auto;
}

.admineachloan_table {
  max-height: 50px;
  overflow: auto;
}

.admin_eachloanNotes {
  max-height: 200px;
  overflow: auto;
}

.loan_purps_notes {
  max-height: 80px;
  overflow-y: auto;
}

.d_view_table {
  max-height: 250px;
  overflow-y: auto;
  border-radius: 15px !important;
  outline: var(--table-outline);
}

.allinv_doc_tab_styl {
  border-radius: 15px;
  outline: var(--table-outline) !important;
}

.allinv_rightmrk_paydetails th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.allinv_rightmrk_paydetails {
  border-radius: 15px !important;
  max-height: 35vh;
  overflow: auto;
  outline: var(--table-outline);
}

.allinv_rightmrk_paydetails td {
  background-color: white;
}

.detld_view_LH {
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;
}

.bolder_text {
  font-weight: 700;
  font-size: 14px;
  color: #292929;
}

.bolder_text_textarea {
  font-weight: 700 !important;
  font-size: 14px !important;
  color: #292929 !important;
}

.bolder_textstrong {
  font-weight: 700;
  font-size: 16px;
  color: #292929;
}

.payment_details_text {
  margin-bottom: 10px;

}

.heading_new_loan {
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #292929;
}

.benne_style {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 0 !important;
  color: #292929;
}

.bolder_text_p_fees {
  font-weight: 700;
  font-size: 16px;
  color: #292929;
}

.radio_btn {
  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
}

.style_mb {
  font-weight: 700;
  font-size: 14px;
  color: #292929;
}

.style_input {
  height: 20px;
  width: 20px;
  vertical-align: middle;

  background: #e6ebf8;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
}

.style_input_radio {
  height: 16px;
  width: 16px;
  vertical-align: middle;
  background: #e6ebf8;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
}

.PD_input_radio {
  height: 16px;
  width: 16px;
  vertical-align: middle;
  background: #E6EBF8;
  accent-color: var(--blue-text-color);
}

.admin_PD_radio_div label {
  cursor: pointer;

}

.admin_PD_tabs h5 {
  font-weight: 400 !important;
  font-size: 18px !important;
  line-height: 24px !important;

}

.no_opp {
  text-align: center;
  position: absolute;

  top: 50%;
  left: 45%;
  color: #7c8495;
  bottom: 50%;
}

.no_opp h1 {
  font-weight: 700 !important;

}

.admin_PD_tabs {
  height: 24px;
}

.rating_txt_d {
  background: var(--ben-grade-d);
  color: var(--ben-navy);
  width: 47px;
  height: 46px;
  border-radius: 6px;
}

.rating_txt_a {
  background: var(--ben-grade-a);
  color: white;
  width: 47px;
  height: 46px;
  border-radius: 6px;
}

.ten_text {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #7c8495;
}

.reason_text {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: var(--ben-text-sesame-color);
}

.business_text {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: var(--ben-text-sesame-color);
}

.rating_txt_b {
  background: var(--ben-grade-b);
  color: white;
  width: 47px;
  height: 46px;
  border-radius: 6px;
}

.rating_txt_c {
  background: var(--ben-grade-c);
  color: var(--ben-navy);
  width: 47px;
  height: 46px;
  border-radius: 6px;
}

/* Light grade backgrounds (C sesame, D grey) need navy text for contrast; .bb forces white. */
.rating_txt_c .bb,
.rating_txt_d .bb {
  color: var(--ben-navy);
}

.bb {
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  color: #ffffff;
  padding: 7px 5px;
  text-align: center !important;
}

.text_st_ranking {
  font-weight: 600;
  font-size: 14px;
  color: #7c8495;
  line-height: 15px;
}

.pointer {
  cursor: pointer;
}

.kyc_style_doc {
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
}

.admin_rej_modal {
  min-height: 10vh;
  vertical-align: middle;
  margin: auto;
  padding: 15px 0px !important;
}

.css-16jkw2k>.ps-menu-button:hover {
  background-color: transparent !important;
}

.css-eh8qic>.ps-menu-button {
  background-color: var(--ben-text-sesame-color);
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  margin-right: 20px;
}

.css-eh8qic>.ps-menu-button:hover {
  background-color: var(--ben-text-sesame-color) !important;
}

.business_name {
  font-size: 1em;
  color: var(--blue-text-color);
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
}



.css-eh8qic>.ps-menu-button:hover {
  background-color: var(--ben-text-sesame-color);
}

.myloan_table_headers {
  vertical-align: middle;
  position: sticky;
  top: 0;
  background-color: white;
  outline: var(--table-outline);
  font-size: 14px;
}

.table>thead {
  vertical-align: middle !important;
}

.green-title {
  color: #059669;
}

.head_threedots h5 {
  text-align: end;
  margin-right: 3.5rem;
  font-weight: 700;
  font-size: 8px;

}

.myservicereq_table {
  max-height: 100px;

}

.head_onedot h5 {
  text-align: start;
  margin-left: -0.5rem;
  font-weight: 700;
  font-size: 8px;
}

.head_fourdots h5 {
  text-align: end;
  margin-right: -2rem;
  font-weight: 700;
  font-size: 8px;

}

.btn-close:focus {
  box-shadow: none !important;
}

.uploadKYCDocBsnsDB {
  margin-bottom: 0px;
  font-weight: bolder;
  padding-right: 0px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: var(--blue-text-color);

}

.uploadKYCDocBsnsDB:hover {
  text-decoration: underline;
}

.rate_percent {
  padding: 10px;
  background-color: white;
}


.myinvestmts_table_div {
  border-radius: 15px !important;
  outline: var(--table-outline);
  max-height: 65vh;
  overflow: auto;
}

.mytrx_myrecpts {
  border-radius: 15px !important;
  outline: var(--table-outline);
  max-height: 70vh;
  overflow: auto;

}

.mytrx_myrecpts th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.mytrx_myrecpts td {
  background-color: white !important;
}

.mypaymentdetails {
  border-radius: 15px !important;
  outline: var(--table-outline);
  max-height: 40vh;
  overflow: auto;
}

.mypaymentdetails th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.mypaymentdetails td {
  background-color: white !important;
}

.inwithbusdetlastcard {
  height: 60vh;
}

.invFullprofInvid h4 {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  color: var(--blue-text-color);

}

.mytrx_mypaymnts {
  border-radius: 15px !important;
  outline: var(--table-outline);
  max-height: 70vh;
  overflow: auto;
}

.mytrx_mypaymnts th {
  position: sticky;
  top: 0;
  background-color: white !important;

}

.mytrx_mypaymnts td {
  background-color: white !important;

}

.bus_kyc_table {
  border-radius: 15px !important;
  outline: var(--table-outline);
  max-height: 72vh;
  overflow: auto;
}

.bus_kyc_table th {
  position: sticky;
  top: 0;
  background-color: white !important;

}

.table_cls {
  border-top: 1px solid lightgray;

}

.popUpImagemodal {
  max-width: 100vw;
  padding-bottom: 2rem;
}

.imagemodalbody {
  height: 86vh;
  align-self: center;

}

.password_msg {
  font-size: 14px;
  color: rgb(87, 86, 86);
  position: absolute;
  right: 5%;
  top: 37%;
  font-weight: 500;
}

.reset_password_const {
  font-size: 12px;
  color: rgb(87, 86, 86);
  margin-top: 10px;
}

.bootStrp_form_conrtl input {
  padding: 2px 10px !important;
  width: -webkit-fill-available;
  border: none !important;
  box-shadow: -5px 2px 10px 0px #0000000D;
  border-radius: 6px 0px 0px 6px !important;
  border: 1px solid #f8f8f8 !important;
  max-width: 130px !important;
}

.payemnt_details_BS_form_conrtl {
  height: 35px;
  width: 180px !important;
}

.payemnt_details_BS_fo_custm {
  height: 35px;
  width: 235px !important;
}

.pymnt_dtls_amt_edit_field input {
  width: 100px !important;
  height: 25px;
}

.custm_brdr input {
  border: 1px solid rgb(241, 241, 241) !important;

}

.bootStrp_form_conrtl_APNL input {
  padding: 2px 10px !important;
  width: -webkit-fill-available;
  border: none !important;
  box-shadow: -5px 2px 10px 0px #0000000D;
  border-radius: 6px 0px 0px 6px !important;
  border: 1px solid #f8f8f8 !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.rating_button {
  width: 50px !important;
  height: 50px !important;
  color: white;
  border-radius: 5px;
  padding: 8px;
  text-align: center !important;
  font-size: 24px;
  font-weight: 400;
  line-height: 29px;
}

.db_sesame_table_title {
  background-color: #F8F6F3;
  font-style: normal !important;
  font-size: 12px !important;
  line-height: 15px !important;
  align-items: center !important;
  color: #292929 !important;
  font-weight: 400;
}

.ml_indiv_loan_dtls {
  background-color: #F8F6F3;
  border-radius: 8px 8px 0px 0px;
  padding: 5px 24px;
}

.ml_indiv_loan_dtls label {
  font-weight: 700;
  font-size: 14px;
  color: #7C8495;
  flex: none;
  order: 0;
  flex-grow: 0;
  text-align: center;
  line-height: 14px;
}

.ml_table_footer {
  border-radius: 0px 0px 8px 8px;
  padding: 13px 21px;
}

.del_bin_style {
  color: rgba(238, 38, 38, 0.651);
  cursor: pointer;
  font-size: 20px;
  margin: 5px 0px 0px 10px
}

.count_of_records {
  margin: auto;
  text-align-last: right;
  padding: 25px 10px 0px 0px;
  color: var(--ptag-font-color);

}

.count_of_records span {
  font-weight: var(--ptag-font-weight);
  margin-bottom: 0px !important;
  line-height: 14.5px;
  font-size: 18px;
}

.modal_title h6 {
  margin-bottom: 0 !important;
}

.count_of_records_ML {
  color: var(--ptag-font-color);
  text-align: end;
  margin-top: 10px;
}

.count_of_records_ML span {
  font-weight: var(--ptag-font-weight);
  margin-bottom: 0px !important;
  line-height: 14.5px;
  font-size: 18px;
  margin-right: 15px;
}

@media screen and (min-width:800px) {
  .inv_opp_table {
    max-height: 38vh;
  }
}

.kyc_man_doc_tab {
  max-height: 65vh;
  overflow: auto;
}

.alert_modal {
  padding-left: 15px !important;
  min-height: 6vh;
  display: flex;
  align-items: center;

}

.text_style_inv {
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.02em;
  color: #292929;
}

.count_of_records_ALLSR {
  color: var(--ptag-font-color);
  margin-bottom: 10px;
}

.count_of_records_ALLSR span {
  font-weight: var(--ptag-font-weight);
  margin-bottom: 0px !important;
  line-height: 14.5px;
  font-size: 18px;
}

.count_of_records_ML span {
  font-weight: var(--ptag-font-weight);
  margin-bottom: 0px !important;
  line-height: 14.5px;
  font-size: 18px;
  margin-right: 15px;
}

.style_loan {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #292929;
}

.style_loan_txt {
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  align-items: center;
  color: #7C8495;
}

.lh_custom_style {
  max-height: 10vh;
}

.blue_tab {
  align-items: center;
  padding: 10px;
  background: #E6EBF8;
  border-radius: 8px;
  width: 145px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.blue_tab p {
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--blue-text-color);
  justify-content: center;
  font-size: 15px;
}

.sesame_tab {
  flex-direction: row;
  align-items: center;
  text-align: center;
  padding: 10px;
  gap: 10px;
  background: #F8F6F3;
  border-radius: 8px;
  width: 145px;
}

.sesame_tab p {
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--ben-text-sesame-color);
  justify-content: center;
  font-size: 14px;
}

.blue-text {
  color: var(--blue-text-color) !important;
}

.comp_pending_expiry {
  font-weight: 700;
  font-size: 12px;
  display: flex;
  gap: 5px;
  color: #292929;
  line-height: 14px;
  margin-top: 5px;
}

.comp_pending_today_expiry_txt {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  align-items: center;
  color: #ED5151;
  display: flex;
  gap: 8px;
}

.bd_COS_div {
  height: 10vh;
  overflow: auto;
}

.db_cos_curncy {
  color: var(--blue-text-color);
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
}

.upload_file_name {
  color: green;
  display: flex;
  align-self: center;
}

.Q_call_report_table_div {
  margin-top: 10px;
  max-height: 29vh !important;
  overflow: auto;
}

.allinve_action_td {
  min-width: 65px;
}

.momreport_filledupview_doc_styl {
  max-width: 56vw;
  margin-bottom: 1rem;
}

.Q_call_report_headers {
  position: sticky;
  top: -1px;
  background-color: white;
  font-size: 14px;
  font-weight: 700;
}

.loan_history_tab {
  max-height: 35vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.loaan_history_content_styl {
  max-height: 145px;
}

.admin_each_history {
  max-height: 210px;
  overflow-y: auto;
  overflow-x: hidden;
}

.admin_all_preclosure_body {
  height: 29.5rem;

}

.preclosure_Table_body {
  border: var(--table-outline);
  border-radius: 15px;
}

.preclosure_Table_body {
  max-height: 200px;
  overflow-y: auto;
}

.card_styl {
  max-width: 22rem;

  min-height: 23.5rem;
}

.btn_background {
  padding: 12px 32px;
  width: 98px;
  height: 39px;
  background: #F2F3F3 !important;
}

.pdfLogo {
  width: 130px;
  margin: 10px 0px 10px -10px;
}

.btn_background_sm {
  width: 98px;
  height: 35px;
  background: #F2F3F3 !important;
}


.card_styl img {
  max-height: 9rem;
  position: relative;
}

.card_styl h4 {
  position: absolute;
  z-index: 2;
  padding: 7px 15px;

}

.card_checked {
  position: absolute;
  z-index: 3;
  right: 15px;
  top: 15px;
  color: yellow;
  font-size: 17px;
}

.rate_A {
  background-color: var(--ben-grade-a);
  color: white;
  border-radius: 6px;
  margin: 10px;
}

.rate_B {
  background-color: var(--ben-grade-b);
  color: white;
  border-radius: 6px;
  margin: 10px;

}

.rate_C {
  background: var(--ben-grade-c);
  color: var(--ben-navy);
  border-radius: 6px;
  margin: 10px;
  align-items: center;
}

.rate_D {
  background-color: var(--ben-grade-d);
  color: var(--ben-navy);
  border-radius: 6px;
  margin: 10px;
}

.inv_card_title_cls {
  display: flex;
  justify-content: space-between;
}

.inv_card_title_cls img {
  height: 15px;
  width: 15px;
  cursor: pointer;
}

.InvOpp_right_tab_card {
  color: white;
  text-align: center;
  padding: 20px 0px;
  border-top-right-radius: 12px !important;
  border-top-left-radius: 12px !important;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
}

.InvOpp_right_tab {
  min-height: 450px;
  max-height: 700px;
  border-radius: 6px;
  position: relative;
  background-color: white;


}

.inv_opp_card_title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: white;
}

.indiv_right_top_bnr {
  position: relative;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
}

.indiv_right_top_bnr img {
  width: 100%;
  border-top-right-radius: 11px;
  border-top-left-radius: 11px;
}

.inv_card_txt {
  max-height: 3.5rem;
  min-height: 3.5rem;
  overflow-y: auto;
}


.indiv_bus_tilte {
  display: flex;
  gap: 20px;
  margin: 25px 20px;
  align-items: center;
  align-content: center;
  cursor: pointer;
}

.indiv_bus_tilte h1 {
  margin-bottom: 0px;
}

.indiv_busns_top_img {
  height: 18rem;
  border: none !important;
}

.indiv_bus_exp_ret {
  background-color: #F2F3F3;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
}

.InvOpp_right_tab_bdy {
  padding: 16px 16px 0px 16px !important;
  max-height: 580px;
  /* QA #42: long schedules scroll inside the card instead of pushing Confirm Investment out of it. */
  min-height: 0;
  overflow-y: auto;

}

.right-card {
  min-width: 280px;
}

.InvOpp_right_tab_bdy .sesam_c {
  color: var(--sesame-color);
}

.confirm_inv_btn {
  left: 0;
  right: 0;
  text-align: center;

}

.nav-link-inv {
  border: none;
  background-color: transparent;
  color: #7C8495;
  margin-bottom: 15px;
  margin-right: 30px;

}

.nav-link-inv-onboard {
  border: none;
  background-color: transparent;
  color: #7C8495;

  margin-right: 30px;

}

.nav-link-settingsProf {
  border: none;
  background-color: transparent;
  color: #7C8495;
  margin-bottom: 0px !important;
  margin-right: 30px;

}

.shareholder_tab input {
  border: 1px solid #e5e3e3 !important;
}

.nav-tabs {
  --bs-nav-tabs-link-active-color: transparent !important;
}

.nav-item-aelb .active {
  text-underline-offset: 3px;
  color: var(--blue-text-color);
}

.nav-item-inv .active {
  color: var(--blue-text-color);
  background-color: white;
  font-weight: 400;
  box-shadow: inset 0 -2px 0 0 var(--gl-theme-accent, var(--blue-text-color));

}

.u_tab_data {
  text-underline-offset: 5px;
  text-decoration: underline var(--ben-gray-color);
  font-size: 16px;
  font-weight: 400
}

.non_u_tab_data {
  font-size: 16px;
  font-weight: 400;

}

.nav-item-indiv-busns .active {
  color: var(--blue-text-color);
  background-color: white;
  font-weight: 400;
  box-shadow: inset 0 -2px 0 0 var(--gl-theme-accent, var(--blue-text-color));

}


.inv_opp_ind_right_tab_btn {
  text-align: center;
}

.ben_progress_bar_main_inv_returns {
  rotate: -90deg;
  margin: 10px;
  background-color: transparent !important;
  width: 180px !important;
}


.indiv_bus_card_styl {
  min-height: 700px;
  height: auto;
  align-self: flex-start;
}

.indiv_bus_card_styl h4 {
  position: absolute;
  z-index: 2;
  padding: 7px 15px;
  right: 10px;
  top: 10px;

}

.indiv_bus_card_styl img {
  max-height: 10rem;
  position: relative;
}

.style_table_inv {
  font-weight: 700;
  font-size: 12px;
  line-height: 25px;
  color: #292929;
  text-align: left;
}

.style_table_inv1 {
  font-weight: 700;
  font-size: 12px;
  line-height: 25px;
  color: #292929;
  text-align: right;
  text-align-last: right;
}

.bar_chart_inv_db canvas {
  width: 420px !important;
  height: 182px !important;
}

.style_table_inv_lite {
  font-weight: 700;
  font-size: 12px;
  line-height: 25px;
  position: sticky;
  top: 0;
  background-color: white;
  color: #7C8495;
  margin-right: 5px;
  text-align: left;
  margin-left: 24px;
}

.my_inv_right_arrow {
  margin-top: 1rem;
}

.style_table_inv_lite1 {
  font-weight: 700;
  font-size: 12px;
  line-height: 25px;
  position: sticky;
  top: 0;
  background-color: white;
  color: #7C8495;
  text-align: right;
}

.line_height_about_inv {
  line-height: 1.5;
  min-height: 450px;
}

.about-document-upload {
  border: 0;
  border-radius: 0;
  padding: 0;
  background: transparent;
}

.about-document-upload .bolder_text_p_fees {
  color: var(--ptag-font-color);
  font-size: var(--ptag-font-size);
  font-weight: var(--ptag-font-weight);
  line-height: 14.5px;
}

.about-document-help {
  max-width: 760px;
  color: var(--ptag-font-color);
  font-size: var(--ptag-font-size);
  font-weight: var(--ptag-font-weight);
  line-height: 18px;
}

.about-document-select-btn {
  min-width: 150px;
  border: 0 !important;
  color: #fff !important;
  background: var(--sesame-color) !important;
  box-shadow: var(--btn-box-shadow);
}

.about-document-select-btn input {
  display: none;
}

.about-document-select-btn.disabled {
  opacity: 0.55;
  pointer-events: none;
}

.about-document-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 0 5px;
  border-bottom: 1px solid rgba(124, 132, 149, 0.22);
  border-radius: 0;
  background: transparent;
}

.about-document-file div {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.about-document-file strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 700;
}

.about-document-file span {
  font-size: 12px;
}

.about-document-ready {
  color: #138a60;
  white-space: nowrap;
}

.about-document-pending {
  color: #9a6a00;
  white-space: nowrap;
}

.about-preview-confirmation {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 0;
}

.about-preview-confirmation .form-check-input {
  width: 20px;
  height: 20px;
  margin-top: 0;
  margin-left: 0;
  border: 2px solid #1f5fd6 !important;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(31, 95, 214, 0.16);
  cursor: pointer;
}

.about-preview-confirmation .form-check-input:checked {
  border-color: #3d79f3;
  background-color: #3d79f3;
}

.about-preview-confirmation .form-check-input:disabled {
  opacity: 1;
  cursor: not-allowed;
}

.about-preview-confirmation label {
  margin-bottom: 0;
  color: #343b4a;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;
}

.about-preview-dialog {
  max-width: min(1200px, 94vw) !important;
}

.about-preview-warning {
  padding: 12px 16px;
  border: 1px solid #e0aa3e;
  border-radius: 8px;
  background: rgba(224, 170, 62, 0.12);
}

.about-preview-content {
  min-height: 55vh;
}

.about-business-content {
  width: 100%;
  overflow-x: auto;
  color: inherit;
  font-size: 14px;
  line-height: 1.65;
}

.about-business-content h1,
.about-business-content h2,
.about-business-content h3,
.about-business-content h4,
.about-business-content h5,
.about-business-content h6 {
  margin: 24px 0 10px;
  color: #3d79f3;
  line-height: 1.3;
}

/* Keep imported document headings close to their Word/ODT scale. Global page
   heading rules are intentionally larger, so the preview needs its own sizes. */
.about-business-content h1 {
  font-size: 20px !important;
}

.about-business-content h2 {
  font-size: 18px !important;
}

.about-business-content h3 {
  font-size: 17px !important;
}

.about-business-content h4,
.about-business-content h5,
.about-business-content h6 {
  font-size: 15px !important;
}

.about-business-content h1,
.about-business-content h2 {
  padding: 9px 12px;
  border-left: 4px solid #3d79f3;
  border-radius: 0 7px 7px 0;
  background: linear-gradient(90deg, rgba(61, 121, 243, 0.14), rgba(61, 121, 243, 0.02));
}

.about-business-content h3,
.about-business-content h4,
.about-business-content h5,
.about-business-content h6 {
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(61, 121, 243, 0.25);
}

.about-business-content h1:first-child,
.about-business-content h2:first-child,
.about-business-content h3:first-child {
  margin-top: 4px;
}

.about-business-content p {
  margin: 0 0 12px !important;
  color: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.65;
}

.about-business-content table {
  width: 100%;
  min-width: 560px;
  margin: 12px 0 24px;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.015);
  box-shadow: 0 3px 12px rgba(22, 45, 85, 0.08);
}

.about-business-content th,
.about-business-content td {
  padding: 10px 12px;
  border: 1px solid rgba(124, 132, 149, 0.35);
  text-align: left;
  vertical-align: top;
}

.about-business-content th {
  border-color: rgba(28, 81, 180, 0.55);
  background: #2f6fd8;
  color: #fff;
  font-weight: 700;
}

.about-business-content tbody tr:nth-child(even) td {
  background: rgba(61, 121, 243, 0.055);
}

.about-business-content strong,
.about-business-content b {
  color: inherit;
}

.about-business-content th strong,
.about-business-content th b {
  color: #fff;
}

.about-business-content th p,
.about-business-content td p {
  margin: 0 0 6px;
}

.about-business-content th p:last-child,
.about-business-content td p:last-child {
  margin-bottom: 0 !important;
}

.about-business-content img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 16px auto;
}

/* The investor tab has a muted parent text colour. Keep imported document
   body content as readable as it is in the admin preview. */
.about-business-content.investor-about-content,
.about-business-content.investor-about-content p,
.about-business-content.investor-about-content td,
.about-business-content.investor-about-content li,
.about-business-content.investor-about-content blockquote,
.about-business-content.investor-about-content strong,
.about-business-content.investor-about-content b,
.about-business-content.investor-about-content em,
.about-business-content.investor-about-content i,
.about-business-content.investor-about-content span {
  color: #212529;
}

.about-business-content.investor-about-content th,
.about-business-content.investor-about-content th p,
.about-business-content.investor-about-content th strong,
.about-business-content.investor-about-content th b,
.about-business-content.investor-about-content th span {
  color: #fff;
}

.about-business-content.investor-about-content h1,
.about-business-content.investor-about-content h2,
.about-business-content.investor-about-content h3,
.about-business-content.investor-about-content h4,
.about-business-content.investor-about-content h5,
.about-business-content.investor-about-content h6,
.about-business-content.investor-about-content h1 strong,
.about-business-content.investor-about-content h2 strong,
.about-business-content.investor-about-content h3 strong,
.about-business-content.investor-about-content h4 strong,
.about-business-content.investor-about-content h5 strong,
.about-business-content.investor-about-content h6 strong,
.about-business-content.investor-about-content h1 span,
.about-business-content.investor-about-content h2 span,
.about-business-content.investor-about-content h3 span,
.about-business-content.investor-about-content h4 span,
.about-business-content.investor-about-content h5 span,
.about-business-content.investor-about-content h6 span {
  color: #3d79f3;
}

.InvOpp_right_tab {
  position: sticky;
  top: 16px;
  align-self: flex-start;
}

@media (max-width: 991px) {
  .InvOpp_right_tab {
    position: static;
  }

  .about-document-file {
    align-items: flex-start;
    flex-direction: column;
  }
}

.businessProf_about_inv {
  line-height: 1.5;
  max-height: 220px;
  overflow: auto;
}

.inv_prf_modal p {
  max-height: 40vh;
  overflow: auto;

}

.line_height_settings {
  line-height: 1.5;
  max-height: 60vh;
  overflow: auto;
}

.form-select:disabled {
  background-color: rgba(128, 128, 128, 0.098) !important;
}

.line_height_settings .aboutcompny {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--blue-text-color);
  margin-bottom: 16px;

}

.text_area_placeholder_settings {
  margin-left: 0px;
}

.loanhistory_tab_styl {
  max-height: 450px;
  overflow-y: auto;
}

.loanhistory_tab_prof {
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
}

.kycDocsBusinessprof .table-responsive {
  max-height: 220px !important;
  overflow: auto;
}

.kycDocsBusinessprof .table-responsive th {
  position: sticky;
  top: 0;
  background-color: white;
}

.invOpp_loaHistory_mainDiv {
  max-height: 300px;
  overflow: auto;
  border-radius: 15px;
  outline: var(--table-outline);

}

.invOpp_loaHistory_mainDiv th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.invOpp_loaHistory_mainDiv td {
  font-weight: 500;
}

.bus_hist_date {
  min-width: 100px;
}

.bus_hist_lastAct {
  min-width: 120px;
}

.current_L_Details {
  line-height: 1.2;
  max-height: 450px;
  overflow: auto;
}

.inv_opp_table {
  max-height: 38vh;
  overflow-y: auto !important;
  text-align: center;
}

.inv_opp_single_table td {
  min-width: 130px;

}

.paragraph {
  white-space: pre-wrap;
  word-wrap: break-word;
}



.inv_db_curency_styl {
  overflow-x: hidden;
  justify-content: end;
}

.Inv_db_card_tilte {
  height: 27px;
  font-weight: 700;
  font-size: 22px;
  color: #000000;
  margin-bottom: 20px;
}

/* .bar_chart_inv_db{
  height: 195px;
} */
.sesame_profit_icon {
  margin-left: 120px;
}

.fa-money-bill-transfer {
  left: 0%;
  right: 82.88%;
  top: 0%;
  bottom: 0%;
  background: #599bc7;
  border-radius: 6px;
}

.percent_first {
  width: 65px !important;
  height: 9vh;
  font-weight: 700;
  font-size: 18px;
  color: var(--ben-text-sesame-color);

}

.card {
  border-radius: 12px !important;
}

.card-img,
.card-img-top {
  min-height: 6rem;
  border-top-right-radius: 12px !important;
  border-top-left-radius: 12px !important;

}

.blue_tab_single_inv {
  align-items: center;
  padding: 10px;
  background: #E6EBF8;
  border-radius: 8px;
  width: 145px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.blue_tab_single_inv p {
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--blue-text-color);
  justify-content: center;
  font-size: 14px;
}

.sesame_tab_single_inv {
  width: 140px;
  align-items: center;
  background: #F8F6F3;
  border-radius: 8px;
  text-align: center;
  align-self: center;
  padding: 10px;
}

.sesame_tab_single_inv p {
  color: var(--ben-text-sesame-color);
  font-size: 14px !important;

}

.bold_txt_btn_tabs {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;

}

.inv_opp_footer_btn {
  flex-shrink: 0;
  background-color: transparent !important;
  border-top: 0px !important;
  padding: 12px !important;

}

.nav-item-inv .active h3 {
  background-color: white !important;
  padding: 5px 8px;
  margin-bottom: 0px !important;
}

.nav-item-inv h3 {
  padding: 5px 8px;
  margin-bottom: 0px !important;
}

.nav-item-inv {
  margin-top: 10px;
}

.Inv_Styles {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;

  color: #292929;
}

.dashboard_isues {
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;

  letter-spacing: -0.02em;

  color: #292929;
}

.inv_db_navbar_brand {
  padding: 20px 35px;
}

.newinvinterest {
  cursor: default;
}

.newinvinterest h6 {
  text-decoration: none;
  color: black;
  cursor: default;
}

.new_inv_interst_table td {
  align-items: center;
  vertical-align: middle;
  font-size: 16px;
}

.fixed_header {
  width: 100% !important;
  table-layout: fixed;
  border-collapse: collapse;
}

.fixed_header tbody {
  display: block;
  width: 100%;
  overflow: auto;
  height: 100px;
}

.fixed_header thead tr {
  display: block;
}

.fixed_header thead {
  background: black;
  color: #fff;
}

.fixed_header th {
  width: 250px !important;
}

.fixed_header td {
  width: 290px !important;
}

.table_data_header_styl {
  font-size: 14px;
}

.scdl_of_paymt {
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  text-decoration-line: underline !important;
  color: var(--blue-text-color) !important;
  height: 17px
}

.textarea-max-height {
  max-height: 40px !important;
  overflow-y: auto;
}

.payemnt_details_BS_form_conrtl input {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border: 1px solid rgb(241, 241, 241) !important;
}

.payemnt_details_BS_form_conrtl span {
  border: 1px solid rgb(241, 241, 241) !important;

}

.custm_input_styl input {
  border: 1px solid #F8F8F8 !important;
}

.custm_input_styl_stngs input {
  border: 1px solid #e5e3e3 !important;
  padding-left: 10px !important;
  height: 40px !important;
}

.custm_input_styl_stngs input::placeholder {
  font-size: 14px !important;
  font-weight: 400;
  opacity: 50%;
}

.inputgroupcustmfield {
  display: flex;
  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0) !important;
}

.inputgroupcustmfield input {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.inputgroupcustmfield .settingsInputP {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  padding: 0px 10px !important;
  background-color: white !important;
  border: 1px solid #f8f8f8 !important;
  margin-left: 0px !important;
}

.qwertyqwe input {
  box-shadow: -1px 3px 10px rgba(0, 0, 0, 0.027) !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.custm_textarea_styl textarea {
  border: 1px solid rgb(219, 219, 219) !important;

}

.closed_eye_styl {
  opacity: 50%;
}

.aksjdhf input::placeholder {
  font-weight: 600;
  color: rgba(128, 128, 128, 0.74);
  font-size: 15px;
}

.disabledstyle input::placeholder {
  font-weight: 600;
  font-size: 14px;
}

.disabledstyle :disabled {
  background-color: rgba(128, 128, 128, 0.098) !important;

}

.newinvinteresttable {
  max-height: 145px;
  overflow: auto;
  border-radius: 15px !important;
  outline: var(--table-outline);

}

.loanpurpose {
  max-height: 40px;
  overflow: auto;
}

.invcompliance_qcr_notes textarea {
  font-size: 0.825rem !important;
}

.newinvinteresttable th {
  position: sticky;
  top: -0.03px;
  background-color: white !important;
  outline: 1px solid rgba(201, 201, 201, 0.164);

}

.newinvinteresttable-style {
  max-height: 180px;
  overflow: auto;
  outline: var(--table-outline);
  border-radius: 15px !important;
}

.loan_pur_myserreq {
  max-height: 10vh;
  overflow: auto;
}

.newinvinteresttable-style th {
  position: sticky;
  top: 0;
  background-color: white !important;
}

.perticlr_bus_table {
  max-height: 53vh;
  overflow-y: auto;
  border-radius: 15px !important;

}

.bus_histry_tab_styl {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #37394C;

}

.busns_histry_table_main td {
  vertical-align: middle !important;
  font-size: 14px;

}

.bus_histry_LT_tab_styl {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: #292929;
}

.perticlr_bus_table td {
  background-color: white !important;
}

.singl_inv_tabl {
  border-radius: 15px !important;
  outline: var(--table-outline);
  max-height: 32vh;
  overflow: auto;
  margin: 0px 48px;
}

.Bus_compliance_tabl {
  max-height: 350px;
  overflow: auto;
}

.bwidfcardspan {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 15px;
  color: #7C8495;
}

.inv_name_styl:hover {
  cursor: pointer;

}

.inv_name_styl img {
  width: 10px;
}

.singInvabout {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #7C8495;
  min-height: 25px;
  overflow: auto;
  max-height: 50px;
}

.singInvabout b {
  color: black;
}

.singInvabout p {
  margin-bottom: 14px !important;
}

.busproftitle {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 18px;
  color: #7C8495;
  min-height: 25px;
  overflow: auto;
}

.admin_user_icon {
  font-size: 20px;
  margin: 0px 20px;
}

.busproftitle b {
  color: black;
  font-size: 18px;

}

.busproftitle p {
  margin-bottom: 14px !important;
  font-size: 18px;
}

.inv_prof_background {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  line-height: 18px;
  color: #7C8495;
  min-height: 35px;
  overflow: auto;
  max-height: 40px;
  overflow: auto;
}

.inv_prof_background b {
  color: black;
  font-size: 18px;

}

.inv_prof_background p {
  margin-bottom: 14px !important;
  font-size: 14px;
  line-height: 22px;
}

.busprofMaintitle h4 {
  font-size: 26px;
  font-weight: 600;
  max-height: 50px;
  overflow: auto;
}

.invFullProfClsbtn {
  align-self: baseline;
  padding: 40px 40px 0px 0px !important;

}

.bwidviewprofile span {
  text-decoration: none;
  margin-bottom: 0px !important;
  width: 118px;
  height: 20px;
  left: 16px;
  top: 153px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--blue-text-color);
}

.bwidviewprofile:hover {
  cursor: pointer;
}

.bwidviewprofile {
  position: absolute;
  bottom: 0;
  padding-bottom: 12px;
}

.newinvintstatus {
  font-weight: 700;
}

.my_receipts_table {
  outline: 1px solid rgb(243, 243, 243);

}

.invfullprofilemodal {
  min-height: 53vh;
  padding-left: 25px !important;
  padding-right: 25px !important;
  padding-bottom: 25px !important;
  margin-top: 15px;
}

.Payment_currency {
  left: 85.71%;
  right: 7.45%;
  top: 46.67%;
  bottom: 21.67%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #C0C0C0;
}

.Payment_currency_settings {
  left: 85.71%;
  right: 7.45%;
  top: 46.67%;
  bottom: 21.67%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.747);
}

.cursor-pointer {
  cursor: pointer !important;
}

.width_date_picker {
  width: 33% !important;
  margin-left: 8px;
  padding-left: 13px;
  z-index: 2
}

.aboutBusiness {
  margin: 10px 10px 25px 0px;
  max-height: 80px;
  overflow: auto;
  margin-bottom: 25px !important;
  line-height: 22px;
}

.aboutBusiness b {
  color: black;
}

.trqteqter img {
  border-radius: 8px;
}

.trqteqter {
  align-self: end;
  justify-content: end;
}

.loanpurpose_txt {
  max-height: 70px;
  overflow: auto;
}


.txt {
  text-align: center;
}

.csv {
  z-index: 1 !important;
  position: relative;
}

.newinvinteresttable-headers {
  font-size: 14px;
}

.ui_sch {
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  color: var(--blue-text-color) !important;
}

.investor_new {
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  padding-left: 3rem;
  letter-spacing: -0.02em;
  cursor: pointer;
  color: #292929;
  margin-top: 25px;
}

.investor_new_first_tab {
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.02em;
  color: #292929;
}

.investor_new img {
  padding: 10px 10px 10px 0px;
  cursor: pointer;
}


table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  text-align: left;
  padding: 8px;
  border: 1px solid #ccc;
}

th {
  position: sticky;
  top: 0;
  background-color: #f0f0f0;
}

td input {
  width: 100%;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.compliance_bd_ab {
  max-width: 245px;
  text-wrap: wrap;
  overflow-wrap: anywhere;
}

.login_btn_outline {
  border: 1px solid blue !important;
  /* Replace 'black' with the desired border color */
}

.custom-select__control {
  border-radius: 5px;
  padding: 0.5rem;
  border-color: #ccc;
}

.custom-select__option {
  background-color: white;
  color: black;
}

.custom-select__control {
  border-radius: 5px;
  padding: 0.5rem;
  border-color: #ccc;
}


.custom-select__option {
  background-color: white;
  color: black;
}

.custom-select__option:hover {
  background-color: #3d79f3 !important;
}

.custom-select__option--is-selected {
  background-color: white;
  color: white;
}

.custom-select__single-value {
  color: black;
}

.custom-select__option--is-selected {
  background-color: white !important;
}

.custom-select__option {
  color: #000000 !important;
}

.custom-select__dropdown-indicator {
  color: #3d79f3;
}

/* Submenu normal and active */
.ps-submenu-content .ps-menu-label {
  color: #000;
  /* normal */
}

.ps-submenu-content .ps-menu-label.ps-active {
  color: #1a73e8;
  font-size: 13px;

  /* active */
}

.ps-submenu-content .ps-menuitem-root:hover .ps-menu-label {
  color: #1a73e8;
  /* hover */
}

/* Info Banner Styles */
.info-banner {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-left: 4px solid #f59e0b;
  padding: 20px 24px;
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.1);
}

.banner-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.banner-icon {
  width: 32px;
  height: 32px;
  background: #f59e0b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.banner-title {
  font-size: 16px;
  font-weight: 700;
  color: #92400e;
}

.banner-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.banner-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #78350f;
  font-weight: 500;
}

.banner-item svg {
  flex-shrink: 0;
}


.step-header {
  margin-bottom: 9px;

}

.step-subtitle {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.6;
}


.step-title {

  font-size: 28px;
  color: #3d79f3;
  margin-bottom: 0px;
  font-weight: 400;
  margin-top: -15px;
}

.step-title-personal {
  font-size: 28px;
  color: #3d79f3;
  margin-bottom: 0px;
  font-weight: 400;
  margin-top: -15px;

}

/* .main-content {
  padding: 24px 18px;
} */

.main-content {
  padding: 0px 18px;
}

.content-wrapper {
  max-width: 89%
}

.step-header-personal {
  margin-bottom: 17px;
}

/* Buttons */
.button-group {
  display: flex;
  gap: 16px;
  margin-top: 14px;
  padding-top: 28px;
  border-top: 1px solid #e5e7eb;
}

.button-group .btn {
  padding: 16px 32px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-family: inherit;
}

.btn-primary {
  flex: 1 1;
  background: #3d79f3;
  color: white;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
}

.btn-primary:disabled {
  background: #d1d5db;
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background: #f3f4f6;
  color: #6b7280;
  min-width: 120px;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

.btn-full {
  width: 100%;
  max-width: 300px;
  padding: 16px;
  background: #3d79f3;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 16px;
}

.btn-full:hover {
  background: #1e40af;
}


.kyc-label {
  font-weight: 600;
  /* bold */
  color: #000;
  /* black */
  margin-bottom: 6px;
}

.nomine-relation-label {
  display: block;
  margin-bottom: 8px;
  color: #374151;
  font-weight: 600;
  font-size: 14px;

}


/* .kyc-status-wrapper {
  margin-top: 8px;
}

.kyc-status {
  display: inline-block;
  padding: 10px 18px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
}
*/

/* Under Review (BLUE TAB) */
/* .kyc-status-review {
  background-color: #2f66d5;
  color: #fff;
} */

/* Warning */
/* .kyc-status-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
} */

/* Rejected */
/* .kyc-status-rejected {
  background-color: #fdecea;
  color: #b02a37;
  border: 1px solid #f5c2c7;
} */

/* Approved */
/* .kyc-status-approved {
  background-color: #e6f4ea;
  color: #137333;
  border: 1px solid #b7dfc1;
}  */

.upload-hint {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 10px;
}

.upload-title {
  font-weight: 600;
  margin-top: 8px;
}

.required {
  color: red;
  font-size: large;
  margin-left: 4px;
}



/* File Upload */
.upload-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 0px;
  margin-top: 8px;
}

.upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 5px 3px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #f9fafb;

}

.upload-area.has-file {
  border-color: #10b981;
  background: #f0fdf4;
  /* padding: 12px 3px; */


}

/* .upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #f9fafb;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.upload-area.has-file {
  border-color: #10b981;
  background: #f0fdf4;
} */

.upload-hint.hidden {
  visibility: hidden;
  /* keeps height */
}

.upload-area:hover {
  border-color: #3d79f3;
  background: #eff6ff;
}

.upload-area.has-file .upload-title {
  color: #065f46;
  font-weight: 600;

}

.upload-area.has-file .file-name {
  color: #047857;
}

/* .upload-area.has-file svg {
  fill: #10b981;
} */

.upload-area p {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 6px;
}

.upload-area .upload-title {
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  margin-top: 11px;

}

.upload-area .file-name {
  color: #10b981;
  font-weight: 600;
  margin-top: 12px;
  font-size: 15px;
}

/* 
.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #374151;
    font-weight: 600;
    font-size: 14px;
} */

@media (max-width: 768px) {
  .upload-grid {
    grid-template-columns: 1fr;
  }
}

/* * Camera */


.camera-container {
  position: relative;
  background: black;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 24px;

  width: 500px;
  height: 300px;
  /* 🔥 THIS IS IMPORTANT */
}

#video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

#canvas {
  display: none;
}

/* #video {
    width: 100%;
    display: block;
}

#canvas {
    display: none;
} */

.camera-preview {
  position: relative;
  max-width: 500px;
}

.camera-preview img {
  width: 100%;
  border-radius: 16px;
}

.retake-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}

.retake-btn:hover {
  background: rgba(0, 0, 0, 0.9);
}

.camera-instructions {
  background: #fadd91;
  border-left: 4px solid #c99716;
  padding: 16px 20px;
  margin-bottom: 24px;
  border-radius: 8px;
  font-size: 14px;
  color: #92400e;
  line-height: 1.8;
}

/* Review Section */
.review-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 32px;
}

.review-section {
  background: #f4f6f9;
  padding: 24px;
  border-radius: 12px;
}

.review-section h3 {
  font-size: 16px;
  color: #111827;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.review-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 14px;
  gap: 16px;
}

.review-item .label {
  color: #6b7280;
  font-weight: 500;
  font-size: 13px;
}

.review-item .value {
  color: #111827;
  font-weight: 500;
  text-align: right;
  font-size: 13px;
}

.edit-link {
  color: #3d79f3;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
}

.edit-link:hover {
  text-decoration: underline;
}

/* Trust Badge */
.trust-badge {
  background: #eff6ff;
  border-left: 4px solid #3d79f3;
  padding: 16px 20px;
  margin-bottom: 32px;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  gap: 12px;

}

.trust-badge svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.trust-badge-content {
  font-size: 14px;
  color: #1e40af;
  line-height: 1.6;
}

.trust-badge-content strong {
  display: block;
  margin-bottom: 4px;
}




/* Desktop Layout */
/* .kyc-container {
  display: grid;
  grid-template-columns: 400px 1fr;
  min-height: 100vh;
} */

/* Left Sidebar */
.sidebar {
  background: #3d79f3;
  color: white;
  padding: 27px 29px;
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
}


.logo {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 48px;
}

.sidebar-contentttt {
  flex: 1 1;
}

.sidebar h1 {
  font-size: 28px;
  line-height: 1.3;
  margin-bottom: 16px;
}

.sidebar p {
  font-size: 15px;
  opacity: 0.9;
  line-height: 1.6;
  margin-bottom: 48px;
}

.progress-step {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: -10px;
  opacity: 0.5;
  transition: all 0.3s;
  margin-top: 32px;
}

.progress-step.active {
  opacity: 3;
}

.progress-step.completed {
  opacity: 5.7;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  flex-shrink: 0;
}

.progress-step.active .step-number {
  background: white;
  color: #3d79f3;
}

.progress-step.completed .step-number {
  background: rgba(255, 255, 255, 0.3);
}

.step-label {
  font-size: 18px;
  font-weight: 500;
}





.kyc-sidebar {
  width: 280px;
  background: linear-gradient(180deg, #1e5eff, #173fb4);
  color: white;
  padding: 24px;
}

.stepper {
  list-style: none;
  padding: 0;
}

.step {
  margin: 16px 0;
  opacity: 0.5;
}

.step.active {
  opacity: 1;
  font-weight: bold;
}

.step.completed {
  opacity: 0.8;
}

.circle {
  background: white;
  color: #1e5eff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}


.kyc-modal-overlay.active {
  display: flex;
}

.kyc-modal-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  align-items: center;
  justify-content: center;
}

.kyc-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.kyc-modal-content {
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.modal-icon {
  width: 64px;
  height: 64px;
  background: #fadd91;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  text-align: center;
  margin-bottom: 16px;
}

.modal-description {
  font-size: 15px;
  color: #6b7280;
  text-align: center;
  margin-bottom: 24px;
  line-height: 1.6;
}

.document-checklist {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.checklist-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #374151;
}

.checklist-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: #A6FF4D;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}

.modal-button {
  width: 100%;
  padding: 16px;
  background: #3d79f3;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.helper-text {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 6px;
}


/* Form Elements */
/* .form-group {
  margin-bottom: 2px
} */

.form-group label {
  display: block;
  margin-bottom: 3px;
  color: #374151;
  font-weight: 600;
  font-size: 14px;
}


.form-field input,
.form-field select,
.form-field textarea {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.3s;
  font-family: inherit;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3d79f3;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.nominee-header {
  margin-bottom: 8px;
}

.nominee-title {
  font-size: 18px;
  font-weight: 600;
  color: #3d79f3;
  margin-bottom: 8px;
}

.nominee-subtitle {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
}

.investor-title {
  --h1-font-size: 28px;
  --h1-font-weight: 400;
}

/* Success Screen */
.success-screen {
  text-align: center;
  padding: 60px 40px;
}

.success-icon {
  width: 100px;
  height: 100px;
  background: #10b981;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 32px;
}

.success-icon svg {
  width: 50px;
  height: 50px;
}

.success-screen h2 {
  font-size: 36px;
  color: #111827;
  margin-bottom: 16px;
  font-weight: 700;
}

.success-screen p {
  color: #6b7280;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.form-group .form-control.input-error {
  /* border-color: #dc3545  !important; */
  border: 2px solid #dc3545 !important;

}

.error-text {
  font-size: 12px;
  color: #dc2626;
  /* red */
}

/* 🔴 FORCE invalid state */
.form-group .field-control.is-invalid {
  border: 2px solid #dc3545 !important;
}

.react-select__option {
  font-weight: 400;
  color: #374151;
}

.react-select__option--is-focused {
  background-color: #f3f4f6;
}

.react-select__option--is-selected {
  background-color: #e5e7eb;
  color: #111827;
  font-weight: 400;
}

.react-select__single-value {
  font-weight: 400;
}



.flatpickr-input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 18px;
  padding-right: 40px;
  padding: 10px 0px;
  /* width: 519px; */
  height: 40px;

}

.progress-step.completed .step-number {
  background-color: #22c55e;
  /* green */
  color: white;
  font-weight: bold;
}

.progress-step.active .step-number {
  background-color: #3d79f3;
  /* blue */
  color: white;
}

.step-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-error {

  border: 2px solid #dc3545 !important;
}

.form-select.input-error {

  border: 2px solid #dc3545 !important;
}


.step-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.step-tick {
  color: #50f20b;
  /* green */
  font-weight: bold;
  font-size: 25px;
}

.progress-step.completed .step-number {
  background-color: #e5f9ef;
  color: #16a34a;
}





.sidebarprohead {
  height: 100vh;
}



.selfie-box {
  display: flex;
  justify-content: center;
  margin: 32px 0;
}

.selfie-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.selfie-ring {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  padding: 6px;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  box-shadow: 0 8px 20px rgba(34, 197, 94, 0.25);
}

.selfie-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
}

.selfie-meta {
  display: flex;
  align-items: center;
  gap: 16px;
}

.selfie-status {
  font-size: 14px;
  color: #16a34a;
  font-weight: 600;
}

.selfie-retake {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.selfie-retake:hover {
  text-decoration: underline;
}

.ps-sidebar-container,
.css-dip3t8 {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}


.kyc-layout {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  /* font-family: Poppins; */
}


.kyc-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 22px 47px;
  background: #f9fafb;
}




.kyc-progress-header {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 2px;
}

.kyc-progress-track {
  width: 100%;
  height: 9px;
  background-color: #e5e7eb;
  border-radius: 999px;
  overflow: hidden;
}

.kyc-progress-fill {
  height: 100%;
  background-color: #3D79F3;
  /* BenneFin Primary Blue */
  border-radius: 999px;
  transition: width 0.3s ease;
}

.kyc-progress-step {
  font-size: 17px;
}

.right-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.kyc-progress-wrapper {
  position: sticky;
  top: 0;
  z-index: 50;
  background: #ffffff;
  padding: 0px 23px;
  border-bottom: 1px solid #e5e7eb;
}



.pep-info-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;

  background-color: transparent;

  border: 2.5px solid black;

  color: black;


  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  margin-left: 6px;
  line-height: 1;
}




.pep-tooltip {
  max-width: 320px;
  white-space: normal;
  font-size: 13px;
  line-height: 1.5;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #ffffff;
  color: #374151;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 9999;
}

.pep-info-icon:hover {
  border-color: black;
  color: black;
}

.pep-info-icon {
  color: black;
  background: transparent !important;
  font-weight: 700;
}


.selfie-success-card.small {
  max-width: 420px;
  /* 🔹 small card */
  margin: 24px auto 0;
  /* 🔹 centered */
  padding: 20px 24px;
  /* 🔹 compact padding */
  border-radius: 12px;
  border: 1px solid #22c55e;
  background: #ecfdf5;
  text-align: center;
  position: relative;
}

.selfie-success-card.small h4 {
  font-size: 18px;
  margin-bottom: 4px;
}

.selfie-success-card.small p {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
}

.selfie-success-card.small .success-icon {
  width: 44px;
  height: 44px;
  background: #22c55e;
  color: #fff;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin-bottom: 10px;
}





.progress-steps {
  margin-top: 32px;
}

.progress-step {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
}

/* ================= CIRCLE BASE ================= */
.step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* ================= COMPLETED ================= */
.progress-step.completed .step-circle {
  background-color: #A6FF4D;
  /* green */
  color: #ffffff;
  border: none;
}

/* ================= ACTIVE ================= */
.progress-step.active .step-circle {
  background-color: #ffffff;
  color: #3d79f3;
  border: none;
}

/* ================= UPCOMING ================= */
.progress-step.upcoming .step-circle {
  background-color: transparent;
  color: #93c5fd;
  border: 2px solid #93c5fd;
}

/* ================= LABEL ================= */
.step-label {
  font-size: 18px;
  font-weight: 500;
  color: #e5e7eb;
}

/* Active label brighter */
.progress-step.active .step-label {
  color: #ffffff;
}

/* Completed label slightly dim */
.progress-step.completed .step-label {
  color: #d1fae5;
}





.review-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.edit-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  /* Uploaded state */
  color: #3d79f3;
  /* blue */
  font-size: 14px;
  font-weight: 500;
}




.review-doc-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.value.uploaded {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #10b981;
  /* green */
  font-size: 13px;
  font-weight: 600;
}

/* Font Awesome check icon */
.uploaded-icon {
  font-size: 16px;
  color: #10b981;
}

.value.not-uploaded {
  color: #9ca3af;
  font-size: 13px;
}


/* Font Awesome check icon */
.uploaded-icon {
  font-size: 16px;
  color: #10b981;
}

.upload-iconnn {
  font-size: 42px;
  margin-bottom: 8px;
  color: #3d79f3;
}

.upload-icon.success {
  color: #10b981;
}


.success-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f8ff;
}

.success-card {
  background: #ffffff;
  width: 1054px;
  max-width: 100%;
  padding: 92px 14px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  height: 588px;
  max-height: 100%;
}

.success-icon-circle {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  background: #22c55e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-title {
  font-size: 33px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.success-message {
  font-size: 20px;
  color: #475569;
  line-height: 1.6;
  margin-bottom: 20px;
}

.success-info-box {
  background: #f1f6ff;
  border-radius: 12px;
  padding: 16px;
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;

}

.success-info-box h4 {
  font-size: 14px;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 8px;
}

.success-info-box ul {
  font-size: 14px;
  padding-left: 18px;
  margin: 0;
}

.success-info-box li {
  font-size: 16px;
  color: #334155;
  margin-bottom: 6px;
}

.success-footer {
  font-size: 15px;
  color: #64748b;
}

.success-footer a {
  color: #3D79F3;
  text-decoration: none;
  font-weight: 500;
}


.investor-title,
.investor-subtitle {
  font-family: "Poppins", sans-serif !important;
  font-weight: 600;
}

.investor-header * {
  font-family: "Poppins", sans-serif !important;
}



.kyc-poppins-ui .btn-primary {
  background-color: #3d79f3 !important;
  border-color: #3d79f3 !important;
}



.kyc-modal-primary-btn {
  background-color: #3d79f3 !important;
  border-color: #3d79f3 !important;
  color: #fff;
}

.kyc-modal-primary-btn:hover,
.kyc-modal-primary-btn:focus {
  background-color: #3d79f3 !important;
  border-color: #3d79f3 !important;
}


.kyc-poppins-ui,
.kyc-poppins-ui *:not(i):not(svg):not([class^="fa"]) {
  font-family: "Poppins", sans-serif !important;
}

.section-title {
  font-weight: 200;
  margin-bottom: 0;
  font-size: 21px;
  color: #3d79f3;
}

.review-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.review-approve-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.review-status .kyc-status {
  white-space: nowrap;
}

/* .kyc-status {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
} */

.kyc-status-warning {
  background-color: #fadd91;
  color: #856404;
  border: 1px solid #fadd91;
}

.kyc-status-review {
  background-color: #fadd91;
  color: #856404;
  border: 1px solid #fadd91;
}

.kyc-status-rejected {
  background-color: #fadd91;
  color: #856404;
  border: 1px solid #fadd91;
}

.kyc-status-approved {
  background-color: #fadd91;
  color: #856404;
  border: 1px solid #fadd91;
}

.upload-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: auto;
}

.upload-disabled .upload-title {
  color: #9ca3af;
}


.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #FFF;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}




@media (max-width: 1199px) and (min-width: 769px) {
  .ps-sidebar-root {
    display: block !important;
    width: 282px !important;
    min-width: 282px !important;
  }

  .ps-menu-label {
    display: none;
  }

  .ps-menu-button {
    justify-content: center;
  }


  /* Navbar container */
  .navbarTop.navbar {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap !important;
    /* 🔑 KEY */
    width: 100%;
  }

  /* Brand / title */
  .navbar-brand {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }





  .navbar-text {
    margin: 0 !important;
    padding: 0 !important;
  }

  @media(max-width: 1199px) and (min-width: 769px) {

    .dropdown {
      display: flex;
      align-items: center;
      margin-left: auto;
    }

    img.dropbtn {
      margin: 0 !important;
    }
  }

  @media (max-width: 768px) {
    .navbarTop.navbar {
      flex-wrap: nowrap !important;
    }
  }

  @media (max-width: 768px) {
    .review-grid {
      grid-template-columns: 1fr;
      /* one below another */
    }
  }
}








@media (max-width: 768px) {


  html,
  body {
    height: auto !important;
    overflow-y: auto !important;
  }

  .kyc-layout,
  .main-content,
  .content-wrapper {
    height: auto !important;
    min-height: 100vh;
    overflow: visible !important;
  }

  /* Layout becomes vertical */
  .kyc-layout {
    flex-direction: column;
  }

  .ps-sidebar-root {
    position: sticky !important;
    top: 0;
    z-index: 1000;
    height: auto !important;
    min-height: unset !important;
    background: #3d79f3;
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;

  }

  .ps-sidebar-container {
    height: auto !important;
    min-height: unset !important;
    width: 100% !important;
    overflow: visible !important;
    position: fixed !important;

  }

  /* Sidebar inner layout */
  .sidebar-inner {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
  }

  /* ❌ Hide progress steps ONLY on mobile */
  .kyc-steps,
  .stepper,
  .progress-steps {
    display: none !important;
  }

  .kyc-content,
  .main-content,
  .content-wrapper {
    overflow-y: visible !important;
    max-height: none;
  }

  .kyc-content {
    padding: 120px 47px;
  }

  /* Typography fix */
  .investor-title {
    font-size: 21px;
    font-weight: 400;
  }

  .sidebar,
  .sidebar-contentttt {
    height: auto !important;
    flex: unset !important;
    padding: 0px 0px;
  }

  .investor-header {
    padding: 16px !important;
  }

  .investor-title {
    margin-bottom: 4px;
  }

  .investor-subtitle {
    font-size: 12px;
    line-height: 1.4;
  }

  .button-group {
    display: flex !important;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
    padding-bottom: 24px;
  }

  /* Navbar container */
  .navbarTop.navbar {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap !important;
    /* 🔑 KEY */
    width: 100%;
  }

  /* Brand / title */
  .navbar-brand {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }



  /* Prevent collapse content from affecting header row */
  .navbar-collapse {
    justify-content: flex-start !important;
  }

  .navbar-text {
    margin: 0 !important;
    padding: 0 !important;
  }

  @media (max-width: 768px) {

    .dropdown {
      display: flex;
      align-items: center;
      margin-left: auto;
      /* 🔑 pushes rest to the right */
    }

    img.dropbtn {
      margin: 0 !important;
    }
  }

  @media (max-width: 768px) {
    .navbarTop.navbar {
      flex-wrap: nowrap !important;
    }
  }

  @media (max-width: 768px) {
    .review-grid {
      grid-template-columns: 1fr;
      /* one below another */
    }
  }

}




.ps-sidebar-root {
  width: 260px;
  min-width: 260px;
}

.eye-color-kyc {
  color: #3D79F3;
  font-size: 20px
}

.cancel-upload-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-upload-btn:hover {
  background: #dc2626;
}

.upload-area {
  position: relative;
  /* 🔑 REQUIRED */
}

/*
.upload-area.has-file {
  padding: 20px 16px;
}
*/

.file-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
  z-index: 20;
}

.icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;

  background: #ffffff;
  color: #111827;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}


.icon-btn.view {
  color: #3d79f3;
}

.icon-btn.cancel {
  color: #dc2626;
}

.eye-view-color-kyc {
  color: #3D79F3;
  font-size: 24px;
}

.error-msg {
  color: "red";
  font-size: "13px";
  margin-top: "4px"
}


.kyc-status {
  padding: 8px 14px;
  border-radius: 20px;
  background: #fadd91;
  color: #3a2a00;
  max-width: 500px;
  font-size: 15px;
}

.kyc-reason {
  margin-top: 4px;
  white-space: normal;
  word-break: break-word;
}

.img-fluid-ekyc {
  max-width: 25%;
  height: auto;
}

.ekyc-btn {
  border: 1px solid #0d6efd;
  color: #0d6efd;
  background-color: #fff;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 14px;
  font-weight: 500;
}

.ekyc-btn:hover {
  background-color: #0d6efd;
  color: #fff;
}

.ekyc-status-badge {
  background-color: #eaf1ff;
  color: #0d6efd;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 500;
}

.ekyc-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin: 4px 59px;
}

/* .ekyc-left, */
/* .ekyc-right {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
} */

.section {
  margin-bottom: 20px;
}

/* .ekyc-left {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  width: 700px !important;
  height: 200px;

} */





.section-header {
  margin-bottom: 5px;
}



/* Line row */
.section-line {
  width: 100%;
  height: 2px;
  border-radius: 2px;
}

/* Colors */
.section-title.blue {
  color: #2563eb;
  font-weight: 500;
}

.section-line.blue {
  background-color: #2563eb;
}

.section-title.orange {
  color: #f00f22;
  font-weight: 500;
}

.section-line.orange {
  background-color: #f00f22;
}



.ekyc-cards {
  min-height: 230px;
  cursor: pointer;
  width: 700px !important;
  background-color: rgb(255, 255, 255) !important;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  margin-top: 20px !important;
}


/* .card { background: var(--card); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: var(--shadow); padding: 16px; }
.grid { display: grid; gap: 16px; }
.grid-2 { grid-template-columns: 1fr 1fr; }
.section-title-ekyc{ margin: 0 0 8px; font-size: 18px; }
.table-ekyc { width: 100%; border-collapse: collapse; }
.table-ekyc th, .table-ekyc td { padding: 12px; border-bottom: 1px solid var(--border); text-align: left; }
.table-ekyc th { color: var(--muted); font-weight: 600; font-size: 12px; text-transform: uppercase; } */

.card-ekyc {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  padding: 16px;
}

/* GRID LAYOUT */
.grid {
  display: grid;
  gap: 16px;
}

.grid-2 {
  grid-template-columns: 1fr;
}

/* SECTION TITLE */
.section-title-ekyc {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}

/* TABLE */
.table-ekyc {
  width: 100%;
  border-collapse: collapse;
}

.table-ekyc th,
.table-ekyc td {
  padding: 5px;
  border-bottom: 1px solid var(--border);
  text-align: left;
  vertical-align: top;
}

.table-ekyc th {
  color: #64748b;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  width: 160px;
}



/* Remove sticky + background from eKYC table */
.table-ekyc th {
  position: static;
  background-color: transparent;
}

/* Remove zebra striping */
.table-ekyc tr:nth-child(even) {
  background-color: transparent;
}


.button-group-ekyc {
  display: flex;
  border-top: 3px solid #e5e7eb;
  margin: 5px 0px;
}



.details-grid {
  display: grid;
  grid-template-columns: 160px 1fr;
  /* label | value */
  row-gap: 12px;
}

.details-grid .label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 3px;
}

.details-grid .value {
  color: #1f2937;
}


.tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 14px;
}

.tag-success {
  background: #acf0c3;
  color: #166534;
}

.tag-danger {
  background: #fee2e2;
  color: #991b1b;
}

.tag-warning {
  background: #db838ca3;
  color: #991b1b;
}

.form-value {
  word-break: break-word;
}

.tag-warn {
  background: #fef3c7;
  color: #92400e;
}


.thumb {
  width: 100%;
  max-width: 280px;
  border-radius: 8px;
  border: 1px solid var(--border);
}

.toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
}

.theme-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  border: 1px solid var(--border);
  padding: 6px 10px;
  border-radius: 999px;
}

.btn-outline-primary {
  border: 1px solid #3D79F3;
  color: #3D79F3;
  background: white;
  font-weight: 500;
}


.case_action_btn {
  border: 1px solid #3D79F3;
  color: #3D79F3;
  background: white;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 6px;
}

.case_action_btn:hover {
  background: #3D79F3;
  color: white;
}


.select {
  width: 302px;
  height: 38px;
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 6px;
}

.risk-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}

.risk-left {
  display: flex;
  gap: 10px;
  align-items: center;
}

.risk-score {
  font-size: 20px;
  font-weight: 600;
}

.risk-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.assessment-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.assessment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f7f8fa;
  padding: 12px;
  border-radius: 8px;
}

.assessment-left {
  display: flex;
  gap: 10px;
  align-items: center;
}

.assessment-icon {
  font-size: 18px;
}

.assessment-title {
  font-weight: 600;
  display: flex;
  gap: 8px;
  align-items: center;
}

.assessment-meta {
  font-size: 12px;
  color: #777;
}

.assessment-actions {
  display: flex;
  gap: 8px;
}

.icon-btn {
  border: none;
  background: white;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
}

.approval-card {
  border: 2px solid #2f6fed;
  border-radius: 10px;
  padding: 16px;
  background: #f9fbff;
}

.approval-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #2f6fed;
  margin-bottom: 5px;
}

.approval-icon {
  font-size: 16px;
}

.approval-title {
  font-size: 16px;
  font-weight: 600;
}

.approval-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.approval-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.approval-checkbox input[type="checkbox"] {
  transform: scale(1.5);
  cursor: pointer;
}

.approval-comment label {
  font-size: 14px;
  font-weight: 500;
}

.approval-comment textarea {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  margin-top: 4px;
}

.required {
  color: red;
}

.approval-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}



.ekyc-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 12px;
}

.ekyc-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ekyc-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.case-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  font-size: 16px;
}

.case-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.case-label {
  font-weight: 500;
  color: #555;
  font-size: 14px
}

.case-id {
  background: #eef2ff;
  color: #2f6fed;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
}

.case-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.case-status {
  color: #444;
  font-size: 14px;
}

.case-btn {
  background: #2f6fed;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.case-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.evidence-btn {
  appearance: none;
  border: none;
  border-radius: 8px;
  padding: 6px 14px;
  cursor: pointer;
  font-weight: 600;
  background: #e2e8f0;
  color: #111827;
  text-decoration: none;
  display: inline-block;
  margin-top: 0px;
}

.evidence-btn:hover {
  background: #cbd5e1;
}

.evidence-btn:disabled {
  appearance: none;
  border: none;
  border-radius: 8px;
  padding: 6px 14px;
  cursor: pointer;
  font-weight: 600;
  background: #e2e8f0;
  color: #111827;
  text-decoration: none;
  display: inline-block;
  margin-top: 0px;
}

.disabled-open-btn {
  /* pointer-events: none;
    opacity: 0.5; */
  cursor: not-allowed;
  background-color: #e9ecef !important;
  border-color: #e9ecef !important;
  color: #6c757d !important;
  box-shadow: none;
}

.ekyc-primary-btn {
  background-color: #0d6efd;
  color: #fff;
  border: none;
  padding: 6px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
}

.ekyc-primary-btn:hover {
  background-color: #0b5ed7;
}

.ekyc-primary-btn:disabled {
  background-color: #bfc6d1;
  cursor: not-allowed;
}

.muted {
  color: #64748b;
}

.table-section th {
  background: #eef2ff;
  color: #1e293b;
  font-weight: 600;
  padding: 10px 12px;
  border-left: 4px solid #2563eb;
}


.case-label-list {
  font-weight: 500;
  color: #555;
  font-size: 25px;
  margin-top: 35px;
}


.case-select-card {
  padding: 14px 16px;
  margin-bottom: 16px;
}

.case-select-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.case-select {
  color: #334155;
}

.case-select:hover {
  border-color: #2563eb;
}

.case-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.case-filter-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-label {
  font-weight: 600;
  color: #334155;
  font-size: 15px;
}

.case-select {
  appearance: none;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 220px;
  background: white;
  font-size: 14px;
}

.ekyc-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-right-risk {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
}

.status-badge {
  background: #e7f1ff;
  color: #0d6efd;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.id-type {
  font-size: 13px;
  color: #555;
}



.ekyc-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.section-line {
  width: 100%;
  height: 2px;
  margin-top: 8px;
  background-color: #0d6efd;
}

.upload-btn {
  background: #2f6fed;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.upload-btn:disabled {
  background-color: #bfc6d1;
  cursor: not-allowed;
}

/* .upload-btn:hover {
  background-color: #f0f6ff;
} */


.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

/* .form-group label {
  font-size: 12px;
  color: #9aa4b2;
  margin-bottom: 4px;
} */

.form-group input {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  color: #101828;
  font-size: 14px;
  outline: none;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}



.form-value {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #101828;
  font-size: 14px;
}


.ekyc-reset-btn {
  background: #b2bac2;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}






.fatf-upload-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.fatf-desc {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 7px;
}


.fatf-storage {
  font-size: 12px;
  color: #6b7280;
}

.file-input-wrapper {
  flex: 1 1;
}

.fatf-upload-row input[type="file"] {
  display: block !important;
  width: 324px;
  color: #000;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
}

.upload-btn-risk {
  background: #2f6fed;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 30px;
}

.upload-btn-risk:disabled {
  background-color: #bfc6d1;
  cursor: not-allowed;
}

.ekyc-textarea {
  resize: vertical;
  white-space: pre-wrap;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  color: #101828;
  font-size: 14px;
  outline: none;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.risk-badge {
  background-color: #e6f7ee;
  color: #1f9d55;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.risk-info-box {
  background-color: #e6f0ff;
  border: 1px solid #bcd3ff;
  color: #1a4fb5;
  padding: 7px 11px;
  border-radius: 6px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 1px;
  margin-top: 0px;

}

.risk-info-box .tick {
  color: #2e7d32;
  font-weight: bold;
}

.choose-file-btn {
  display: inline-block;
  padding: 8px 24px;
  margin-bottom: 0;
  background-color: #ffffff;
  color: #0d6efd;
  border: 1px solid #0d6efd;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.choose-file-btn:hover {
  background-color: #0d6efd;
  color: #ffffff;
}

.choose-file-btn:active {
  transform: scale(0.98);
}

/* Keep the file name area at a fixed width so the Upload button
   always stays in the same position */
.selected-file-name {
  display: inline-block;
  width: 320px;
  /* Adjust width as needed */
  min-width: 320px;
  max-width: 320px;
  font-size: 14px;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* Optional: prevent wrapping of the whole row */
.fatf-upload-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.upload-history-label {
  font-weight: 500;
  color: #212519;
  font-size: 21px;
  margin-left: 18px;
  margin-top: 7px;
}

.kyc-status-badge.approved {
  color: #198754;
  /* Green */
  font-weight: 500;
  font-size: 16px;
}

.kyc-status-badge.pending {
  color: #0d6efd;
  /* Blue */
  font-weight: 500;
  font-size: 16px;
}

.kyc-status-badge.rejected {
  color: #dc3545;
  /* Red */
  font-weight: 500;
  font-size: 16px;
}

.login-logo {
  width: 100%;
  max-width: 400px;
  height: auto;
}

.login_input_space {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 1rem;
}

/* Stack tab buttons neatly on small screens */
@media (max-width: 576px) {
  .login_input_space {
    padding: 0.75rem;
  }

  .login-logo {
    max-width: 280px;
  }

  .login_btn_outline,
  .btn-primary {
    font-size: 14px;
    padding: 0.5rem 0.75rem !important;
  }

  .login_btn_outline h5,
  .btn-primary h5 {
    font-size: 14px;
    margin: 0;
  }
}

.ekyc-list-reset-btn {
  background: #2f6fed;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;

}

.risk-badge {
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  display: inline-block;
}

.risk-badge.high {
  background: #ec5c6a;
  color: #fff;
}


.tag-risk {
  background: #f4616f;
  color: #fff;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 400;
}

.risk-text {
  font-size: 16px;
  font-weight: 400;
}

.tag-risk-high {
    background: #fee2e2;
    color: #991b1b;
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 16px;
}

.tag-risk-medium {
    background: #fef3c7;
    color: #92400e;
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 16px;
}

.tag-risk-low {
    background: #db838ca3;
    color: #166534;
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 16px;
}

.tag-risk-pending {
    background: #cbd5e180;
    color: #334155;
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,yDAAyD;EACzD,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;EACrC,0CAA0C;EAC1C,2BAA2B;EAC3B,4CAA4C;EAC5C,4BAA4B;EAC5B,uBAAuB;EACvB,oDAAoD;EACpD,4BAA4B;EAC5B,uDAAuD;EACvD,2DAAwD;EACxD,6DAA4D;EAC5D,2DAAwD;EACxD,4EAA4E;EAC5E,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,4DAA4D;EAC5D,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;;AAEhC;;AAEA;;;;;;;;;;;;;;;;;EAiBE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,+DAA+D;EAC/D,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;;AAEjC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,UAAU;;EAEV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC;gEAC8D;EAC9D,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC;gEAC8D;EAC9D,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;;;AAIA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;AACnC;;AAEA;EACE,wHAAwH;EACxH,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC;gEAC8D;EAC9D,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,wCAAwC;EACxC,2BAA2B;EAC3B,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC;gEAC8D;EAC9D,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC;gEAC8D;EAC9D,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB;gEAC8D;EAC9D,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB;gEAC8D;EAC9D,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;EACzC,qBAAqB;EACrB;gEAC8D;AAChE;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,oDAAoD;EACpD,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;GAGG;;AAEH;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,MAAM;EACN,0BAA0B;AAC5B;;AAEA;EACE,yDAAmE;EACnE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yDAAqE;EACrE,wBAAwB;EACxB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,MAAM;EACN,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;AAC5B;;;AAGA;EACE,yDAAyD;AAC3D;;AAEA;EACE,gDAAgD;;AAElD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;;EAEd,8BAA8B;;AAEhC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;;EAEV,cAAc;;AAEhB;;AAEA;EACE,mDAAmD;EACnD,YAAY;;AAEd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;;;;AAKA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;;EAEd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,kCAAkC;;EAElC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;;AAE9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf;AACF;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;EACV,UAAU;EACV,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,MAAM;EACN,UAAU;EACV,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B;AACF;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;;AAEpC;;AAEA;EACE,kCAAkC;AACpC;;;AAGA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;;AAEpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,MAAM;EACN,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,+CAA+C;EAC/C,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;;AAErB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,8BAA8B;;AAEhC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;EAClC,6BAA6B;;AAE/B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,6BAA6B;;AAE/B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA,2GAA2G;AAC3G;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;;EAE7B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;;AAGA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;;EAGA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;;;EAGhB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;;IAEjB,cAAc;;EAEhB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;;;EAGpB;;EAEA;IACE,kCAAkC;IAClC,8BAA8B;EAChC;;;EAGA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,wBAAwB;IACxB,aAAa;IACb,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;;AAE7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,uDAAuD;EACvD,oCAAoC;;AAEtC;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,uDAAuD;EACvD,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,4BAA4B;;AAE9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;;AAEhB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;;EAEnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,6BAA6B;;AAE/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yDAAyD;EACzD,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,2CAA2C;EAC3C,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yDAAyD;EACzD,2CAA2C;EAC3C,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;;AAEhC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,2BAA2B;;;AAG7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,8BAA8B;EAC9B,mBAAmB;;AAErB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;;AAEX;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,WAAW;;AAEb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;;AAE/B;;AAEA;EACE,iDAAiD;;AAEnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;;AAEjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,0DAA0D;EAC1D,0CAA0C;EAC1C,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,0DAA0D;EAC1D,0CAA0C;EAC1C,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,cAAc;;EAEd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;;AAE7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,sCAAsC;EACtC,yCAAyC;EACzC,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;;AAEpB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,uCAAuC;EACvC,0CAA0C;EAC1C,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,uBAAuB;;AAEzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,WAAW;AACb;;;AAGA;EACE,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,2BAA2B;;AAE7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;;AAEb;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;;AAEjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;;;;;AAMA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;;AAExB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;;EAEnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;;EAEtB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;;AAE9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;;EAElB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,8FAA8F;AAC9F;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;;;AAIA;EACE,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;;AAE/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;;AAGA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;;AAE/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;;AAEpC;;AAEA;EACE,kCAAkC;;AAEpC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;;AAEpC;;AAEA;EACE,+BAA+B;;AAEjC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,uCAAuC;EACvC,yCAAyC;EACzC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,+CAA+C;;AAEjD;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,uCAAuC;EACvC,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;;AAE/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;;AAEnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;;;AAGzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mGAAmG;EACnG,aAAa;EACb,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;;EAEd,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;;AAEpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,2EAA2E;;AAE7E;;AAEA;EACE,0BAA0B;EAC1B,gDAAgD;EAChD,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,2EAA2E;;AAE7E;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,wCAAwC;EACxC,uBAAuB;AACzB;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,SAAS;;AAEX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;EAME,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;gFACgF;AAChF;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,sFAAsF;AACxF;;AAEA;;;;EAIE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;;EAEE,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;4DAC4D;AAC5D;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;;AAErB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;;;AAIA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;GAEG;AACH;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,OAAO;EACP,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mCAAmC;;AAErC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,wCAAwC;EACxC,uCAAuC;;AAEzC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;;AAE5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;;AAEzB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,0BAA0B;EAC1B,wBAAwB;;AAE1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,uBAAuB;;EAEvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,0CAA0C;EAC1C,wCAAwC;EACxC;AACF;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;;AAEjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,4BAA4B;EAC5B,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,yDAAyD;EACzD,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;;AAEjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uDAAuD;;AAEzD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,6CAA6C;;AAE/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;;AAEhC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,iCAAiC;EACjC,eAAe;;AAEjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;;AAEjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;;AAEjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;;AAEvC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,UAAU;;EAEV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;;AAEvC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;;AAGA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;;AAEjB;;;AAGA;;;;;;;;;;;;CAYC;;AAED,4BAA4B;AAC5B;;;GAGG;;AAEH,YAAY;AACZ;;;;GAIG;;AAEH,aAAa;AACb;;;;GAIG;;AAEH,aAAa;AACb;;;;IAII;;AAEJ;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;;;AAIA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;;AAErB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;;;AAGzB;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;GAOG;;AAEH;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,aAAa;;;AAGb;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;;EAEnB,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;GAOG;;AAEH;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;;AAEX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;;;AAKA,mBAAmB;AACnB;;;;GAIG;;AAEH,iBAAiB;AACjB;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;;;;AAMA;EACE,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;;AAGA,kBAAkB;AAClB;;GAEG;;AAEH;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;;AAEtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,yDAA4T;EAC5T,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;;;;AAMA;EACE,aAAa;AACf;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,6BAA6B;EAC7B,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;;;AAGA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;;;;AAKA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,6BAA6B;;EAE7B,yBAAyB;;EAEzB,YAAY;;;EAGZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;;;AAKA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;;;;;AAMA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,UAAU;EACV,cAAc;EACd,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,cAAc;AAChB;;;;;;AAMA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;;;;AAKA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;;AAGA;;EAEE,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;;;AAIA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;;;AAIA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;AACb;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;;AAGA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;;AAEH;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;;AAKA;EACE;IACE,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;;EAGA,qBAAqB;EACrB;IACE,wBAAwB;IACxB,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,WAAW;IACX,WAAW;EACb;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;;;;;EAMA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;IAEE;MACE,aAAa;MACb,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,sBAAsB;IACxB;EACF;AACF;;;;;;;;;AASA;;;EAGE;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;;IAGE,uBAAuB;IACvB,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA,4BAA4B;EAC5B;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;;EAE5B;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;;EAE5B;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA,yCAAyC;EACzC;;;IAGE,wBAAwB;EAC1B;;EAEA;;;IAGE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,qBAAqB;EACrB;IACE,wBAAwB;IACxB,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,WAAW;IACX,WAAW;EACb;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;;;EAIA,uDAAuD;EACvD;IACE,sCAAsC;EACxC;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;IAEE;MACE,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,gCAAgC;IAClC;;IAEA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,sBAAsB;IACxB;EACF;;AAEF;;;;;AAKA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;CAIC;;AAED;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;;EAEZ,mBAAmB;EACnB,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,eAAe;EACf,wCAAwC;AAC1C;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB;AACF;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;;;;GAIG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;;;;;;AAMH;EACE,kBAAkB;AACpB;;;;AAIA,aAAa;AACb;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,+CAA+C;EAC/C,+CAA+C;EAC/C,2BAA2B;AAC7B;;;AAGA;;;;;;uGAMuG;;AAEvG;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;;;AAIA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE;mBACiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;;AAGA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;GAEG;;;AAGH;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;GAIG;;AAEH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kDAAkD;AACpD;;;;AAIA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;;;;;AAOA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;;AAEjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;sCACsC;AACtC;EACE,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,kCAAkC;EACpC;;EAEA;;IAEE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB","sourcesContent":[":root {\n  --ben-gray-color: #bcbec0;\n  --ben-radio-size: 18px;\n  --text-color: #ffffff;\n  --blue-text-color: #3D79F3;\n  --ben-text-sesame-color: #baa38b;\n  --div-padding: 24px;\n  --font-family: \"Inter\", sans-serif;\n  --background-color: #3D79F3;\n  --border-color: #3D79F3;\n  --focus-shadow: #3D79F3;\n  --btn-color-gray: var(--ben-gray-color);\n  --btn-padding: 10px 15px;\n  --btn-line-height: 15px;\n  --btn-sm-padding: 5px 10px;\n  --btn-sm-lh: 8px;\n  --btn-box-shadow: 0px 2px 10px rgba(161, 161, 161, 0.493);\n  --btn-letter-spacing: 0.3px;\n  --btn-font-size: 12px;\n  --btn-font-weight: 700;\n  --h1-font-size: 24px;\n  --h1-font-weight: 400;\n  --h1-line-height: 29px;\n  --h3-font-size: 14px;\n  --h3-font-weight: 700;\n  --h5-font-size: 14px;\n  --h5-font-weight: 500;\n  --ptag-font-size: 12px;\n  --ptag-font-color: #bcbec0;\n  --gray-text-color: var(--ben-gray-color);\n  --ptag-font-weight: 700;\n  --article-font-size: 12px;\n  --article-font-weight: 400;\n  --span-font-weight: 400;\n  --span-font-size: 12px;\n  --btn-hover-background-color: #3D79F3;\n  --gray-btn-hover-background-color: #bcbec0;\n  --upload-btn-color: #bcbec0;\n  --sesame-color: var(--ben-text-sesame-color);\n  --ben-btn-border-radius: 8px;\n  --ben-bg-color: #3D79F3;\n  --ben-drpdn-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);\n  --btn-color-graytwo: #F2F3F3;\n  --table-outline: 0.3px solid rgba(211, 211, 211, 0.281);\n  --blue-capsule-img: url(\"../public/images/Blue_cap.svg\");\n  --sesame-capsule-img: url(\"../public/images/sesame_cap.svg\");\n  --gray-capsule-img: url(\"../public/images/gray_cap.svg\");\n  /* BenneFin brand palette: grading badges, funding bars and Fund Now icons */\n  --ben-navy: #0D1D54;\n  --ben-blue: #3D79F3;\n  --ben-sesame: #BAA38B;\n  /* darker sesame for text on white (#BAA38B is only 2.4:1) */\n  --ben-sesame-dark: #7A6449;\n  --ben-grey: #BCBEC0;\n  --ben-grey-dark: #7C8495;\n  --ben-track: #E5E7EB;\n  --ben-grade-a: var(--ben-navy);\n  --ben-grade-b: var(--ben-blue);\n  --ben-grade-c: var(--ben-sesame);\n  --ben-grade-d: var(--ben-grey);\n\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nspan,\np,\narticle,\nselect,\ninput,\ntextarea,\nb,\noption,\nlabel,\nlink,\na {\n  font-family: \"Inter\", sans-serif !important;\n}\n\nh5 {\n  margin-bottom: 0 !important;\n}\n\ninput[type=\"date\"] {\n  display: flex;\n  text-align: start !important;\n}\n\ntextarea::placeholder {\n  opacity: 50% !important;\n  color: var(gray-text-color) !important;\n}\n\n.minus_btn {\n  border-radius: 50%;\n  width: 20px;\n  padding: 5px;\n  align-items: center;\n  display: inline-flex;\n  margin-left: 10px;\n  height: 20px;\n  text-align: center;\n  color: white;\n}\n\ntextarea:disabled {\n  background-color: rgba(128, 128, 128, 0.098) !important;\n}\n\n.bg-ben {\n  background-color: var(--ben-bg-color);\n}\n\n.shadow-ben {\n  box-shadow: var(--ben-drpdn-shadow);\n}\n\n::placeholder {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n  font-size: 13px;\n  opacity: 45%;\n}\n\n.btn {\n  --bs-btn-border-color: none !important;\n  --bs-btn-border-radius: var(--ben-btn-border-radius) !important;\n  --bs-btn-font-weight: 400 !important;\n  --btn-padding-x: 2px !important;\n  --btn-padding-y: 2px !important;\n\n}\n\np {\n  font-size: var(--ptag-font-size);\n  font-weight: var(--ptag-font-weight);\n  color: var(--ptag-font-color);\n  margin-bottom: 0px !important;\n  line-height: 14.5px;\n}\n\narticle {\n  font-size: var(--article-font-size);\n  font-weight: var(--article-font-weight);\n}\n\nh1 {\n  font-size: var(--h1-font-size) !important;\n  font-weight: var(--h1-font-weight) !important;\n}\n\nh3 {\n  font-size: var(--h3-font-size) !important;\n  font-weight: var(--h3-font-weight) !important;\n}\n\nspan {\n  font-size: var(--span-font-size);\n  font-weight: var(--span-font-weight);\n}\n\n.eye-color {\n  color: blue;\n}\n\n.pagestyle {\n  height: calc(100vh - 83px);\n  overflow: auto;\n}\n\n.bus_notific_main {\n  display: flex;\n  position: absolute;\n  margin-bottom: 0px !important;\n}\n\n.blue_txt {\n  color: var(--blue-text-color);\n}\n\n.emaillogintxtdstyl {\n  width: 746px;\n  height: 64px;\n  left: calc(50% - 746px/2);\n  top: 120px;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  text-align: center;\n}\n\n.show_password_eye {\n  position: absolute;\n  top: 55%;\n  left: 90%;\n  cursor: pointer;\n}\n\n.emailmaindiv {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 1rem;\n  gap: 30px;\n}\n\n.emaillogintxtdstyl span {\n  width: 746px;\n  height: 64px;\n  left: calc(50% - 746px/2);\n  top: 120px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  text-align: center;\n}\n\n.blue_btn {\n  background-color: var(--background-color) !important;\n  height: var(--btn-height);\n  width: var(--btn-width);\n  font-family: var(--font-family);\n  color: var(--text-color) !important;\n  border: var(--border-color);\n  padding: var(--btn-padding) !important;\n  border-radius: var(--ben-btn-border-radius);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  line-height: var(--btn-line-height);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-shadow: var(--focus-shadow);\n  font-size: var(--btn-font-size);\n  font-weight: var(--btn-font-weight);\n  letter-spacing: var(--btn-letter-spacing);\n  display: inline-block;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.blue_btn_btn {\n  background-color: var(--background-color) !important;\n  height: var(--btn-height);\n  width: var(--btn-width);\n  font-family: var(--font-family);\n  color: var(--text-color) !important;\n  border: var(--border-color);\n  padding: var(--btn-padding) !important;\n  border-radius: var(--ben-btn-border-radius);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  line-height: var(--btn-line-height);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-shadow: var(--focus-shadow);\n  font-size: var(--btn-font-size);\n  font-weight: var(--btn-font-weight);\n  letter-spacing: var(--btn-letter-spacing);\n  display: inline-block;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n\n\n.kyc-primary-btn:hover {\n  background-color: #3D79F3;\n}\n\n.blue_btn:disabled {\n  opacity: 0.5;\n  color: #ebebeb;\n  cursor: default;\n}\n\n.blue_btn:hover {\n  background-color: var(--btn-hover-background-color);\n  box-shadow: var(--btn-box-shadow);\n}\n\n.disclaimer-message {\n  /* QA #42: was sticky with z-index 1000 and covered Confirm Investment on long schedules; now it sits below the cards. */\n  background-color: white;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.gray_btn {\n  background-color: var(--btn-color-gray) !important;\n  height: var(--btn-height);\n  width: var(--btn-width);\n  font-family: var(--font-family);\n  color: var(--text-color) !important;\n  border: var(--border-color);\n  padding: var(--btn-padding) !important;\n  border-radius: var(--ben-btn-border-radius);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  line-height: var(--btn-line-height);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-shadow: var(--focus-shadow);\n  font-size: var(--btn-font-size);\n  font-weight: var(--btn-font-weight);\n  letter-spacing: var(--btn-letter-spacing);\n  display: inline-block;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.graytwo_btn {\n  background-color: var(--btn-color-graytwo) !important;\n  height: var(--btn-height);\n  width: var(--btn-width);\n  font-family: var(--font-family);\n  color: var(--blue-text-color) !important;\n  border: var(--border-color);\n  padding: var(--btn-padding) !important;\n  border-radius: var(--ben-btn-border-radius);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  line-height: var(--btn-line-height);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-shadow: var(--focus-shadow);\n  font-size: var(--btn-font-size);\n  font-weight: 400 !important;\n  letter-spacing: var(--btn-letter-spacing);\n  display: inline-block;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.upload_btn {\n  background-color: var(--upload-btn-color) !important;\n  height: var(--btn-height);\n  width: var(--btn-width);\n  font-family: var(--font-family);\n  color: black !important;\n  border: var(--border-color);\n  padding: var(--btn-padding) !important;\n  border-radius: 5px;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  line-height: var(--btn-line-height);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-shadow: var(--focus-shadow);\n  font-size: var(--btn-font-size);\n  font-weight: var(--btn-font-weight);\n  letter-spacing: var(--btn-letter-spacing);\n  display: inline-block;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.black_btn {\n  background: var(--gray-text-color);\n  height: var(--btn-height);\n  width: var(--btn-width);\n  font-family: var(--font-family);\n  color: var(--text-color);\n  border: var(--border-color);\n  padding: var(--btn-padding);\n  border-radius: 5px;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  line-height: 15px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-shadow: var(--focus-shadow);\n  cursor: pointer;\n}\n\n.black_btn:disabled {\n  opacity: 0.5;\n  color: #ebebeb;\n}\n\n.black_btn:hover {\n  background: var(--gray-text-color);\n  box-shadow: 0px 5px 7px rgba(161, 161, 161, 0.493);\n}\n\n.singlInvImage {\n  display: flex;\n  width: 210px !important;\n}\n\n.singlInvImage img {\n  width: 190px;\n  border-radius: 15px 0px 0px 15px;\n}\n\n.gray_btn:disabled {\n  padding: var(--btn-padding) !important;\n  border-radius: 5px;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  line-height: 1.5;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-shadow: var(--focus-shadow);\n  font-size: var(--btn-font-size);\n  font-weight: var(--btn-font-weight);\n  letter-spacing: var(--btn-letter-spacing);\n  display: inline-block;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.gray_btn:disabled {\n  opacity: 0.5;\n  color: #ebebeb;\n}\n\n.gray_btn:hover {\n  background-color: var(--gray-btn-hover-background-color);\n  box-shadow: var(--btn-box-shadow);\n}\n\ninput {\n  border-radius: 0% !important;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  background-color: var(--background-color) !important;\n  transition: none;\n  /* border-radius: 0%; */\n  color: white !important;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 29px;\n\n  /* text-decoration: underline; */\n}\n\n.nav-tabs .nav-link[data-rr-ui-event-key=\"investor_login\"] {\n  color: white !important;\n}\n\n.nav-tabs .nav-link[data-rr-ui-event-key=\"investor_login\"]:not(.active) {\n  color: var(--ben-gray-color) !important;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link {\n  color: var(--ben-gray-color) !important;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link:hover {\n  /* border-radius: 0%; */\n}\n\n.css-dip3t8 {\n  background-color: var(--blue-text-color) !important;\n  left: 0 !important;\n  top: 0 !important;\n  height: 100vh !important;\n}\n\n/* .css-dip3t8-open {\n  background-color: #64ba01 !important;\n  position: fixed !important;\n} */\n\n.css-1bdadyq:hover {\n  background-color: #d8d8d800 !important;\n}\n\n.menu_items span {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 15px;\n}\n\n.login_main {\n  background: #000000;\n  height: 100vh;\n}\n\n.login_main_img {\n  width: 100%;\n  height: 100vh;\n  object-fit: cover;\n}\n\n.main_nav {\n  height: 70px;\n  width: auto;\n  left: 250px;\n  right: 0;\n  background-color: #fff;\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  transition-duration: 300ms;\n}\n\n.admin_bg {\n  background-image: url(\"../public/images/admin_blue_background.svg\");\n  height: 100vh;\n  background-size: cover;\n}\n\n.loginTruemail {\n  background-image: url(\"../public/images/backgroundforEmaillogin.svg\");\n  height: 100vh !important;\n  background-repeat: no-repeat !important;\n  background-size: cover;\n}\n\n.emailloginSave {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  justify-content: center;\n}\n\n.admin_login_label_email label {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  color: #292929;\n\n}\n\n.admin_login_label label {\n  color: white !important;\n}\n\n/* .nav_collapsed {\n  height: 70px;\n  width: auto;\n  left: 79px;\n  right: 0;\n  background-color: #fff;\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  transition-duration: 300ms;\n\n} */\n\n.db_collapsed {\n  width: auto;\n  left: 5%;\n  right: 0;\n  position: absolute;\n  transition-duration: 300ms;\n  top: 20%;\n}\n\n.bashboard {\n  height: 70px;\n  width: auto;\n  left: 250px;\n  right: 0;\n  position: absolute;\n  transition-duration: 300ms;\n  top: 20%;\n}\n\n.sidebar_img {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.sidebar_right_arrow {\n  margin: 10px 0;\n}\n\n.login_input_space {\n  min-width: 400px;\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n  border-color: transparent !important;\n  isolation: isolate;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-link-hover-border-color: transparent !important;\n  --bs-nav-tabs-border-width: 0px !important;\n}\n\n.login_txt {\n  margin-left: -49px !important;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.ben_card_cls_main {\n  display: flex;\n  gap: 20px;\n}\n\n.card {\n  border: none !important;\n}\n\n.ben_card_cls {\n  padding: 32px;\n}\n\n.innercard_content {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 23px;\n}\n\n.innercard_content p {\n  font-size: 12px !important;\n}\n\n.innercard_content h5 {\n  font-weight: 800;\n  font-size: 12px;\n  line-height: 15px;\n  margin-bottom: 0px;\n}\n\n.ben_progress_bar_main {\n  border-radius: 0% !important;\n  margin: 0 15px;\n  /* min-width: 180px; */\n  min-height: 22px;\n  margin-top: 2px;\n}\n\n#yesRadio {\n  height: var(--ben-radio-size);\n  width: var(--ben-radio-size);\n}\n\n#noRadio {\n  height: var(--ben-radio-size);\n  width: var(--ben-radio-size);\n}\n\n.is_pep_div {\n  align-items: center;\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.pep_radio {\n  align-items: center !important;\n}\n\n.pep_radio input {\n  height: 2em !important;\n  width: 2em !important;\n  border-radius: 50% !important;\n  transform: translate(100%);\n}\n\n\n.ben_progress_bar {\n  background-color: var(--ben-text-sesame-color) !important;\n}\n\n.ben_progress_bar_blue {\n  background-color: var(--ben-bg-color) !important;\n\n}\n\n.bd_amt_styl b {\n  color: #7C8495;\n}\n\n.bd_amt_styl span {\n  color: var(--blue-text-color);\n  font-size: 21px;\n  font-weight: 500;\n}\n\n.business_db_title {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: -0.02em;\n  color: #292929;\n}\n\n.inv_db_currency {\n  height: 15px;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n  color: #7C8495;\n\n  justify-content: space-between;\n\n}\n\n.btn a {\n  text-decoration: none !important;\n  color: white;\n}\n\n.view_all_Link a {\n  text-decoration: none !important;\n  color: black;\n}\n\n.btn a:hover {\n  color: white;\n}\n\n.inv_db_currency ol {\n  /* padding-left: 2.25rem !important; */\n  justify-content: space-between;\n}\n\n.inv_db_tinv {\n  width: 99px;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n  left: 45px;\n\n  color: #7C8495;\n\n}\n\n.ben_progress_bar_gray {\n  background-color: var(--gray-text-color) !important;\n  height: 20px;\n\n}\n\n.ben_progress_bar_main_inv .progress {\n  height: 20px;\n}\n\n.inv_db_txt {\n  font-size: 12px;\n  font-weight: 700;\n  color: #7C8495;\n\n}\n\n.inv_db_txt1 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #7C8495;\n\n}\n\n.ben_card_cls h6 {\n  margin-bottom: 20px;\n}\n\ninput:disabled {\n  background-color: rgba(128, 128, 128, 0.098) !important;\n}\n\n.nav {\n  display: block !important;\n}\n\n/* .form-group label {\n  margin-bottom: 5px;\n} */\n\n.form-group span {\n  color: red;\n  font-size: large;\n  margin-left: 2px;\n}\n\n.first ul ol {\n  padding-left: 0px;\n}\n\n.cos_main .second ul {\n  padding-left: 0;\n}\n\n.cos_main .third ul {\n  padding-left: 0;\n}\n\n.ben_select_cls {\n  min-width: fit-content;\n}\n\n.loan_page {\n  position: absolute;\n  left: 20%;\n  margin-bottom: 16px;\n  max-height: 100vh;\n  width: auto;\n}\n\n.modal_title {\n  padding: 5px 15px !important;\n}\n\n.APNL_option_flds {\n  padding: 2px 10px !important;\n  width: -webkit-fill-available;\n}\n\n.fa-eye-font {\n  font-size: 15px;\n}\n\n/* .ben_select_cls select {\n  padding: 4px auto 4px 10px !important;\n} */\n\n.css-ybys5z.ps-collapsed {\n  width: 80px;\n  min-width: 80px;\n}\n\n.css-ybys5z {\n  position: fixed !important;\n}\n\n.custom-file-input::-webkit-file-upload-button {\n  transition-delay: 2000ms;\n  display: none;\n}\n\ninput[type=\"file\" i] {\n  border: none !important;\n  text-align: center;\n  border-color: #fff !important;\n  color: red;\n  display: none;\n}\n\ni.fa-solid {\n  overflow: hidden;\n  /* Ensure the icon does not cause overflow */\n  display: inline-block;\n  /* Ensures the icon behaves like text */\n}\n\ninput[type=\"file\" i]:focus-visible {\n  border: #fff;\n}\n\ninput[type=\"date\"] {\n  padding: 5px;\n  border: none !important;\n  text-align: center;\n  border-color: #fff !important;\n}\n\n.input_filname {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: black !important;\n}\n\n.upload_cls {\n  margin-top: 10px;\n}\n\n.upload_cls img {\n  height: 15px;\n  margin: 3px;\n  cursor: pointer;\n}\n\n.label_style {\n  width: 165px;\n  height: 32px;\n  background: var(--ben-gray-color);\n  border-radius: 8px;\n}\n\n.attach_doc {\n  width: 135px;\n  height: 32px;\n  left: 43px;\n  top: 73px;\n  background: var(--sesame-color);\n  border-radius: 8px;\n  color: white;\n}\n\n.cust_placeholder_styl input::placeholder {\n  font-weight: 700;\n  color: rgb(7, 7, 7) !important;\n}\n\n.pending_link_modal_docs_div {\n  max-height: 45vh;\n  overflow: auto;\n  margin-right: 10px;\n}\n\n.kyc_table th {\n  position: static;\n}\n\n.compliance_pending_status {\n  font-weight: 700;\n  color: var(--blue-text-color);\n  cursor: pointer;\n}\n\n.onboarding_pending_status {\n  font-weight: 700;\n  color: var(--blue-text-color);\n\n}\n\n.compliance_inv_pending_status {\n  font-weight: 700;\n  color: var(--blue-text-color);\n  cursor: pointer;\n}\n\n.compliance_inv_pending_status:hover {\n  text-decoration: underline;\n}\n\n.compliance_pending_status:hover {\n  text-decoration: underline;\n}\n\n.compliance_inv_approved_status {\n  font-weight: 700;\n  color: #059669;\n}\n\n.compliance_approved_status {\n  font-weight: 700;\n  color: #059669;\n  cursor: pointer;\n}\n\n.onboarding_approved_status {\n  font-weight: 700;\n  color: #059669;\n\n}\n\n.text_area_placeholder textarea::placeholder {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n  color: #7C8495;\n}\n\n.text_area_placeholder_settings textarea {\n  font-size: 14px;\n  line-height: 17px;\n  padding: 10px !important;\n}\n\n.text_area_placeholder_settings {\n  margin: 10px;\n}\n\n.compliance_approved_status:hover {\n  text-decoration: underline green;\n}\n\n.compliance_rejected_status {\n  font-weight: 700;\n  color: #ED5151;\n}\n\n.upload_report_btn {\n  width: fit-content;\n  padding: 10px 25px;\n  background: var(--sesame-color);\n  border-radius: 8px;\n  color: white;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  align-items: center;\n  text-align: center;\n  cursor: pointer;\n}\n\n.upload_report_btn_newloanRequest {\n  width: fit-content;\n  padding: 6px 12px;\n  background: var(--sesame-color);\n  border-radius: 8px;\n  color: white;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  align-items: center;\n  text-align: center;\n  cursor: pointer;\n}\n\n\n\n\n.text_styles_new {\n  font-weight: bold;\n  font-size: 12px;\n  color: #000000;\n}\n\n.mand_doc_child_div {\n  max-height: 60vh;\n  overflow: auto;\n}\n\n.padding_style {\n  margin-top: 2px !important;\n}\n\n.singleInvColrTabs {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n  width: 30%;\n}\n\n.kyc_close_to_expry_txt {\n  position: absolute;\n  top: 90%;\n  bottom: 16.78%;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n\n  /* Importance indicate star mark */\n\n  color: #ED5151;\n}\n\n.notift_btn_txtsize button {\n  font-size: 13px;\n}\n\n.upload_cls label {\n  color: var(--blue-text-color);\n  text-align: end;\n  cursor: pointer;\n  font-weight: 400;\n  font-size: 15px;\n  align-items: center;\n}\n\n.upload_cls article {\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.upload_cls span {\n  font-size: 15px;\n}\n\n.custom-file-input:active {\n  outline: 0;\n}\n\n.custom-file-input:active::before {\n  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);\n}\n\n.ANLtextarea {\n  border: 1px solid #e5e3e3 !important;\n  box-shadow: 0px 2px 10px rgb(0 0 0 / 5%);\n}\n\n.comp_pending_radio_styl {\n  font-weight: 700;\n  font-size: 13px;\n  color: #7C8495;\n}\n\n.settingsSavebtn button {\n  margin-right: 16px;\n  padding: 8px 24px !important;\n\n}\n\n.settingsSavebtn {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.complaince_pendingLink_notes {\n  border: none !important;\n  box-shadow: 0px 2px 10px rgb(0 0 0 / 5%);\n  height: 12vh;\n\n}\n\n.plus-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.upload-text {\n  color: var(--blue-text-color) !important;\n  font-size: 15px;\n  margin: 5px\n}\n\ntextarea:focus {\n  outline: none !important;\n  border-color: #d3d3d3 !important;\n  box-shadow: 0 0 2px 2px #d1d1d14d !important;\n  caret-color: var(--ben-gray-color);\n}\n\n.message-box {\n  height: 50px;\n  width: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n  color: #292929;\n}\n\ninput:focus {\n  outline: none !important;\n  cursor: pointer;\n}\n\n.ANL_options {\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  gap: 10px;\n}\n\n.dropbtn {\n  color: white;\n  padding: 0px 16px;\n  font-size: 16px;\n  border: none;\n}\n\n.navIcon {\n  padding: 10px;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n  align-content: center;\n  cursor: pointer;\n}\n\n.bell_styl {\n  align-self: center;\n  cursor: pointer;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #ffffff;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  right: 35%;\n  top: 85%;\n  border-radius: 10px;\n}\n\n.dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-content a:hover {\n  background-color: rgb(238, 238, 238);\n  border-radius: 10px;\n}\n\n.dropdown:hover .dropdown-content {\n  display: block;\n  border-radius: 10px;\n}\n\n.mar-0 {\n  margin-left: 0px !important;\n}\n\n.mar-270 {\n  margin-left: 270px !important;\n}\n\n/* .sidenav_txt_span {\n  display: none;\n} */\n\n.sidenav_logo img {\n  width: 100%;\n  padding: 10px;\n  width: 220px;\n}\n\n.row {\n  --bs-gutter-x: 0rem !important;\n}\n\n.row-no-gutter {\n  --bs-gutter-x: 0rem !important;\n}\n\n.row.allow-gutter {\n  --bs-gutter-x: 3rem !important;\n}\n\n.nav_first_child {\n  display: contents;\n}\n\n.nav_first_child p {\n  margin-top: 8px;\n}\n\n.investor_img_upload {\n  font-size: 12px;\n  padding: 5px !important;\n}\n\nspan.blue_btn.investor_img_upload {\n  min-width: 130px;\n}\n\n.navbarTop {\n  background-color: white;\n  height: 71px;\n  top: 0;\n  z-index: 1;\n  position: sticky !important;\n  padding: 0 !important;\n  z-index: 999;\n}\n\n.form-label {\n  font-weight: 700;\n}\n\n.btn_style {\n  text-align: end;\n  align-self: self-end;\n}\n\n.b_style_new {\n  background-image: var(--blue-capsule-img);\n  padding-left: 10px;\n  color: white;\n  margin-left: 5px;\n  background-repeat: no-repeat;\n  width: 80%;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.b_inv_prof_tabs {\n  background-image: var(--blue-capsule-img);\n  padding-left: 10px;\n  color: white;\n  margin-left: 5px;\n  background-repeat: no-repeat;\n  width: 160px;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.b_style_modal {\n  background-image: var(--blue-capsule-img);\n  padding-left: 10px;\n  background-repeat: no-repeat;\n  color: white;\n  margin-left: 5px;\n  width: 80%;\n  height: 46px;\n  border-radius: 12px;\n}\n\n.blue_style_new {\n  background-image: var(--blue-capsule-img);\n  padding-left: 10px;\n  background-repeat: no-repeat;\n  padding-right: 10px;\n  color: white;\n  margin-left: 5px;\n  width: fit-content;\n  border-radius: 12px;\n  max-width: 210px\n}\n\n.gray_style_new {\n  background-image: var(--sesame-capsule-img);\n  padding-left: 10px;\n  padding-right: 10px;\n  color: white;\n  margin-left: 5px;\n  width: fit-content;\n  border-radius: 12px;\n  background-repeat: no-repeat;\n  max-width: 210px\n}\n\n.n_style_new {\n  background-image: var(--sesame-capsule-img);\n  background-repeat: no-repeat;\n  padding-left: 10px;\n  color: white;\n  width: 80%;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.n_inv_prof_tabs {\n  background-image: var(--sesame-capsule-img);\n  background-repeat: no-repeat;\n  padding-left: 10px;\n  color: white;\n  width: 160px;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.n_style_modal {\n  background-image: var(--sesame-capsule-img);\n  background-repeat: no-repeat;\n  padding-left: 10px;\n  color: white;\n  width: 80%;\n  height: 46px;\n  border-radius: 12px;\n}\n\n.g_style_new {\n  background-image: var(--gray-capsule-img);\n  background-repeat: no-repeat;\n  padding-left: 10px;\n  color: white;\n  width: 80%;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.g_inv_prof_tabs {\n  background-image: var(--gray-capsule-img);\n  background-repeat: no-repeat;\n  padding-left: 10px;\n  color: white;\n  width: 160px;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.r_style_new {\n  background-image: url(\"../public/images/red_capsule.svg\");\n  background-repeat: no-repeat;\n  padding-left: 10px;\n  color: white;\n  width: 80%;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.p_style_new {\n  background-image: var(--gray-capsule-img);\n  background-repeat: no-repeat;\n  padding-left: 10px;\n  color: white;\n  width: 80%;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.p_style_comp_pending_pills {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 18px;\n  color: #ffffff;\n}\n\n.r_style_new {\n  background-color: #ed5151;\n  padding-left: 10px;\n  color: white;\n  width: 80%;\n  height: 56px;\n  border-radius: 12px;\n}\n\n.p_style {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 29px;\n  color: #ffffff;\n}\n\n.AllInv_top_tab {\n  position: sticky;\n  top: 114px;\n  z-index: 2;\n}\n\n.allservicereq_tab_styl {\n  border-radius: 15px !important;\n  max-height: 58vh;\n  overflow: auto;\n}\n\n.allservicereq_tab_styl th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n\n}\n\n.allservicereq_tab_styl td {\n  background-color: white !important;\n}\n\n\n.compliance_top_tab {\n  top: 80px;\n  z-index: 2;\n}\n\n.compliance_tab_height {\n  max-height: 350px;\n  overflow: auto;\n  border-radius: 15px;\n  outline: var(--table-outline);\n\n}\n\n.compliance_tab_height th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n\n}\n\n.all_inv_table_head {\n  position: sticky;\n  top: -0.02px;\n  background-color: white;\n  z-index: 3;\n  outline: 1px solid lightgray;\n  font-size: 14px;\n}\n\n.all_inv_newinv_table th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n  font-size: 15px;\n}\n\n.cmp_onb_bus_tab th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n  font-size: 15px;\n}\n\n.all_inv_newinv_table_mod {\n  max-height: 30vh;\n  overflow: auto;\n}\n\n.no_histry_txt {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.allinv_inv_table {\n  height: 45vh;\n  overflow: auto;\n  border-radius: 15px;\n}\n\n.kyc_tab {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: self-end;\n}\n\n.my_serv_custm_notes {\n  max-height: 230px;\n  overflow: auto;\n}\n\n.view_inv_notes {\n  max-height: 150px;\n}\n\n.newloan_notes {\n  max-height: 40px;\n  overflow: auto;\n}\n\n.servreq_notes {\n  height: 40px;\n  overflow: auto;\n}\n\n.loan_type_servicereq {\n  max-height: 12vh;\n  overflow: auto;\n}\n\n.payemnt_details_BS_form_conrtl input::placeholder {\n  font-size: 15px !important;\n  font-weight: 600;\n}\n\n.historyLoader {\n  position: absolute !important;\n  left: 50% !important;\n  top: 50% !important;\n}\n\n.settings_YOE label {\n  margin-bottom: 6px !important;\n}\n\n.settings_BS_form_conrtl input::placeholder {\n  font-size: 12px !important;\n  font-weight: 400;\n}\n\n.investor_table_headers th {\n  position: sticky !important;\n  top: 0 !important;\n  background-color: white !important;\n}\n\n.navbarTopAdmin {\n  top: 0;\n  width: 100% !important;\n  background-color: rgb(245, 245, 245);\n  z-index: 1000;\n  padding: 0 !important;\n}\n\n.admin_body_main {\n  position: sticky !important;\n  top: 0 !important;\n  background-color: white;\n  z-index: 1;\n  padding: 0px 48px;\n}\n\n.admin_serv {\n  font-size: 24px;\n  margin: 5px;\n  cursor: pointer;\n  color: var(--gray-text-color);\n}\n\n/* .mar_top {\n  margin-top: 100px !important;\n} */\n\n.indiv_loan_dtls {\n  cursor: pointer;\n}\n\n.indiv_loan_dtls {\n  width: 15px;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.hidden_eye_style {\n  width: 15px;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.indiv_loan_dtls_eye {\n  cursor: pointer;\n  width: 24px;\n}\n\n.admin-cards {\n  min-height: 230px;\n  cursor: pointer;\n  width: 300px !important;\n  background-color: rgb(255, 255, 255) !important;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);\n  margin-top: 20px !important;\n}\n\n.text_st1 {\n  font-weight: 500;\n  font-size: 13px;\n  color: #292929;\n}\n\n.exp_date {\n  color: #7c8495;\n  font-weight: 700;\n  font-size: 14px;\n  margin-top: 1px;\n}\n\n.up_new {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 15px;\n  text-decoration-line: underline;\n  cursor: pointer;\n  color: var(--blue-text-color);\n}\n\n.card_paragraph {\n  font-weight: 450;\n  margin-top: 5px;\n  font-size: 14px !important;\n  text-align: center !important;\n  color: #7c8495 !important;\n}\n\n.rejected_reason span {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.disable-link {\n  pointer-events: none;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--sesame-color);\n  border-radius: 10px;\n\n}\n\n::-webkit-scrollbar-track-piece {\n  background: #e4e3e3;\n  border-radius: 10px;\n}\n\n.db_rp_table th {\n  font-size: small;\n  font-weight: 400;\n  padding: 0px -10px;\n  position: sticky;\n  top: 0;\n  background-color: #F8F6F3 !important;\n}\n\n.db_rp_table td {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 15px;\n  color: #292929;\n}\n\n.my_loan_table {\n  max-height: 55vh;\n  overflow: auto;\n  background-color: white;\n  border-radius: 15px !important;\n\n}\n\n.my_loan_table td {\n  text-align: center;\n}\n\n.fin tbody td {\n  font-weight: 500;\n}\n\n.loan_purpose_field {\n  max-height: 8.5vh;\n  overflow: auto;\n}\n\n.inv_my_servicereq_table {\n  max-height: 58vh;\n  overflow: auto;\n  background-color: white;\n  border-radius: 15px !important;\n}\n\n.inv_my_servicereq_table td {\n  text-align: center;\n}\n\n.busns_histry_table_main {\n  max-height: 75vh;\n  overflow: auto;\n  border-radius: 15px;\n  box-shadow: inset 0px -1px 0px rgba(102, 102, 102, 0.08);\n}\n\n.busns_histry_table td {\n  background-color: white !important;\n  padding-left: 25px !important;\n\n}\n\n.busns_histry_table th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n  padding-left: 25px !important;\n\n}\n\n.cmp_onb_bus_tab {\n  border-radius: 15px;\n  outline: var(--table-outline);\n}\n\n.all_inv_newinv_table {\n  max-height: 58vh !important;\n  overflow: auto;\n  border-radius: 15px;\n  outline: var(--table-outline);\n\n}\n\n.adminall_inv_newinv_table {\n  height: 58vh !important;\n  overflow: auto;\n  border-radius: 15px;\n}\n/* Cells line up under the centred headers (a global `td { text-align: left }` pulled them left, QA #29). */\n.adminall_inv_newinv_table td {\n  text-align: center;\n}\n\n.invfullproftable {\n  height: 40vh !important;\n  overflow: auto;\n  border-radius: 15px;\n  outline: var(--table-outline);\n\n  width: 80%;\n}\n\n.invfulprflabout {\n  max-height: 40vh;\n  overflow: auto;\n}\n\n.aboutInvfulprfl {\n  height: 55px;\n  min-width: 50rem;\n}\n\n.document_tab_modal {\n  max-height: 250px;\n  overflow: auto;\n}\n\n.bus_doc_modal_tabl {\n  max-height: 250px;\n  overflow: auto;\n}\n\n.doc_repo_inv_table {\n  max-height: 47vh;\n  overflow: auto;\n  border-radius: 15px;\n}\n\n.doc_repo_inv_table th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.admin_all_busns_tabl {\n  height: 58vh;\n  overflow: auto;\n  border-radius: 15px;\n  outline: var(--table-outline);\n\n}\n\n.admin_all_busns_tabl th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.admin_each_ln_pop {\n  height: 45px;\n}\n\n.busns_each_ln_pop {\n  height: 35px;\n}\n\n.my_loan_table th {\n  text-align: center;\n  vertical-align: middle;\n  position: relative;\n}\n\n.inv_kyc_table {\n  max-height: 65vh;\n  overflow: auto;\n  border-radius: 15px !important;\n}\n\n.inv_kyc_table th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.inv_profile_kyc_table {\n  max-height: 50vh;\n  overflow: auto;\n  border-radius: 15px !important;\n}\n\n.inv_profile_kyc_tablepop {\n  max-height: 40vh;\n  overflow: auto;\n  border-radius: 15px !important;\n}\n\n.inv_profile_kyc_table th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.inv_profile_kyc_tablepop th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n\n@media screen and (min-width: 1860px) {\n  .table-responsive {\n    max-height: 68vh;\n  }\n\n  .inv_opp_table {\n    max-height: 25vh !important;\n  }\n\n  .emailmaindiv {\n    gap: 80px;\n    margin-top: 3rem;\n  }\n\n  .password_msg {\n    right: 15% !important;\n    top: 34% !important;\n  }\n\n  .notif_main_div {\n    max-height: 80vh;\n  }\n\n  .line_height_settings {\n    max-height: 75vh !important;\n    overflow: auto;\n  }\n\n  .singl_inv_tabl {\n    max-height: 60vh !important;\n  }\n\n  .inv_my_servicereq_table {\n    max-height: 70vh !important;\n  }\n\n  .mytrx_myrecpts {\n    max-height: 75vh;\n  }\n\n  .allservicereq_tab_styl {\n    max-height: 68vh !important;\n  }\n\n  .compliance_tab_height {\n    max-height: 68vh;\n  }\n\n  .typ_of_feclty_labels {\n    max-height: 20vh !important;\n  }\n\n  .percent_first {\n    height: 5vh !important;\n  }\n\n  .bus_dashboard_width {\n    max-height: 35vh;\n    min-height: 31vh;\n  }\n\n\n  .myinvestmts_table_div {\n    max-height: 75vh !important;\n  }\n\n  .my_loan_table {\n    max-height: 63vh;\n  }\n\n  .eachloan_table {\n    max-height: 50vh;\n  }\n\n  .myservice_table_div {\n    max-height: 74vh !important;\n  }\n\n  .doc_repo_inv_table {\n    max-height: 65vh;\n  }\n\n  .perticlr_bus_table {\n    max-height: 70vh !important;\n  }\n\n  .all_inv_newinv_table {\n    max-height: 69vh !important\n  }\n\n  .adminall_inv_newinv_table {\n    height: 69vh !important;\n  }\n\n  .admin_all_busns_tabl {\n    height: 70vh !important;\n  }\n\n  .allinv_inv_table {\n    height: 65vh !important;\n  }\n\n  .bar_chart_inv_db canvas {\n    width: 680px !important;\n    height: 250px !important;\n  }\n\n  .inv_db_currency {\n    height: 15px;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 15px;\n    color: #7C8495;\n\n\n  }\n\n  .inv_db_tinv {\n    width: 100px;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 15px;\n    margin-left: 53px;\n\n    color: #7C8495;\n\n  }\n\n  .inv_db_currency {\n    height: 15px;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 15px;\n    color: #7C8495;\n    padding-left: 60px;\n\n\n  }\n\n  .inv_db_currency ol {\n    /* padding-left: 30px!important; */\n    justify-content: space-between;\n  }\n\n\n  .inv_db_currency ol {\n    padding-left: 15px !important;\n    padding-right: 9px !important;\n  }\n\n  .confirm_inv_btn {\n    left: 0;\n    right: 0;\n    text-align: center;\n    margin: 15px !important;\n  }\n\n  .bar_chart_inv_db {\n    height: 250px !important;\n  }\n\n  .InvOpp_right_tab {\n    max-height: 730px !important;\n  }\n\n  .blue_tab {\n    padding: 18px;\n  }\n\n  .sesame_tab {\n    padding: 18px;\n  }\n}\n\n@media screen and (max-width: 920px) {\n  /* * {\n    opacity: 60%;\n  } */\n\n  .inv_opp_table {\n    max-height: 38vh !important;\n  }\n\n  .blue_btn {\n    padding: var(--btn-sm-padding);\n    width: 160px;\n    line-height: 8px;\n    font-size: 12px;\n    font-weight: 400;\n  }\n\n  .gray_btn {\n    padding: var(--btn-sm-padding);\n    line-height: var(--btn-sm-lh);\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  .login_main_img {\n    object-fit: cover;\n    max-width: 100%;\n    height: 100%;\n  }\n\n  .login_main {\n    background: none;\n    max-width: 100%;\n    height: auto;\n  }\n\n  .login_input_space {\n    min-width: 100%;\n  }\n\n  .nav-tabs .nav-item.show .nav-link,\n  .nav-tabs .nav-link.active {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 19px;\n    margin-bottom: 20px;\n  }\n\n  .nav-tabs .nav-item.show .nav-link,\n  .nav-tabs .nav-link {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    margin-bottom: 20px;\n  }\n\n  .login_txt {\n    display: flex;\n    z-index: 10;\n    transform: rotate(90deg);\n    height: 200px;\n    margin: auto;\n    left: 50%;\n  }\n\n  .sidenavbar_cls {\n    display: none;\n  }\n\n  .dropdown-content {\n    right: -100%;\n  }\n\n  .admin_body_main {\n    position: sticky !important;\n    top: 0 !important;\n    background-color: white;\n    z-index: 1;\n    padding: 0px 14px 0px 14px;\n  }\n\n  .sidenavbar {\n    display: none !important;\n  }\n}\n\n.Financials_tab .table-responsive {\n  max-height: 450px !important;\n  overflow-y: auto !important;\n\n}\n\n.h6_style {\n  font-weight: 400;\n  font-size: 16px;\n  font-weight: 400;\n  color: #000000;\n}\n\n.modal-footer {\n  padding: 5px 10px !important;\n}\n\n.forgot_pwd {\n  color: var(--ben-gray-color) !important;\n  float: end !important;\n  cursor: pointer;\n}\n\nselect,\ninput {\n  border: none !important;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05) !important;\n  border-radius: 5px !important;\n  border: 1px solid #f8f8f8 !important;\n}\n\n.percent_symbol {\n  padding: 0px 10px !important;\n  background-color: white !important;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05) !important;\n  border: 1px solid #f8f8f8 !important;\n\n}\n\n.paymnt_details_amt {\n  padding: 0px 10px !important;\n  background-color: white !important;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05) !important;\n  border: 1px solid #f8f8f8 !important;\n}\n\n.kycFiledstyle {\n  border: 1px solid lightgray;\n  padding: 8px;\n  border-radius: 5px;\n  background-color: #f0efef;\n}\n\n.kyc_upload_cls {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.kyc_upload_cls tr {\n  display: flex;\n  justify-content: space-between;\n}\n\n.upload_cls input {\n  box-shadow: none !important;\n}\n\n.gray-text {\n  color: var(--gray-text-color);\n}\n\n.sesame-color {\n  color: var(--sesame-color);\n}\n\n.bg-sesame {\n  background-color: var(--sesame-color) !important;\n}\n\n.forgot_pwd_main {\n  margin-top: 25px !important;\n  margin-bottom: 25px !important;\n  margin: auto;\n}\n\n.reset_third_modal .forgot_pwd_main {\n  padding: 0px 15px !important;\n\n}\n\n.forgot_pwd_main h5 {\n  text-align: center;\n  height: 24px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -0.02em;\n  color: #292929;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin: auto;\n}\n\n.forgot_pwd_main p {\n  height: 12px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 12px;\n  letter-spacing: -0.02em;\n  color: #7C8495;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.forgot_pwd_main .input_email {\n  border: 0.5px solid #BABABA !important;\n  border-radius: 6px;\n}\n\n.forgot_pwd_main .reset_btn {\n  width: 230px;\n  height: 30px;\n  background: var(--blue-text-color);\n  border: 0.5px solid var(--blue-text-color);\n  border-radius: 6px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  color: white;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 15px;\n}\n\n.forgot_pwd_main .reset_btn:disabled {\n  opacity: 50%;\n\n}\n\n.new_password_crossmark {\n  position: absolute;\n  right: 4%;\n  top: 4%;\n  cursor: pointer;\n}\n\n.forgot_pwd_main .reset_txt {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  color: #FFFFFF;\n\n}\n\n.newpwd_min_height {\n  height: 33vh !important;\n}\n\n.compl_bus_actions_td {\n  min-width: 130px;\n  display: flex;\n  justify-content: center;\n}\n\n.compl_bus_actions_td_business_kyc {\n  min-width: 130px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.hide_pwd_icon {\n  position: absolute;\n  right: 8%;\n  bottom: 58%;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.passwd_criteria {\n  color: red;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.passwd_crit_reset {\n  color: red;\n  font-size: 11px;\n}\n\n.newpswd_btn_styl {\n  width: 100%;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  bottom: 0;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.opt_field_boxes {\n  justify-content: space-evenly;\n  margin: 25px 15px 8px 15px;\n}\n\n.opt_field_boxes input {\n  width: 30px;\n  height: 30px;\n  border: 0.5px solid #BABABA !important;\n  border-radius: 6px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  text-align: center;\n}\n\n.resend_main {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: center;\n  gap: 11px;\n  align-items: center;\n  margin-bottom: 20px\n}\n\n.resend_otp_txt {\n  display: flex;\n  justify-content: center;\n  gap: 3px;\n  text-align: center;\n  margin-bottom: 30px;\n\n  height: 12px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 300;\n  font-size: 10px;\n  line-height: 12px;\n  letter-spacing: -0.02em;\n  color: #7C8495;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.resend_style {\n  color: #ED5151;\n  font-weight: 600;\n  font-size: 11px;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background-color: transparent;\n\n}\n\n.resend_style:hover {\n  text-decoration: underline #ED5151;\n}\n\n.resend_style:disabled:hover {\n  text-decoration: none;\n  cursor: default;\n}\n\n.sesam_color_backto {\n  display: flex;\n  justify-content: center;\n  gap: 5px;\n  height: 12px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.02em;\n  color: var(--sesame-color);\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  margin-top: 25px;\n  cursor: pointer;\n\n}\n\n.ml_lrn {\n  color: var(--gray-text-color);\n  font-weight: 600;\n  font-size: 24px;\n}\n\n.Cpointer {\n  cursor: pointer;\n}\n\n.buttons-wrapper {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.button-wrapper {\n  margin: 5px;\n  width: max-content;\n}\n\n.table-responsive {\n  max-height: 58vh;\n  overflow: auto;\n}\n\n.sidebarprohead a {\n  text-decoration: none !important;\n  color: white !important;\n}\n\n.sidebarimg {\n  padding: 20px 0px 20px 20px;\n  cursor: pointer;\n}\n\n.brand_logo_styl {\n  height: 70px;\n  padding: 10px 0px 10px 27px;\n  margin: auto;\n  transition: cubic-bezier(0.075, 0.82, 0.165, 1);\n  cursor: pointer;\n}\n\n.ps-menu-icon {\n  width: 20px;\n  font-size: larger;\n}\n\n.css-kvqf1i {\n  background-color: var(--ben-text-sesame-color) !important;\n  border-bottom-right-radius: 8px;\n  border-top-right-radius: 8px;\n  margin-right: 20px;\n}\n\n.sidebar_li_styl>.ps-active {\n  background-color: var(--ben-text-sesame-color) !important;\n  border-bottom-right-radius: 10px !important;\n  border-top-right-radius: 10px !important;\n  margin-right: 20px !important;\n}\n\n.ps-menu-button:hover {\n  background-color: transparent !important;\n}\n\n.sidebar_li_styl>.ps-active:hover {\n  background-color: var(--ben-text-sesame-color) !important;\n  border-bottom-right-radius: 10px !important;\n  border-top-right-radius: 10px !important;\n  margin-right: 20px !important;\n}\n\n.db_body {\n  max-height: 88vh;\n  overflow-y: auto;\n  /* max-width: 1670px; */\n}\n\n.content_main_body {\n  padding: 20px 35px;\n}\n\n.bus_dashboard_width {\n  max-width: 1400px;\n  min-height: 43vh;\n}\n\n.totl_repaid_div .totl_repaid {\n  color: #7C8495;\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 8px;\n}\n\n.card_footer_color .TOA {\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 21px;\n  color: var(--blue-text-color);\n}\n\n.totl_repaid_div b {\n  color: var(--ben-text-sesame-color);\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px\n}\n\n.totl_outstng {\n  font-weight: 700;\n  font-size: 11.5px;\n  color: var(--blue-text-color);\n  text-align: center;\n}\n\n.db_first_card_footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\n.db_hr_polygon_div img {\n  position: absolute;\n  left: 50%;\n  margin-top: -2px;\n}\n\n.datepickermom_report input {\n  height: 30px;\n}\n\n.momreport_details_popup span {\n  font-weight: 700;\n  font-size: 14px;\n  padding-left: 0px !important;\n}\n\n.admin_eachloan_modal_main {\n  height: 35rem !important;\n}\n\n.eachloan_table {\n  max-height: 30vh;\n  overflow-y: auto;\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n}\n\n.gray_border {\n  height: 1px;\n  border: 1px solid var(--ben-text-sesame-color);\n}\n\n.card_footer_color {\n  background-color: #f8f6f3 !important;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.db_hr_styl {\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n}\n\n.typ_of_feclty_labels {\n  max-height: 23.5vh;\n  overflow: auto;\n  align-self: center;\n}\n\n.kyc_confirmation {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 24px;\n  margin-left: 10px;\n}\n\n.db_cos_card_main h6 {\n  color: var(--blue-text-color);\n}\n\n.Admin_eachL_popup {\n  background-color: #F8F6F3;\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n\n}\n\n.invSubtextareafont .form-control {\n  font-size: 16px !important;\n}\n\n.card_title_txt article {\n  margin-bottom: 10px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  color: #292929;\n}\n\n.doughnut_div canvas {\n  padding-bottom: 10px;\n}\n\n.secondrowcard_height {\n  height: 250px !important;\n}\n\n.bus_db_secondrowcard_height {\n  height: 260px !important;\n}\n\n.dash_b_RRP_table_div {\n  max-height: 29vh;\n  overflow: auto;\n}\n\n.no_doc_styl {\n  margin-left: -50px;\n}\n\n.bd_viewall {\n  cursor: pointer;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n  color: #000000;\n}\n\n.doughnut_card {\n  max-width: 450px !important;\n\n}\n\n.inv_db_Card_Size {\n  max-width: max-content;\n}\n\n.inv_db_Card_Size article {\n  width: 83px;\n  height: 24px;\n  left: 337px;\n  top: 624px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20.0853px;\n  line-height: 24px;\n  color: #292929;\n\n}\n\n.secondrowcard_height article {\n  height: 24px;\n  left: 862.96px;\n  top: 624.96px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20.0853px;\n  line-height: 24px;\n  color: #292929;\n}\n\n.dropdn_select_cls {\n  display: block !important;\n  padding-left: 12px !important;\n  padding-right: 31px !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.settings_YOE .dropdn_select_cls_settings {\n  height: 40px;\n  border: 1px solid #e5e3e3 !important;\n}\n\n.dropdn_select_cls_settings {\n  display: block !important;\n  padding-left: 12px !important;\n  padding-right: 31px !important;\n  padding-top: 2px !important;\n  padding-bottom: 4px !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.modal-header {\n  padding: 10px 15px !important;\n}\n\n.modal-body {\n  padding: 0px 10px !important;\n}\n\n.modal-footer {\n  padding: 2px 5px !important;\n}\n\nhr {\n  margin: 10px 0px !important;\n\n}\n\n.form-control {\n  padding: 3px 5px !important;\n\n\n}\n\n.field-control {\n  padding: 7px 5px !important;\n  width: 95% !important;\n  border: 2px solid hsl(220, 13%, 91%);\n  border-radius: 6px;\n  outline: none;\n}\n\n.field-control-name {\n  padding: 7px 5px !important;\n  width: 98% !important;\n  border: 2px solid #e5e7eb;\n  border-radius: 6px;\n  outline: none;\n}\n\n.prefooter {\n  margin-bottom: 5px !important;\n}\n\n.skeleton_mrgn {\n  margin: 10px;\n}\n\n\n.notif_main {\n  display: flex !important;\n  justify-content: flex-end !important;\n  margin-bottom: 15px !important;\n  padding-right: 24px;\n\n}\n\n.notifCount {\n  background-color: var(--blue-text-color);\n  position: absolute;\n  border-radius: 50px;\n  min-width: 17px;\n  min-height: 17px;\n  color: white;\n  text-align: center;\n  align-content: center;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  right: -5px;\n  padding: 1px;\n  top: -5px;\n\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n  isolation: initial !important;\n}\n\n.belldotblue {\n  background-color: var(--blue-text-color);\n  position: absolute;\n  border-radius: 50px;\n  width: 10px;\n  height: 10px;\n  top: 30%;\n  right: 100%;\n\n}\n\n.toast_main_div {\n  z-index: 100 !important;\n}\n\n.toast_viewdetails {\n  width: 71px;\n  height: 12px;\n  cursor: pointer;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 12px;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: var(--blue-text-color);\n\n}\n\n.toast_viewdetails:hover {\n  text-decoration: underline var(--blue-text-color);\n\n}\n\n.offcanvas-header {\n  padding-bottom: 0px !important;\n}\n\n.toast_dismiss {\n  width: 45px;\n  height: 12px;\n  cursor: pointer;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 12px;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: rgba(207, 24, 24, 0.808);\n\n}\n\n.notifpanestyl .notif_time {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 10px;\n  padding-left: 15px;\n}\n\n.notifpanestyl .notif_txt {\n  padding: 10px;\n  margin-right: 10px;\n  align-self: center;\n}\n\n.notif_main_active_home {\n  background: var(--ben-text-sesame-color) ! important;\n  border: 1px solid var(--ben-text-sesame-color) ! important;\n  border-radius: 6px 0px 0px 6px ! important;\n  color: white ! important;\n  cursor: pointer;\n  width: 78px;\n  text-align: center;\n}\n\n.notif_main_active_profile {\n  background: var(--ben-text-sesame-color) ! important;\n  border: 1px solid var(--ben-text-sesame-color) ! important;\n  border-radius: 0px 6px 6px 0px ! important;\n  color: white ! important;\n  cursor: pointer;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .notif_main_active_home {\n  color: white ! important;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 13px;\n\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .notif_main_active_profile {\n  color: white ! important;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 13px;\n}\n\n.notifpanestyl {\n  background: #FFFFFF;\n  border-radius: 6px;\n  min-height: 74px;\n  display: flex !important;\n  margin-bottom: 20px !important;\n}\n\n.notif_date {\n  left: 2.03%;\n  right: 86.15%;\n  top: 29.73%;\n  bottom: 50%;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 15px;\n  color: #292929;\n}\n\n.notif_time p {\n  left: 2.03%;\n  right: 93.07%;\n  top: 54.05%;\n  bottom: 29.73%;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 12px;\n  color: #7C8495;\n\n}\n\n.nodataStyl {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 14px !important;\n  font-weight: 700 !important;\n\n}\n\n.notif_main_div {\n  max-height: 72vh;\n  overflow: auto;\n}\n\n.notifinactivestyle_home {\n  background: white ! important;\n  border: 1px solid white ! important;\n  border-top-left-radius: 6px !important;\n  border-bottom-left-radius: 6px !important;\n  color: #7C8495 ! important;\n  cursor: pointer;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  line-height: 13px !important;\n  width: 78px;\n  text-align: center;\n\n}\n\n.notifinactivestyle_profile {\n  background: white ! important;\n  border: 1px solid white ! important;\n  border-top-right-radius: 6px !important;\n  border-bottom-right-radius: 6px !important;\n  color: #7C8495 ! important;\n  cursor: pointer;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  line-height: 13px !important;\n}\n\n.box {\n  display: flex;\n  height: 150px;\n  width: 50px;\n  border: 1px solid black;\n\n}\n\n.Indiv_notif_styl {\n  border: 1px solid #ececec;\n  padding: 10px;\n  margin-bottom: 8px;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.notif_msg_heigt {\n  line-height: 20px;\n}\n\n.notification_menu {\n  min-width: 500px !important;\n  max-height: 85vh;\n  overflow: auto;\n  padding: 15px;\n}\n\n.admin_notif_sidebar {\n  max-height: 95vh;\n  top: 0.5% !important;\n  overflow: auto;\n  border-radius: 5px;\n  right: 0.5% !important;\n  width: 445px !important;\n}\n\n.inv_notif {\n  height: max-content;\n  top: 1% !important;\n  right: 1% !important;\n  border: 1px solid rgb(124, 122, 122);\n}\n\n.slide-in {\n  background-color: var(--ben-gray-color);\n  color: white;\n  width: 200px;\n  margin-left: -480px;\n  transition-property: margin-left;\n  transition-duration: 500ms;\n  z-index: 10;\n}\n\n\n.expirydangerstyl {\n  color: #ED5151;\n  font-weight: 700;\n\n}\n\n.onClickApplyLoaderStyl {\n  position: absolute;\n  left: 0;\n  right: 0;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.048);\n}\n\n.loader_style {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 57%;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  color: var(--blue-text-color);\n}\n\n.titleplusedit {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.titleplusedit h1 {\n  margin-bottom: 0px !important;\n  align-self: end;\n}\n\n.profileBusDetailstab {\n  background: #FFFFFF;\n  border-radius: 12px;\n  padding: 16px;\n  margin-top: 16px !important;\n  min-height: 50vh !important;\n\n}\n\n.settingsmaindiv {\n  background: #FFFFFF;\n  border-radius: 12px;\n  padding: 12px 18px;\n  margin-top: 16px !important;\n}\n\n.image_uploadbtndiv {\n  position: relative;\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  justify-content: center;\n}\n\n.image_uploadbtndiv .blue_btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}\n\n.image_uploadbtndiv .blue_btn img {\n  width: 18px !important;\n  height: 18px !important;\n  margin-right: 5px;\n  width: 100%;\n  height: auto;\n\n}\n\n.inv_image_uploadbtndiv .blue_btn {\n  position: absolute;\n}\n\n.inv_image_uploadbtndiv .blue_btn img {\n  width: 18px !important;\n  height: 18px !important;\n  width: 100%;\n\n}\n\n.inv_image_uploadbtndiv label {\n  margin-bottom: 25px;\n\n}\n\n.inv_image_uploadbtndiv {\n  padding-left: 0px !important;\n}\n\n.inv_image_uploadbtndiv img {\n  margin-right: 5px;\n  width: 180px;\n  height: 160px;\n  border-top-left-radius: 15px;\n  border-bottom-left-radius: 15px;\n\n}\n\n.profile_maindiv2 .col img {\n  width: 547px;\n  height: 155px;\n  border-radius: 5px;\n}\n\n.profMainDiv {\n  max-height: 85vh;\n  overflow: auto;\n}\n\n.expiredtxt {\n  color: #ED5151;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n}\n\n.bus_summary {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: #7C8495;\n\n}\n\n.bus_summary b {\n  color: black;\n}\n\n.bus_summary p {\n  max-height: 12vh;\n  overflow: auto;\n}\n\n\n\n\n\n.text_styles {\n  text-align: center;\n  width: 180px;\n  height: 19px;\n  color: var(--ben-text-sesame-color);\n  font-size: 18px;\n  font-weight: 700;\n\n}\n\n.text_st {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n  color: #7c8495;\n}\n\n.text_ststrong {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 15px;\n  color: #7c8495;\n}\n\n.gray_btn_lg {\n  align-items: center;\n  padding: 8px 24px;\n  width: 426px;\n  height: 54px;\n  background: var(--ben-text-sesame-color);\n  border-radius: 6px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  border: none;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 24px;\n  text-align: center;\n  color: #FFFFFF;\n}\n\n.gray_btn_lg:disabled {\n  opacity: 60%;\n}\n\n.text_st_status {\n  line-height: 15px;\n  color: #7c8495;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.text_st_new {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  display: flex;\n  align-items: center;\n  /* Titles */\n  color: #292929;\n}\n\n.text_bolder {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--blue-text-color);\n}\n\n.text_bolder_sr {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 17px;\n  color: var(--blue-text-color);\n  cursor: pointer;\n}\n\n.text_bolder_business {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 17px;\n  color: #178f17;\n  cursor: pointer;\n}\n\n.text_bolder_business_v1 {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 17px;\n  color: #059669;\n}\n\n.text_bolder_investor {\n  font-size: 14px;\n  line-height: 17px;\n  text-decoration-line: underline;\n  color: var(--blue-text-color);\n  cursor: pointer;\n}\n\n.text_bolde_doc {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  display: flex;\n  align-items: center;\n  color: var(--blue-text-color);\n  justify-content: right;\n\n}\n\n.doc_tab_height {\n  max-height: 100px !important;\n  overflow: auto;\n}\n\n.admineachloan_table {\n  max-height: 50px;\n  overflow: auto;\n}\n\n.admin_eachloanNotes {\n  max-height: 200px;\n  overflow: auto;\n}\n\n.loan_purps_notes {\n  max-height: 80px;\n  overflow-y: auto;\n}\n\n.d_view_table {\n  max-height: 250px;\n  overflow-y: auto;\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n}\n\n.allinv_doc_tab_styl {\n  border-radius: 15px;\n  outline: var(--table-outline) !important;\n}\n\n.allinv_rightmrk_paydetails th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.allinv_rightmrk_paydetails {\n  border-radius: 15px !important;\n  max-height: 35vh;\n  overflow: auto;\n  outline: var(--table-outline);\n}\n\n.allinv_rightmrk_paydetails td {\n  background-color: white;\n}\n\n.detld_view_LH {\n  max-height: 350px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.bolder_text {\n  font-weight: 700;\n  font-size: 14px;\n  color: #292929;\n}\n\n.bolder_text_textarea {\n  font-weight: 700 !important;\n  font-size: 14px !important;\n  color: #292929 !important;\n}\n\n.bolder_textstrong {\n  font-weight: 700;\n  font-size: 16px;\n  color: #292929;\n}\n\n.payment_details_text {\n  margin-bottom: 10px;\n\n}\n\n.heading_new_loan {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n\n  color: #292929;\n}\n\n.benne_style {\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 0 !important;\n  color: #292929;\n}\n\n.bolder_text_p_fees {\n  font-weight: 700;\n  font-size: 16px;\n  color: #292929;\n}\n\n.radio_btn {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 17px;\n}\n\n.style_mb {\n  font-weight: 700;\n  font-size: 14px;\n  color: #292929;\n}\n\n.style_input {\n  height: 20px;\n  width: 20px;\n  vertical-align: middle;\n\n  background: #e6ebf8;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.style_input_radio {\n  height: 16px;\n  width: 16px;\n  vertical-align: middle;\n  background: #e6ebf8;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.PD_input_radio {\n  height: 16px;\n  width: 16px;\n  vertical-align: middle;\n  background: #E6EBF8;\n  accent-color: var(--blue-text-color);\n}\n\n.admin_PD_radio_div label {\n  cursor: pointer;\n\n}\n\n.admin_PD_tabs h5 {\n  font-weight: 400 !important;\n  font-size: 18px !important;\n  line-height: 24px !important;\n\n}\n\n.no_opp {\n  text-align: center;\n  position: absolute;\n\n  top: 50%;\n  left: 45%;\n  color: #7c8495;\n  bottom: 50%;\n}\n\n.no_opp h1 {\n  font-weight: 700 !important;\n\n}\n\n.admin_PD_tabs {\n  height: 24px;\n}\n\n.rating_txt_d {\n  background: var(--ben-grade-d);\n  color: var(--ben-navy);\n  width: 47px;\n  height: 46px;\n  border-radius: 6px;\n}\n\n.rating_txt_a {\n  background: var(--ben-grade-a);\n  color: white;\n  width: 47px;\n  height: 46px;\n  border-radius: 6px;\n}\n\n.ten_text {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  color: #7c8495;\n}\n\n.reason_text {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: var(--ben-text-sesame-color);\n}\n\n.business_text {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 24px;\n  color: var(--ben-text-sesame-color);\n}\n\n.rating_txt_b {\n  background: var(--ben-grade-b);\n  color: white;\n  width: 47px;\n  height: 46px;\n  border-radius: 6px;\n}\n\n.rating_txt_c {\n  background: var(--ben-grade-c);\n  color: var(--ben-navy);\n  width: 47px;\n  height: 46px;\n  border-radius: 6px;\n}\n\n/* Light grade backgrounds (C sesame, D grey) need navy text for contrast; .bb forces white. */\n.rating_txt_c .bb,\n.rating_txt_d .bb {\n  color: var(--ben-navy);\n}\n\n.bb {\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  color: #ffffff;\n  padding: 7px 5px;\n  text-align: center !important;\n}\n\n.text_st_ranking {\n  font-weight: 600;\n  font-size: 14px;\n  color: #7c8495;\n  line-height: 15px;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.kyc_style_doc {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n}\n\n.admin_rej_modal {\n  min-height: 10vh;\n  vertical-align: middle;\n  margin: auto;\n  padding: 15px 0px !important;\n}\n\n.css-16jkw2k>.ps-menu-button:hover {\n  background-color: transparent !important;\n}\n\n.css-eh8qic>.ps-menu-button {\n  background-color: var(--ben-text-sesame-color);\n  border-bottom-right-radius: 10px;\n  border-top-right-radius: 10px;\n  margin-right: 20px;\n}\n\n.css-eh8qic>.ps-menu-button:hover {\n  background-color: var(--ben-text-sesame-color) !important;\n}\n\n.business_name {\n  font-size: 1em;\n  color: var(--blue-text-color);\n  text-decoration: underline;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n\n\n.css-eh8qic>.ps-menu-button:hover {\n  background-color: var(--ben-text-sesame-color);\n}\n\n.myloan_table_headers {\n  vertical-align: middle;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  outline: var(--table-outline);\n  font-size: 14px;\n}\n\n.table>thead {\n  vertical-align: middle !important;\n}\n\n.green-title {\n  color: #059669;\n}\n\n.head_threedots h5 {\n  text-align: end;\n  margin-right: 3.5rem;\n  font-weight: 700;\n  font-size: 8px;\n\n}\n\n.myservicereq_table {\n  max-height: 100px;\n\n}\n\n.head_onedot h5 {\n  text-align: start;\n  margin-left: -0.5rem;\n  font-weight: 700;\n  font-size: 8px;\n}\n\n.head_fourdots h5 {\n  text-align: end;\n  margin-right: -2rem;\n  font-weight: 700;\n  font-size: 8px;\n\n}\n\n.btn-close:focus {\n  box-shadow: none !important;\n}\n\n.uploadKYCDocBsnsDB {\n  margin-bottom: 0px;\n  font-weight: bolder;\n  padding-right: 0px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--blue-text-color);\n\n}\n\n.uploadKYCDocBsnsDB:hover {\n  text-decoration: underline;\n}\n\n.rate_percent {\n  padding: 10px;\n  background-color: white;\n}\n\n\n.myinvestmts_table_div {\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n  max-height: 65vh;\n  overflow: auto;\n}\n\n.mytrx_myrecpts {\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n  max-height: 70vh;\n  overflow: auto;\n\n}\n\n.mytrx_myrecpts th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.mytrx_myrecpts td {\n  background-color: white !important;\n}\n\n.mypaymentdetails {\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n  max-height: 40vh;\n  overflow: auto;\n}\n\n.mypaymentdetails th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.mypaymentdetails td {\n  background-color: white !important;\n}\n\n.inwithbusdetlastcard {\n  height: 60vh;\n}\n\n.invFullprofInvid h4 {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  color: var(--blue-text-color);\n\n}\n\n.mytrx_mypaymnts {\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n  max-height: 70vh;\n  overflow: auto;\n}\n\n.mytrx_mypaymnts th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n\n}\n\n.mytrx_mypaymnts td {\n  background-color: white !important;\n\n}\n\n.bus_kyc_table {\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n  max-height: 72vh;\n  overflow: auto;\n}\n\n.bus_kyc_table th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n\n}\n\n.table_cls {\n  border-top: 1px solid lightgray;\n\n}\n\n.popUpImagemodal {\n  max-width: 100vw;\n  padding-bottom: 2rem;\n}\n\n.imagemodalbody {\n  height: 86vh;\n  align-self: center;\n\n}\n\n.password_msg {\n  font-size: 14px;\n  color: rgb(87, 86, 86);\n  position: absolute;\n  right: 5%;\n  top: 37%;\n  font-weight: 500;\n}\n\n.reset_password_const {\n  font-size: 12px;\n  color: rgb(87, 86, 86);\n  margin-top: 10px;\n}\n\n.bootStrp_form_conrtl input {\n  padding: 2px 10px !important;\n  width: -webkit-fill-available;\n  border: none !important;\n  box-shadow: -5px 2px 10px 0px #0000000D;\n  border-radius: 6px 0px 0px 6px !important;\n  border: 1px solid #f8f8f8 !important;\n  max-width: 130px !important;\n}\n\n.payemnt_details_BS_form_conrtl {\n  height: 35px;\n  width: 180px !important;\n}\n\n.payemnt_details_BS_fo_custm {\n  height: 35px;\n  width: 235px !important;\n}\n\n.pymnt_dtls_amt_edit_field input {\n  width: 100px !important;\n  height: 25px;\n}\n\n.custm_brdr input {\n  border: 1px solid rgb(241, 241, 241) !important;\n\n}\n\n.bootStrp_form_conrtl_APNL input {\n  padding: 2px 10px !important;\n  width: -webkit-fill-available;\n  border: none !important;\n  box-shadow: -5px 2px 10px 0px #0000000D;\n  border-radius: 6px 0px 0px 6px !important;\n  border: 1px solid #f8f8f8 !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.rating_button {\n  width: 50px !important;\n  height: 50px !important;\n  color: white;\n  border-radius: 5px;\n  padding: 8px;\n  text-align: center !important;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 29px;\n}\n\n.db_sesame_table_title {\n  background-color: #F8F6F3;\n  font-style: normal !important;\n  font-size: 12px !important;\n  line-height: 15px !important;\n  align-items: center !important;\n  color: #292929 !important;\n  font-weight: 400;\n}\n\n.ml_indiv_loan_dtls {\n  background-color: #F8F6F3;\n  border-radius: 8px 8px 0px 0px;\n  padding: 5px 24px;\n}\n\n.ml_indiv_loan_dtls label {\n  font-weight: 700;\n  font-size: 14px;\n  color: #7C8495;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  text-align: center;\n  line-height: 14px;\n}\n\n.ml_table_footer {\n  border-radius: 0px 0px 8px 8px;\n  padding: 13px 21px;\n}\n\n.del_bin_style {\n  color: rgba(238, 38, 38, 0.651);\n  cursor: pointer;\n  font-size: 20px;\n  margin: 5px 0px 0px 10px\n}\n\n.count_of_records {\n  margin: auto;\n  text-align-last: right;\n  padding: 25px 10px 0px 0px;\n  color: var(--ptag-font-color);\n\n}\n\n.count_of_records span {\n  font-weight: var(--ptag-font-weight);\n  margin-bottom: 0px !important;\n  line-height: 14.5px;\n  font-size: 18px;\n}\n\n.modal_title h6 {\n  margin-bottom: 0 !important;\n}\n\n.count_of_records_ML {\n  color: var(--ptag-font-color);\n  text-align: end;\n  margin-top: 10px;\n}\n\n.count_of_records_ML span {\n  font-weight: var(--ptag-font-weight);\n  margin-bottom: 0px !important;\n  line-height: 14.5px;\n  font-size: 18px;\n  margin-right: 15px;\n}\n\n@media screen and (min-width:800px) {\n  .inv_opp_table {\n    max-height: 38vh;\n  }\n}\n\n.kyc_man_doc_tab {\n  max-height: 65vh;\n  overflow: auto;\n}\n\n.alert_modal {\n  padding-left: 15px !important;\n  min-height: 6vh;\n  display: flex;\n  align-items: center;\n\n}\n\n.text_style_inv {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: -0.02em;\n  color: #292929;\n}\n\n.count_of_records_ALLSR {\n  color: var(--ptag-font-color);\n  margin-bottom: 10px;\n}\n\n.count_of_records_ALLSR span {\n  font-weight: var(--ptag-font-weight);\n  margin-bottom: 0px !important;\n  line-height: 14.5px;\n  font-size: 18px;\n}\n\n.count_of_records_ML span {\n  font-weight: var(--ptag-font-weight);\n  margin-bottom: 0px !important;\n  line-height: 14.5px;\n  font-size: 18px;\n  margin-right: 15px;\n}\n\n.style_loan {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n  color: #292929;\n}\n\n.style_loan_txt {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n  align-items: center;\n  color: #7C8495;\n}\n\n.lh_custom_style {\n  max-height: 10vh;\n}\n\n.blue_tab {\n  align-items: center;\n  padding: 10px;\n  background: #E6EBF8;\n  border-radius: 8px;\n  width: 145px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.blue_tab p {\n  font-weight: 700;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: var(--blue-text-color);\n  justify-content: center;\n  font-size: 15px;\n}\n\n.sesame_tab {\n  flex-direction: row;\n  align-items: center;\n  text-align: center;\n  padding: 10px;\n  gap: 10px;\n  background: #F8F6F3;\n  border-radius: 8px;\n  width: 145px;\n}\n\n.sesame_tab p {\n  font-weight: 700;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: var(--ben-text-sesame-color);\n  justify-content: center;\n  font-size: 14px;\n}\n\n.blue-text {\n  color: var(--blue-text-color) !important;\n}\n\n.comp_pending_expiry {\n  font-weight: 700;\n  font-size: 12px;\n  display: flex;\n  gap: 5px;\n  color: #292929;\n  line-height: 14px;\n  margin-top: 5px;\n}\n\n.comp_pending_today_expiry_txt {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 14px;\n  align-items: center;\n  color: #ED5151;\n  display: flex;\n  gap: 8px;\n}\n\n.bd_COS_div {\n  height: 10vh;\n  overflow: auto;\n}\n\n.db_cos_curncy {\n  color: var(--blue-text-color);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  text-align: right;\n}\n\n.upload_file_name {\n  color: green;\n  display: flex;\n  align-self: center;\n}\n\n.Q_call_report_table_div {\n  margin-top: 10px;\n  max-height: 29vh !important;\n  overflow: auto;\n}\n\n.allinve_action_td {\n  min-width: 65px;\n}\n\n.momreport_filledupview_doc_styl {\n  max-width: 56vw;\n  margin-bottom: 1rem;\n}\n\n.Q_call_report_headers {\n  position: sticky;\n  top: -1px;\n  background-color: white;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.loan_history_tab {\n  max-height: 35vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.loaan_history_content_styl {\n  max-height: 145px;\n}\n\n.admin_each_history {\n  max-height: 210px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.admin_all_preclosure_body {\n  height: 29.5rem;\n\n}\n\n.preclosure_Table_body {\n  border: var(--table-outline);\n  border-radius: 15px;\n}\n\n.preclosure_Table_body {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.card_styl {\n  max-width: 22rem;\n\n  min-height: 23.5rem;\n}\n\n.btn_background {\n  padding: 12px 32px;\n  width: 98px;\n  height: 39px;\n  background: #F2F3F3 !important;\n}\n\n.pdfLogo {\n  width: 130px;\n  margin: 10px 0px 10px -10px;\n}\n\n.btn_background_sm {\n  width: 98px;\n  height: 35px;\n  background: #F2F3F3 !important;\n}\n\n\n.card_styl img {\n  max-height: 9rem;\n  position: relative;\n}\n\n.card_styl h4 {\n  position: absolute;\n  z-index: 2;\n  padding: 7px 15px;\n\n}\n\n.card_checked {\n  position: absolute;\n  z-index: 3;\n  right: 15px;\n  top: 15px;\n  color: yellow;\n  font-size: 17px;\n}\n\n.rate_A {\n  background-color: var(--ben-grade-a);\n  color: white;\n  border-radius: 6px;\n  margin: 10px;\n}\n\n.rate_B {\n  background-color: var(--ben-grade-b);\n  color: white;\n  border-radius: 6px;\n  margin: 10px;\n\n}\n\n.rate_C {\n  background: var(--ben-grade-c);\n  color: var(--ben-navy);\n  border-radius: 6px;\n  margin: 10px;\n  align-items: center;\n}\n\n.rate_D {\n  background-color: var(--ben-grade-d);\n  color: var(--ben-navy);\n  border-radius: 6px;\n  margin: 10px;\n}\n\n.inv_card_title_cls {\n  display: flex;\n  justify-content: space-between;\n}\n\n.inv_card_title_cls img {\n  height: 15px;\n  width: 15px;\n  cursor: pointer;\n}\n\n.InvOpp_right_tab_card {\n  color: white;\n  text-align: center;\n  padding: 20px 0px;\n  border-top-right-radius: 12px !important;\n  border-top-left-radius: 12px !important;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  right: 0;\n}\n\n.InvOpp_right_tab {\n  min-height: 450px;\n  max-height: 700px;\n  border-radius: 6px;\n  position: relative;\n  background-color: white;\n\n\n}\n\n.inv_opp_card_title {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: white;\n}\n\n.indiv_right_top_bnr {\n  position: relative;\n  border-top-right-radius: 12px;\n  border-top-left-radius: 12px;\n}\n\n.indiv_right_top_bnr img {\n  width: 100%;\n  border-top-right-radius: 11px;\n  border-top-left-radius: 11px;\n}\n\n.inv_card_txt {\n  max-height: 3.5rem;\n  min-height: 3.5rem;\n  overflow-y: auto;\n}\n\n\n.indiv_bus_tilte {\n  display: flex;\n  gap: 20px;\n  margin: 25px 20px;\n  align-items: center;\n  align-content: center;\n  cursor: pointer;\n}\n\n.indiv_bus_tilte h1 {\n  margin-bottom: 0px;\n}\n\n.indiv_busns_top_img {\n  height: 18rem;\n  border: none !important;\n}\n\n.indiv_bus_exp_ret {\n  background-color: #F2F3F3;\n  align-items: center;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.InvOpp_right_tab_bdy {\n  padding: 16px 16px 0px 16px !important;\n  max-height: 580px;\n  /* QA #42: long schedules scroll inside the card instead of pushing Confirm Investment out of it. */\n  min-height: 0;\n  overflow-y: auto;\n\n}\n\n.right-card {\n  min-width: 280px;\n}\n\n.InvOpp_right_tab_bdy .sesam_c {\n  color: var(--sesame-color);\n}\n\n.confirm_inv_btn {\n  left: 0;\n  right: 0;\n  text-align: center;\n\n}\n\n.nav-link-inv {\n  border: none;\n  background-color: transparent;\n  color: #7C8495;\n  margin-bottom: 15px;\n  margin-right: 30px;\n\n}\n\n.nav-link-inv-onboard {\n  border: none;\n  background-color: transparent;\n  color: #7C8495;\n\n  margin-right: 30px;\n\n}\n\n.nav-link-settingsProf {\n  border: none;\n  background-color: transparent;\n  color: #7C8495;\n  margin-bottom: 0px !important;\n  margin-right: 30px;\n\n}\n\n.shareholder_tab input {\n  border: 1px solid #e5e3e3 !important;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-link-active-color: transparent !important;\n}\n\n.nav-item-aelb .active {\n  text-underline-offset: 3px;\n  color: var(--blue-text-color);\n}\n\n.nav-item-inv .active {\n  color: var(--blue-text-color);\n  background-color: white;\n  font-weight: 400;\n  box-shadow: inset 0 -2px 0 0 var(--gl-theme-accent, var(--blue-text-color));\n\n}\n\n.u_tab_data {\n  text-underline-offset: 5px;\n  text-decoration: underline var(--ben-gray-color);\n  font-size: 16px;\n  font-weight: 400\n}\n\n.non_u_tab_data {\n  font-size: 16px;\n  font-weight: 400;\n\n}\n\n.nav-item-indiv-busns .active {\n  color: var(--blue-text-color);\n  background-color: white;\n  font-weight: 400;\n  box-shadow: inset 0 -2px 0 0 var(--gl-theme-accent, var(--blue-text-color));\n\n}\n\n\n.inv_opp_ind_right_tab_btn {\n  text-align: center;\n}\n\n.ben_progress_bar_main_inv_returns {\n  rotate: -90deg;\n  margin: 10px;\n  background-color: transparent !important;\n  width: 180px !important;\n}\n\n\n.indiv_bus_card_styl {\n  min-height: 700px;\n  height: auto;\n  align-self: flex-start;\n}\n\n.indiv_bus_card_styl h4 {\n  position: absolute;\n  z-index: 2;\n  padding: 7px 15px;\n  right: 10px;\n  top: 10px;\n\n}\n\n.indiv_bus_card_styl img {\n  max-height: 10rem;\n  position: relative;\n}\n\n.style_table_inv {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 25px;\n  color: #292929;\n  text-align: left;\n}\n\n.style_table_inv1 {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 25px;\n  color: #292929;\n  text-align: right;\n  text-align-last: right;\n}\n\n.bar_chart_inv_db canvas {\n  width: 420px !important;\n  height: 182px !important;\n}\n\n.style_table_inv_lite {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 25px;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  color: #7C8495;\n  margin-right: 5px;\n  text-align: left;\n  margin-left: 24px;\n}\n\n.my_inv_right_arrow {\n  margin-top: 1rem;\n}\n\n.style_table_inv_lite1 {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 25px;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  color: #7C8495;\n  text-align: right;\n}\n\n.line_height_about_inv {\n  line-height: 1.5;\n  min-height: 450px;\n}\n\n.about-document-upload {\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.about-document-upload .bolder_text_p_fees {\n  color: var(--ptag-font-color);\n  font-size: var(--ptag-font-size);\n  font-weight: var(--ptag-font-weight);\n  line-height: 14.5px;\n}\n\n.about-document-help {\n  max-width: 760px;\n  color: var(--ptag-font-color);\n  font-size: var(--ptag-font-size);\n  font-weight: var(--ptag-font-weight);\n  line-height: 18px;\n}\n\n.about-document-select-btn {\n  min-width: 150px;\n  border: 0 !important;\n  color: #fff !important;\n  background: var(--sesame-color) !important;\n  box-shadow: var(--btn-box-shadow);\n}\n\n.about-document-select-btn input {\n  display: none;\n}\n\n.about-document-select-btn.disabled {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.about-document-file {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 7px 0 5px;\n  border-bottom: 1px solid rgba(124, 132, 149, 0.22);\n  border-radius: 0;\n  background: transparent;\n}\n\n.about-document-file div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.about-document-file strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.about-document-file span {\n  font-size: 12px;\n}\n\n.about-document-ready {\n  color: #138a60;\n  white-space: nowrap;\n}\n\n.about-document-pending {\n  color: #9a6a00;\n  white-space: nowrap;\n}\n\n.about-preview-confirmation {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-left: 0;\n}\n\n.about-preview-confirmation .form-check-input {\n  width: 20px;\n  height: 20px;\n  margin-top: 0;\n  margin-left: 0;\n  border: 2px solid #1f5fd6 !important;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 3px rgba(31, 95, 214, 0.16);\n  cursor: pointer;\n}\n\n.about-preview-confirmation .form-check-input:checked {\n  border-color: #3d79f3;\n  background-color: #3d79f3;\n}\n\n.about-preview-confirmation .form-check-input:disabled {\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n.about-preview-confirmation label {\n  margin-bottom: 0;\n  color: #343b4a;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 20px;\n  cursor: pointer;\n}\n\n.about-preview-dialog {\n  max-width: min(1200px, 94vw) !important;\n}\n\n.about-preview-warning {\n  padding: 12px 16px;\n  border: 1px solid #e0aa3e;\n  border-radius: 8px;\n  background: rgba(224, 170, 62, 0.12);\n}\n\n.about-preview-content {\n  min-height: 55vh;\n}\n\n.about-business-content {\n  width: 100%;\n  overflow-x: auto;\n  color: inherit;\n  font-size: 14px;\n  line-height: 1.65;\n}\n\n.about-business-content h1,\n.about-business-content h2,\n.about-business-content h3,\n.about-business-content h4,\n.about-business-content h5,\n.about-business-content h6 {\n  margin: 24px 0 10px;\n  color: #3d79f3;\n  line-height: 1.3;\n}\n\n/* Keep imported document headings close to their Word/ODT scale. Global page\n   heading rules are intentionally larger, so the preview needs its own sizes. */\n.about-business-content h1 {\n  font-size: 20px !important;\n}\n\n.about-business-content h2 {\n  font-size: 18px !important;\n}\n\n.about-business-content h3 {\n  font-size: 17px !important;\n}\n\n.about-business-content h4,\n.about-business-content h5,\n.about-business-content h6 {\n  font-size: 15px !important;\n}\n\n.about-business-content h1,\n.about-business-content h2 {\n  padding: 9px 12px;\n  border-left: 4px solid #3d79f3;\n  border-radius: 0 7px 7px 0;\n  background: linear-gradient(90deg, rgba(61, 121, 243, 0.14), rgba(61, 121, 243, 0.02));\n}\n\n.about-business-content h3,\n.about-business-content h4,\n.about-business-content h5,\n.about-business-content h6 {\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgba(61, 121, 243, 0.25);\n}\n\n.about-business-content h1:first-child,\n.about-business-content h2:first-child,\n.about-business-content h3:first-child {\n  margin-top: 4px;\n}\n\n.about-business-content p {\n  margin: 0 0 12px !important;\n  color: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.65;\n}\n\n.about-business-content table {\n  width: 100%;\n  min-width: 560px;\n  margin: 12px 0 24px;\n  border-collapse: collapse;\n  background: rgba(255, 255, 255, 0.015);\n  box-shadow: 0 3px 12px rgba(22, 45, 85, 0.08);\n}\n\n.about-business-content th,\n.about-business-content td {\n  padding: 10px 12px;\n  border: 1px solid rgba(124, 132, 149, 0.35);\n  text-align: left;\n  vertical-align: top;\n}\n\n.about-business-content th {\n  border-color: rgba(28, 81, 180, 0.55);\n  background: #2f6fd8;\n  color: #fff;\n  font-weight: 700;\n}\n\n.about-business-content tbody tr:nth-child(even) td {\n  background: rgba(61, 121, 243, 0.055);\n}\n\n.about-business-content strong,\n.about-business-content b {\n  color: inherit;\n}\n\n.about-business-content th strong,\n.about-business-content th b {\n  color: #fff;\n}\n\n.about-business-content th p,\n.about-business-content td p {\n  margin: 0 0 6px;\n}\n\n.about-business-content th p:last-child,\n.about-business-content td p:last-child {\n  margin-bottom: 0 !important;\n}\n\n.about-business-content img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin: 16px auto;\n}\n\n/* The investor tab has a muted parent text colour. Keep imported document\n   body content as readable as it is in the admin preview. */\n.about-business-content.investor-about-content,\n.about-business-content.investor-about-content p,\n.about-business-content.investor-about-content td,\n.about-business-content.investor-about-content li,\n.about-business-content.investor-about-content blockquote,\n.about-business-content.investor-about-content strong,\n.about-business-content.investor-about-content b,\n.about-business-content.investor-about-content em,\n.about-business-content.investor-about-content i,\n.about-business-content.investor-about-content span {\n  color: #212529;\n}\n\n.about-business-content.investor-about-content th,\n.about-business-content.investor-about-content th p,\n.about-business-content.investor-about-content th strong,\n.about-business-content.investor-about-content th b,\n.about-business-content.investor-about-content th span {\n  color: #fff;\n}\n\n.about-business-content.investor-about-content h1,\n.about-business-content.investor-about-content h2,\n.about-business-content.investor-about-content h3,\n.about-business-content.investor-about-content h4,\n.about-business-content.investor-about-content h5,\n.about-business-content.investor-about-content h6,\n.about-business-content.investor-about-content h1 strong,\n.about-business-content.investor-about-content h2 strong,\n.about-business-content.investor-about-content h3 strong,\n.about-business-content.investor-about-content h4 strong,\n.about-business-content.investor-about-content h5 strong,\n.about-business-content.investor-about-content h6 strong,\n.about-business-content.investor-about-content h1 span,\n.about-business-content.investor-about-content h2 span,\n.about-business-content.investor-about-content h3 span,\n.about-business-content.investor-about-content h4 span,\n.about-business-content.investor-about-content h5 span,\n.about-business-content.investor-about-content h6 span {\n  color: #3d79f3;\n}\n\n.InvOpp_right_tab {\n  position: sticky;\n  top: 16px;\n  align-self: flex-start;\n}\n\n@media (max-width: 991px) {\n  .InvOpp_right_tab {\n    position: static;\n  }\n\n  .about-document-file {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.businessProf_about_inv {\n  line-height: 1.5;\n  max-height: 220px;\n  overflow: auto;\n}\n\n.inv_prf_modal p {\n  max-height: 40vh;\n  overflow: auto;\n\n}\n\n.line_height_settings {\n  line-height: 1.5;\n  max-height: 60vh;\n  overflow: auto;\n}\n\n.form-select:disabled {\n  background-color: rgba(128, 128, 128, 0.098) !important;\n}\n\n.line_height_settings .aboutcompny {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--blue-text-color);\n  margin-bottom: 16px;\n\n}\n\n.text_area_placeholder_settings {\n  margin-left: 0px;\n}\n\n.loanhistory_tab_styl {\n  max-height: 450px;\n  overflow-y: auto;\n}\n\n.loanhistory_tab_prof {\n  max-height: 220px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.kycDocsBusinessprof .table-responsive {\n  max-height: 220px !important;\n  overflow: auto;\n}\n\n.kycDocsBusinessprof .table-responsive th {\n  position: sticky;\n  top: 0;\n  background-color: white;\n}\n\n.invOpp_loaHistory_mainDiv {\n  max-height: 300px;\n  overflow: auto;\n  border-radius: 15px;\n  outline: var(--table-outline);\n\n}\n\n.invOpp_loaHistory_mainDiv th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.invOpp_loaHistory_mainDiv td {\n  font-weight: 500;\n}\n\n.bus_hist_date {\n  min-width: 100px;\n}\n\n.bus_hist_lastAct {\n  min-width: 120px;\n}\n\n.current_L_Details {\n  line-height: 1.2;\n  max-height: 450px;\n  overflow: auto;\n}\n\n.inv_opp_table {\n  max-height: 38vh;\n  overflow-y: auto !important;\n  text-align: center;\n}\n\n.inv_opp_single_table td {\n  min-width: 130px;\n\n}\n\n.paragraph {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n\n\n.inv_db_curency_styl {\n  overflow-x: hidden;\n  justify-content: end;\n}\n\n.Inv_db_card_tilte {\n  height: 27px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n/* .bar_chart_inv_db{\n  height: 195px;\n} */\n.sesame_profit_icon {\n  margin-left: 120px;\n}\n\n.fa-money-bill-transfer {\n  left: 0%;\n  right: 82.88%;\n  top: 0%;\n  bottom: 0%;\n  background: #599bc7;\n  border-radius: 6px;\n}\n\n.percent_first {\n  width: 65px !important;\n  height: 9vh;\n  font-weight: 700;\n  font-size: 18px;\n  color: var(--ben-text-sesame-color);\n\n}\n\n.card {\n  border-radius: 12px !important;\n}\n\n.card-img,\n.card-img-top {\n  min-height: 6rem;\n  border-top-right-radius: 12px !important;\n  border-top-left-radius: 12px !important;\n\n}\n\n.blue_tab_single_inv {\n  align-items: center;\n  padding: 10px;\n  background: #E6EBF8;\n  border-radius: 8px;\n  width: 145px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.blue_tab_single_inv p {\n  font-weight: 700;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: var(--blue-text-color);\n  justify-content: center;\n  font-size: 14px;\n}\n\n.sesame_tab_single_inv {\n  width: 140px;\n  align-items: center;\n  background: #F8F6F3;\n  border-radius: 8px;\n  text-align: center;\n  align-self: center;\n  padding: 10px;\n}\n\n.sesame_tab_single_inv p {\n  color: var(--ben-text-sesame-color);\n  font-size: 14px !important;\n\n}\n\n.bold_txt_btn_tabs {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n\n}\n\n.inv_opp_footer_btn {\n  flex-shrink: 0;\n  background-color: transparent !important;\n  border-top: 0px !important;\n  padding: 12px !important;\n\n}\n\n.nav-item-inv .active h3 {\n  background-color: white !important;\n  padding: 5px 8px;\n  margin-bottom: 0px !important;\n}\n\n.nav-item-inv h3 {\n  padding: 5px 8px;\n  margin-bottom: 0px !important;\n}\n\n.nav-item-inv {\n  margin-top: 10px;\n}\n\n.Inv_Styles {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 24px;\n\n  color: #292929;\n}\n\n.dashboard_isues {\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n\n  letter-spacing: -0.02em;\n\n  color: #292929;\n}\n\n.inv_db_navbar_brand {\n  padding: 20px 35px;\n}\n\n.newinvinterest {\n  cursor: default;\n}\n\n.newinvinterest h6 {\n  text-decoration: none;\n  color: black;\n  cursor: default;\n}\n\n.new_inv_interst_table td {\n  align-items: center;\n  vertical-align: middle;\n  font-size: 16px;\n}\n\n.fixed_header {\n  width: 100% !important;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n.fixed_header tbody {\n  display: block;\n  width: 100%;\n  overflow: auto;\n  height: 100px;\n}\n\n.fixed_header thead tr {\n  display: block;\n}\n\n.fixed_header thead {\n  background: black;\n  color: #fff;\n}\n\n.fixed_header th {\n  width: 250px !important;\n}\n\n.fixed_header td {\n  width: 290px !important;\n}\n\n.table_data_header_styl {\n  font-size: 14px;\n}\n\n.scdl_of_paymt {\n  font-style: normal !important;\n  font-weight: 400 !important;\n  font-size: 14px !important;\n  text-decoration-line: underline !important;\n  color: var(--blue-text-color) !important;\n  height: 17px\n}\n\n.textarea-max-height {\n  max-height: 40px !important;\n  overflow-y: auto;\n}\n\n.payemnt_details_BS_form_conrtl input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border: 1px solid rgb(241, 241, 241) !important;\n}\n\n.payemnt_details_BS_form_conrtl span {\n  border: 1px solid rgb(241, 241, 241) !important;\n\n}\n\n.custm_input_styl input {\n  border: 1px solid #F8F8F8 !important;\n}\n\n.custm_input_styl_stngs input {\n  border: 1px solid #e5e3e3 !important;\n  padding-left: 10px !important;\n  height: 40px !important;\n}\n\n.custm_input_styl_stngs input::placeholder {\n  font-size: 14px !important;\n  font-weight: 400;\n  opacity: 50%;\n}\n\n.inputgroupcustmfield {\n  display: flex;\n  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0) !important;\n}\n\n.inputgroupcustmfield input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n}\n\n.inputgroupcustmfield .settingsInputP {\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n  padding: 0px 10px !important;\n  background-color: white !important;\n  border: 1px solid #f8f8f8 !important;\n  margin-left: 0px !important;\n}\n\n.qwertyqwe input {\n  box-shadow: -1px 3px 10px rgba(0, 0, 0, 0.027) !important;\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n}\n\n.custm_textarea_styl textarea {\n  border: 1px solid rgb(219, 219, 219) !important;\n\n}\n\n.closed_eye_styl {\n  opacity: 50%;\n}\n\n.aksjdhf input::placeholder {\n  font-weight: 600;\n  color: rgba(128, 128, 128, 0.74);\n  font-size: 15px;\n}\n\n.disabledstyle input::placeholder {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.disabledstyle :disabled {\n  background-color: rgba(128, 128, 128, 0.098) !important;\n\n}\n\n.newinvinteresttable {\n  max-height: 145px;\n  overflow: auto;\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n\n}\n\n.loanpurpose {\n  max-height: 40px;\n  overflow: auto;\n}\n\n.invcompliance_qcr_notes textarea {\n  font-size: 0.825rem !important;\n}\n\n.newinvinteresttable th {\n  position: sticky;\n  top: -0.03px;\n  background-color: white !important;\n  outline: 1px solid rgba(201, 201, 201, 0.164);\n\n}\n\n.newinvinteresttable-style {\n  max-height: 180px;\n  overflow: auto;\n  outline: var(--table-outline);\n  border-radius: 15px !important;\n}\n\n.loan_pur_myserreq {\n  max-height: 10vh;\n  overflow: auto;\n}\n\n.newinvinteresttable-style th {\n  position: sticky;\n  top: 0;\n  background-color: white !important;\n}\n\n.perticlr_bus_table {\n  max-height: 53vh;\n  overflow-y: auto;\n  border-radius: 15px !important;\n\n}\n\n.bus_histry_tab_styl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #37394C;\n\n}\n\n.busns_histry_table_main td {\n  vertical-align: middle !important;\n  font-size: 14px;\n\n}\n\n.bus_histry_LT_tab_styl {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n  color: #292929;\n}\n\n.perticlr_bus_table td {\n  background-color: white !important;\n}\n\n.singl_inv_tabl {\n  border-radius: 15px !important;\n  outline: var(--table-outline);\n  max-height: 32vh;\n  overflow: auto;\n  margin: 0px 48px;\n}\n\n.Bus_compliance_tabl {\n  max-height: 350px;\n  overflow: auto;\n}\n\n.bwidfcardspan {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 15px;\n  color: #7C8495;\n}\n\n.inv_name_styl:hover {\n  cursor: pointer;\n\n}\n\n.inv_name_styl img {\n  width: 10px;\n}\n\n.singInvabout {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: #7C8495;\n  min-height: 25px;\n  overflow: auto;\n  max-height: 50px;\n}\n\n.singInvabout b {\n  color: black;\n}\n\n.singInvabout p {\n  margin-bottom: 14px !important;\n}\n\n.busproftitle {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 18px;\n  color: #7C8495;\n  min-height: 25px;\n  overflow: auto;\n}\n\n.admin_user_icon {\n  font-size: 20px;\n  margin: 0px 20px;\n}\n\n.busproftitle b {\n  color: black;\n  font-size: 18px;\n\n}\n\n.busproftitle p {\n  margin-bottom: 14px !important;\n  font-size: 18px;\n}\n\n.inv_prof_background {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 800;\n  font-size: 12px;\n  line-height: 18px;\n  color: #7C8495;\n  min-height: 35px;\n  overflow: auto;\n  max-height: 40px;\n  overflow: auto;\n}\n\n.inv_prof_background b {\n  color: black;\n  font-size: 18px;\n\n}\n\n.inv_prof_background p {\n  margin-bottom: 14px !important;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.busprofMaintitle h4 {\n  font-size: 26px;\n  font-weight: 600;\n  max-height: 50px;\n  overflow: auto;\n}\n\n.invFullProfClsbtn {\n  align-self: baseline;\n  padding: 40px 40px 0px 0px !important;\n\n}\n\n.bwidviewprofile span {\n  text-decoration: none;\n  margin-bottom: 0px !important;\n  width: 118px;\n  height: 20px;\n  left: 16px;\n  top: 153px;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--blue-text-color);\n}\n\n.bwidviewprofile:hover {\n  cursor: pointer;\n}\n\n.bwidviewprofile {\n  position: absolute;\n  bottom: 0;\n  padding-bottom: 12px;\n}\n\n.newinvintstatus {\n  font-weight: 700;\n}\n\n.my_receipts_table {\n  outline: 1px solid rgb(243, 243, 243);\n\n}\n\n.invfullprofilemodal {\n  min-height: 53vh;\n  padding-left: 25px !important;\n  padding-right: 25px !important;\n  padding-bottom: 25px !important;\n  margin-top: 15px;\n}\n\n.Payment_currency {\n  left: 85.71%;\n  right: 7.45%;\n  top: 46.67%;\n  bottom: 21.67%;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  color: #C0C0C0;\n}\n\n.Payment_currency_settings {\n  left: 85.71%;\n  right: 7.45%;\n  top: 46.67%;\n  bottom: 21.67%;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  color: rgba(0, 0, 0, 0.747);\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.width_date_picker {\n  width: 33% !important;\n  margin-left: 8px;\n  padding-left: 13px;\n  z-index: 2\n}\n\n.aboutBusiness {\n  margin: 10px 10px 25px 0px;\n  max-height: 80px;\n  overflow: auto;\n  margin-bottom: 25px !important;\n  line-height: 22px;\n}\n\n.aboutBusiness b {\n  color: black;\n}\n\n.trqteqter img {\n  border-radius: 8px;\n}\n\n.trqteqter {\n  align-self: end;\n  justify-content: end;\n}\n\n.loanpurpose_txt {\n  max-height: 70px;\n  overflow: auto;\n}\n\n\n.txt {\n  text-align: center;\n}\n\n.csv {\n  z-index: 1 !important;\n  position: relative;\n}\n\n.newinvinteresttable-headers {\n  font-size: 14px;\n}\n\n.ui_sch {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 17px;\n  color: var(--blue-text-color) !important;\n}\n\n.investor_new {\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  padding-left: 3rem;\n  letter-spacing: -0.02em;\n  cursor: pointer;\n  color: #292929;\n  margin-top: 25px;\n}\n\n.investor_new_first_tab {\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: -0.02em;\n  color: #292929;\n}\n\n.investor_new img {\n  padding: 10px 10px 10px 0px;\n  cursor: pointer;\n}\n\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth,\ntd {\n  text-align: left;\n  padding: 8px;\n  border: 1px solid #ccc;\n}\n\nth {\n  position: sticky;\n  top: 0;\n  background-color: #f0f0f0;\n}\n\ntd input {\n  width: 100%;\n}\n\ntr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.compliance_bd_ab {\n  max-width: 245px;\n  text-wrap: wrap;\n  overflow-wrap: anywhere;\n}\n\n.login_btn_outline {\n  border: 1px solid blue !important;\n  /* Replace 'black' with the desired border color */\n}\n\n.custom-select__control {\n  border-radius: 5px;\n  padding: 0.5rem;\n  border-color: #ccc;\n}\n\n.custom-select__option {\n  background-color: white;\n  color: black;\n}\n\n.custom-select__control {\n  border-radius: 5px;\n  padding: 0.5rem;\n  border-color: #ccc;\n}\n\n\n.custom-select__option {\n  background-color: white;\n  color: black;\n}\n\n.custom-select__option:hover {\n  background-color: #3d79f3 !important;\n}\n\n.custom-select__option--is-selected {\n  background-color: white;\n  color: white;\n}\n\n.custom-select__single-value {\n  color: black;\n}\n\n.custom-select__option--is-selected {\n  background-color: white !important;\n}\n\n.custom-select__option {\n  color: #000000 !important;\n}\n\n.custom-select__dropdown-indicator {\n  color: #3d79f3;\n}\n\n/* Submenu normal and active */\n.ps-submenu-content .ps-menu-label {\n  color: #000;\n  /* normal */\n}\n\n.ps-submenu-content .ps-menu-label.ps-active {\n  color: #1a73e8;\n  font-size: 13px;\n\n  /* active */\n}\n\n.ps-submenu-content .ps-menuitem-root:hover .ps-menu-label {\n  color: #1a73e8;\n  /* hover */\n}\n\n/* Info Banner Styles */\n.info-banner {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border-left: 4px solid #f59e0b;\n  padding: 20px 24px;\n  margin-bottom: 24px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.1);\n}\n\n.banner-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.banner-icon {\n  width: 32px;\n  height: 32px;\n  background: #f59e0b;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.banner-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #92400e;\n}\n\n.banner-items {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.banner-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #78350f;\n  font-weight: 500;\n}\n\n.banner-item svg {\n  flex-shrink: 0;\n}\n\n\n.step-header {\n  margin-bottom: 9px;\n\n}\n\n.step-subtitle {\n  font-size: 15px;\n  color: #6b7280;\n  line-height: 1.6;\n}\n\n\n.step-title {\n\n  font-size: 28px;\n  color: #3d79f3;\n  margin-bottom: 0px;\n  font-weight: 400;\n  margin-top: -15px;\n}\n\n.step-title-personal {\n  font-size: 28px;\n  color: #3d79f3;\n  margin-bottom: 0px;\n  font-weight: 400;\n  margin-top: -15px;\n\n}\n\n/* .main-content {\n  padding: 24px 18px;\n} */\n\n.main-content {\n  padding: 0px 18px;\n}\n\n.content-wrapper {\n  max-width: 89%\n}\n\n.step-header-personal {\n  margin-bottom: 17px;\n}\n\n/* Buttons */\n.button-group {\n  display: flex;\n  gap: 16px;\n  margin-top: 14px;\n  padding-top: 28px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.button-group .btn {\n  padding: 16px 32px;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-family: inherit;\n}\n\n.btn-primary {\n  flex: 1;\n  background: #3d79f3;\n  color: white;\n  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);\n}\n\n.btn-primary:disabled {\n  background: #d1d5db;\n  box-shadow: none;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-secondary {\n  background: #f3f4f6;\n  color: #6b7280;\n  min-width: 120px;\n}\n\n.btn-secondary:hover {\n  background: #e5e7eb;\n}\n\n.btn-full {\n  width: 100%;\n  max-width: 300px;\n  padding: 16px;\n  background: #3d79f3;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n\n.btn-full:hover {\n  background: #1e40af;\n}\n\n\n.kyc-label {\n  font-weight: 600;\n  /* bold */\n  color: #000;\n  /* black */\n  margin-bottom: 6px;\n}\n\n.nomine-relation-label {\n  display: block;\n  margin-bottom: 8px;\n  color: #374151;\n  font-weight: 600;\n  font-size: 14px;\n\n}\n\n\n/* .kyc-status-wrapper {\n  margin-top: 8px;\n}\n\n.kyc-status {\n  display: inline-block;\n  padding: 10px 18px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1;\n}\n*/\n\n/* Under Review (BLUE TAB) */\n/* .kyc-status-review {\n  background-color: #2f66d5;\n  color: #fff;\n} */\n\n/* Warning */\n/* .kyc-status-warning {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeeba;\n} */\n\n/* Rejected */\n/* .kyc-status-rejected {\n  background-color: #fdecea;\n  color: #b02a37;\n  border: 1px solid #f5c2c7;\n} */\n\n/* Approved */\n/* .kyc-status-approved {\n  background-color: #e6f4ea;\n  color: #137333;\n  border: 1px solid #b7dfc1;\n}  */\n\n.upload-hint {\n  font-size: 13px;\n  color: #9ca3af;\n  margin-top: 10px;\n}\n\n.upload-title {\n  font-weight: 600;\n  margin-top: 8px;\n}\n\n.required {\n  color: red;\n  font-size: large;\n  margin-left: 4px;\n}\n\n\n\n/* File Upload */\n.upload-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 0px;\n  margin-top: 8px;\n}\n\n.upload-area {\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n  padding: 5px 3px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s;\n  background: #f9fafb;\n\n}\n\n.upload-area.has-file {\n  border-color: #10b981;\n  background: #f0fdf4;\n  /* padding: 12px 3px; */\n\n\n}\n\n/* .upload-area {\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n  padding: 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s;\n  background: #f9fafb;\n  min-height: 160px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.upload-area.has-file {\n  border-color: #10b981;\n  background: #f0fdf4;\n} */\n\n.upload-hint.hidden {\n  visibility: hidden;\n  /* keeps height */\n}\n\n.upload-area:hover {\n  border-color: #3d79f3;\n  background: #eff6ff;\n}\n\n.upload-area.has-file .upload-title {\n  color: #065f46;\n  font-weight: 600;\n\n}\n\n.upload-area.has-file .file-name {\n  color: #047857;\n}\n\n/* .upload-area.has-file svg {\n  fill: #10b981;\n} */\n\n.upload-area p {\n  color: #6b7280;\n  font-size: 14px;\n  margin-bottom: 6px;\n}\n\n.upload-area .upload-title {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 6px;\n  margin-top: 11px;\n\n}\n\n.upload-area .file-name {\n  color: #10b981;\n  font-weight: 600;\n  margin-top: 12px;\n  font-size: 15px;\n}\n\n/* \n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #374151;\n    font-weight: 600;\n    font-size: 14px;\n} */\n\n@media (max-width: 768px) {\n  .upload-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* * Camera */\n\n\n.camera-container {\n  position: relative;\n  background: black;\n  border-radius: 16px;\n  overflow: hidden;\n  margin-bottom: 24px;\n\n  width: 500px;\n  height: 300px;\n  /* 🔥 THIS IS IMPORTANT */\n}\n\n#video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n#canvas {\n  display: none;\n}\n\n/* #video {\n    width: 100%;\n    display: block;\n}\n\n#canvas {\n    display: none;\n} */\n\n.camera-preview {\n  position: relative;\n  max-width: 500px;\n}\n\n.camera-preview img {\n  width: 100%;\n  border-radius: 16px;\n}\n\n.retake-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.retake-btn:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n.camera-instructions {\n  background: #fadd91;\n  border-left: 4px solid #c99716;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #92400e;\n  line-height: 1.8;\n}\n\n/* Review Section */\n.review-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.review-section {\n  background: #f4f6f9;\n  padding: 24px;\n  border-radius: 12px;\n}\n\n.review-section h3 {\n  font-size: 16px;\n  color: #111827;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.review-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  font-size: 14px;\n  gap: 16px;\n}\n\n.review-item .label {\n  color: #6b7280;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.review-item .value {\n  color: #111827;\n  font-weight: 500;\n  text-align: right;\n  font-size: 13px;\n}\n\n.edit-link {\n  color: #3d79f3;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.edit-link:hover {\n  text-decoration: underline;\n}\n\n/* Trust Badge */\n.trust-badge {\n  background: #eff6ff;\n  border-left: 4px solid #3d79f3;\n  padding: 16px 20px;\n  margin-bottom: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n\n}\n\n.trust-badge svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.trust-badge-content {\n  font-size: 14px;\n  color: #1e40af;\n  line-height: 1.6;\n}\n\n.trust-badge-content strong {\n  display: block;\n  margin-bottom: 4px;\n}\n\n\n\n\n/* Desktop Layout */\n/* .kyc-container {\n  display: grid;\n  grid-template-columns: 400px 1fr;\n  min-height: 100vh;\n} */\n\n/* Left Sidebar */\n.sidebar {\n  background: #3d79f3;\n  color: white;\n  padding: 27px 29px;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.logo {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 48px;\n}\n\n.sidebar-contentttt {\n  flex: 1;\n}\n\n.sidebar h1 {\n  font-size: 28px;\n  line-height: 1.3;\n  margin-bottom: 16px;\n}\n\n.sidebar p {\n  font-size: 15px;\n  opacity: 0.9;\n  line-height: 1.6;\n  margin-bottom: 48px;\n}\n\n.progress-step {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  margin-bottom: -10px;\n  opacity: 0.5;\n  transition: all 0.3s;\n  margin-top: 32px;\n}\n\n.progress-step.active {\n  opacity: 3;\n}\n\n.progress-step.completed {\n  opacity: 5.7;\n}\n\n.step-number {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.progress-step.active .step-number {\n  background: white;\n  color: #3d79f3;\n}\n\n.progress-step.completed .step-number {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.step-label {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n\n\n\n\n.kyc-sidebar {\n  width: 280px;\n  background: linear-gradient(180deg, #1e5eff, #173fb4);\n  color: white;\n  padding: 24px;\n}\n\n.stepper {\n  list-style: none;\n  padding: 0;\n}\n\n.step {\n  margin: 16px 0;\n  opacity: 0.5;\n}\n\n.step.active {\n  opacity: 1;\n  font-weight: bold;\n}\n\n.step.completed {\n  opacity: 0.8;\n}\n\n.circle {\n  background: white;\n  color: #1e5eff;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n}\n\n\n.kyc-modal-overlay.active {\n  display: flex;\n}\n\n.kyc-modal-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  align-items: center;\n  justify-content: center;\n}\n\n.kyc-modal {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.kyc-modal-content {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease;\n}\n\n.modal-icon {\n  width: 64px;\n  height: 64px;\n  background: #fadd91;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n}\n\n.modal-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #111827;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.modal-description {\n  font-size: 15px;\n  color: #6b7280;\n  text-align: center;\n  margin-bottom: 24px;\n  line-height: 1.6;\n}\n\n.document-checklist {\n  background: #f9fafb;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.checklist-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n  font-size: 14px;\n  color: #374151;\n}\n\n.checklist-icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  background: #A6FF4D;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n}\n\n.modal-button {\n  width: 100%;\n  padding: 16px;\n  background: #3d79f3;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.helper-text {\n  font-size: 13px;\n  color: #9ca3af;\n  margin-top: 6px;\n}\n\n\n/* Form Elements */\n/* .form-group {\n  margin-bottom: 2px\n} */\n\n.form-group label {\n  display: block;\n  margin-bottom: 3px;\n  color: #374151;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n\n.form-field input,\n.form-field select,\n.form-field textarea {\n  width: 100%;\n  padding: 14px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 15px;\n  transition: all 0.3s;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #3d79f3;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.nominee-header {\n  margin-bottom: 8px;\n}\n\n.nominee-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #3d79f3;\n  margin-bottom: 8px;\n}\n\n.nominee-subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.6;\n}\n\n.investor-title {\n  --h1-font-size: 28px;\n  --h1-font-weight: 400;\n}\n\n/* Success Screen */\n.success-screen {\n  text-align: center;\n  padding: 60px 40px;\n}\n\n.success-icon {\n  width: 100px;\n  height: 100px;\n  background: #10b981;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 32px;\n}\n\n.success-icon svg {\n  width: 50px;\n  height: 50px;\n}\n\n.success-screen h2 {\n  font-size: 36px;\n  color: #111827;\n  margin-bottom: 16px;\n  font-weight: 700;\n}\n\n.success-screen p {\n  color: #6b7280;\n  font-size: 16px;\n  line-height: 1.6;\n  margin-bottom: 40px;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.form-group .form-control.input-error {\n  /* border-color: #dc3545  !important; */\n  border: 2px solid #dc3545 !important;\n\n}\n\n.error-text {\n  font-size: 12px;\n  color: #dc2626;\n  /* red */\n}\n\n/* 🔴 FORCE invalid state */\n.form-group .field-control.is-invalid {\n  border: 2px solid #dc3545 !important;\n}\n\n.react-select__option {\n  font-weight: 400;\n  color: #374151;\n}\n\n.react-select__option--is-focused {\n  background-color: #f3f4f6;\n}\n\n.react-select__option--is-selected {\n  background-color: #e5e7eb;\n  color: #111827;\n  font-weight: 400;\n}\n\n.react-select__single-value {\n  font-weight: 400;\n}\n\n\n\n.flatpickr-input {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%239ca3af'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M8 7V3m8 4V3m-9 8h10m-12 9h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 18px;\n  padding-right: 40px;\n  padding: 10px 0px;\n  /* width: 519px; */\n  height: 40px;\n\n}\n\n.progress-step.completed .step-number {\n  background-color: #22c55e;\n  /* green */\n  color: white;\n  font-weight: bold;\n}\n\n.progress-step.active .step-number {\n  background-color: #3d79f3;\n  /* blue */\n  color: white;\n}\n\n.step-number {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.input-error {\n\n  border: 2px solid #dc3545 !important;\n}\n\n.form-select.input-error {\n\n  border: 2px solid #dc3545 !important;\n}\n\n\n.step-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.step-tick {\n  color: #50f20b;\n  /* green */\n  font-weight: bold;\n  font-size: 25px;\n}\n\n.progress-step.completed .step-number {\n  background-color: #e5f9ef;\n  color: #16a34a;\n}\n\n\n\n\n\n.sidebarprohead {\n  height: 100vh;\n}\n\n\n\n.selfie-box {\n  display: flex;\n  justify-content: center;\n  margin: 32px 0;\n}\n\n.selfie-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.selfie-ring {\n  width: 180px;\n  height: 180px;\n  border-radius: 50%;\n  padding: 6px;\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n  box-shadow: 0 8px 20px rgba(34, 197, 94, 0.25);\n}\n\n.selfie-image {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #fff;\n}\n\n.selfie-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.selfie-status {\n  font-size: 14px;\n  color: #16a34a;\n  font-weight: 600;\n}\n\n.selfie-retake {\n  background: none;\n  border: none;\n  color: #ef4444;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.selfie-retake:hover {\n  text-decoration: underline;\n}\n\n.ps-sidebar-container,\n.css-dip3t8 {\n  overflow-y: hidden !important;\n  overflow-x: hidden !important;\n}\n\n\n.kyc-layout {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n  /* font-family: Poppins; */\n}\n\n\n.kyc-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 22px 47px;\n  background: #f9fafb;\n}\n\n\n\n\n.kyc-progress-header {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 2px;\n}\n\n.kyc-progress-track {\n  width: 100%;\n  height: 9px;\n  background-color: #e5e7eb;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.kyc-progress-fill {\n  height: 100%;\n  background-color: #3D79F3;\n  /* BenneFin Primary Blue */\n  border-radius: 999px;\n  transition: width 0.3s ease;\n}\n\n.kyc-progress-step {\n  font-size: 17px;\n}\n\n.right-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.kyc-progress-wrapper {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  background: #ffffff;\n  padding: 0px 23px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n\n\n.pep-info-icon {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n\n  background-color: transparent;\n\n  border: 2.5px solid black;\n\n  color: black;\n\n\n  font-family: \"Poppins\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n  margin-left: 6px;\n  line-height: 1;\n}\n\n\n\n\n.pep-tooltip {\n  max-width: 320px;\n  white-space: normal;\n  font-size: 13px;\n  line-height: 1.5;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  color: #374151;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  z-index: 9999;\n}\n\n.pep-info-icon:hover {\n  border-color: black;\n  color: black;\n}\n\n.pep-info-icon {\n  color: black;\n  background: transparent !important;\n  font-weight: 700;\n}\n\n\n.selfie-success-card.small {\n  max-width: 420px;\n  /* 🔹 small card */\n  margin: 24px auto 0;\n  /* 🔹 centered */\n  padding: 20px 24px;\n  /* 🔹 compact padding */\n  border-radius: 12px;\n  border: 1px solid #22c55e;\n  background: #ecfdf5;\n  text-align: center;\n  position: relative;\n}\n\n.selfie-success-card.small h4 {\n  font-size: 18px;\n  margin-bottom: 4px;\n}\n\n.selfie-success-card.small p {\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 8px;\n}\n\n.selfie-success-card.small .success-icon {\n  width: 44px;\n  height: 44px;\n  background: #22c55e;\n  color: #fff;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n\n\n\n\n\n.progress-steps {\n  margin-top: 32px;\n}\n\n.progress-step {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 22px;\n}\n\n/* ================= CIRCLE BASE ================= */\n.step-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ================= COMPLETED ================= */\n.progress-step.completed .step-circle {\n  background-color: #A6FF4D;\n  /* green */\n  color: #ffffff;\n  border: none;\n}\n\n/* ================= ACTIVE ================= */\n.progress-step.active .step-circle {\n  background-color: #ffffff;\n  color: #3d79f3;\n  border: none;\n}\n\n/* ================= UPCOMING ================= */\n.progress-step.upcoming .step-circle {\n  background-color: transparent;\n  color: #93c5fd;\n  border: 2px solid #93c5fd;\n}\n\n/* ================= LABEL ================= */\n.step-label {\n  font-size: 18px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n/* Active label brighter */\n.progress-step.active .step-label {\n  color: #ffffff;\n}\n\n/* Completed label slightly dim */\n.progress-step.completed .step-label {\n  color: #d1fae5;\n}\n\n\n\n\n\n.review-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.edit-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  /* Uploaded state */\n  color: #3d79f3;\n  /* blue */\n  font-size: 14px;\n  font-weight: 500;\n}\n\n\n\n\n.review-doc-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n\n.value.uploaded {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #10b981;\n  /* green */\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* Font Awesome check icon */\n.uploaded-icon {\n  font-size: 16px;\n  color: #10b981;\n}\n\n.value.not-uploaded {\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n\n/* Font Awesome check icon */\n.uploaded-icon {\n  font-size: 16px;\n  color: #10b981;\n}\n\n.upload-iconnn {\n  font-size: 42px;\n  margin-bottom: 8px;\n  color: #3d79f3;\n}\n\n.upload-icon.success {\n  color: #10b981;\n}\n\n\n.success-wrapper {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f8ff;\n}\n\n.success-card {\n  background: #ffffff;\n  width: 1054px;\n  max-width: 100%;\n  padding: 92px 14px;\n  border-radius: 16px;\n  text-align: center;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);\n  height: 588px;\n  max-height: 100%;\n}\n\n.success-icon-circle {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 16px;\n  background: #22c55e;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-title {\n  font-size: 33px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 8px;\n}\n\n.success-message {\n  font-size: 20px;\n  color: #475569;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.success-info-box {\n  background: #f1f6ff;\n  border-radius: 12px;\n  padding: 16px;\n  text-align: left;\n  margin-bottom: 20px;\n  margin-top: 20px;\n\n}\n\n.success-info-box h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e40af;\n  margin-bottom: 8px;\n}\n\n.success-info-box ul {\n  font-size: 14px;\n  padding-left: 18px;\n  margin: 0;\n}\n\n.success-info-box li {\n  font-size: 16px;\n  color: #334155;\n  margin-bottom: 6px;\n}\n\n.success-footer {\n  font-size: 15px;\n  color: #64748b;\n}\n\n.success-footer a {\n  color: #3D79F3;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n\n.investor-title,\n.investor-subtitle {\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 600;\n}\n\n.investor-header * {\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n\n\n.kyc-poppins-ui .btn-primary {\n  background-color: #3d79f3 !important;\n  border-color: #3d79f3 !important;\n}\n\n\n\n.kyc-modal-primary-btn {\n  background-color: #3d79f3 !important;\n  border-color: #3d79f3 !important;\n  color: #fff;\n}\n\n.kyc-modal-primary-btn:hover,\n.kyc-modal-primary-btn:focus {\n  background-color: #3d79f3 !important;\n  border-color: #3d79f3 !important;\n}\n\n\n.kyc-poppins-ui,\n.kyc-poppins-ui *:not(i):not(svg):not([class^=\"fa\"]) {\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.section-title {\n  font-weight: 200;\n  margin-bottom: 0;\n  font-size: 21px;\n  color: #3d79f3;\n}\n\n.review-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.review-approve-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.review-status .kyc-status {\n  white-space: nowrap;\n}\n\n/* .kyc-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n} */\n\n.kyc-status-warning {\n  background-color: #fadd91;\n  color: #856404;\n  border: 1px solid #fadd91;\n}\n\n.kyc-status-review {\n  background-color: #fadd91;\n  color: #856404;\n  border: 1px solid #fadd91;\n}\n\n.kyc-status-rejected {\n  background-color: #fadd91;\n  color: #856404;\n  border: 1px solid #fadd91;\n}\n\n.kyc-status-approved {\n  background-color: #fadd91;\n  color: #856404;\n  border: 1px solid #fadd91;\n}\n\n.upload-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: auto;\n}\n\n.upload-disabled .upload-title {\n  color: #9ca3af;\n}\n\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #FFF;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n\n@media (max-width: 1199px) and (min-width: 769px) {\n  .ps-sidebar-root {\n    display: block !important;\n    width: 282px !important;\n    min-width: 282px !important;\n  }\n\n  .ps-menu-label {\n    display: none;\n  }\n\n  .ps-menu-button {\n    justify-content: center;\n  }\n\n\n  /* Navbar container */\n  .navbarTop.navbar {\n    display: flex !important;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: nowrap !important;\n    /* 🔑 KEY */\n    width: 100%;\n  }\n\n  /* Brand / title */\n  .navbar-brand {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n  }\n\n\n\n\n\n  .navbar-text {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  @media(max-width: 1199px) and (min-width: 769px) {\n\n    .dropdown {\n      display: flex;\n      align-items: center;\n      margin-left: auto;\n    }\n\n    img.dropbtn {\n      margin: 0 !important;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .navbarTop.navbar {\n      flex-wrap: nowrap !important;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .review-grid {\n      grid-template-columns: 1fr;\n      /* one below another */\n    }\n  }\n}\n\n\n\n\n\n\n\n\n@media (max-width: 768px) {\n\n\n  html,\n  body {\n    height: auto !important;\n    overflow-y: auto !important;\n  }\n\n  .kyc-layout,\n  .main-content,\n  .content-wrapper {\n    height: auto !important;\n    min-height: 100vh;\n    overflow: visible !important;\n  }\n\n  /* Layout becomes vertical */\n  .kyc-layout {\n    flex-direction: column;\n  }\n\n  .ps-sidebar-root {\n    position: sticky !important;\n    top: 0;\n    z-index: 1000;\n    height: auto !important;\n    min-height: unset !important;\n    background: #3d79f3;\n    width: 100% !important;\n    min-width: 100% !important;\n    max-width: 100% !important;\n\n  }\n\n  .ps-sidebar-container {\n    height: auto !important;\n    min-height: unset !important;\n    width: 100% !important;\n    overflow: visible !important;\n    position: fixed !important;\n\n  }\n\n  /* Sidebar inner layout */\n  .sidebar-inner {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 16px;\n  }\n\n  /* ❌ Hide progress steps ONLY on mobile */\n  .kyc-steps,\n  .stepper,\n  .progress-steps {\n    display: none !important;\n  }\n\n  .kyc-content,\n  .main-content,\n  .content-wrapper {\n    overflow-y: visible !important;\n    max-height: none;\n  }\n\n  .kyc-content {\n    padding: 120px 47px;\n  }\n\n  /* Typography fix */\n  .investor-title {\n    font-size: 21px;\n    font-weight: 400;\n  }\n\n  .sidebar,\n  .sidebar-contentttt {\n    height: auto !important;\n    flex: unset !important;\n    padding: 0px 0px;\n  }\n\n  .investor-header {\n    padding: 16px !important;\n  }\n\n  .investor-title {\n    margin-bottom: 4px;\n  }\n\n  .investor-subtitle {\n    font-size: 12px;\n    line-height: 1.4;\n  }\n\n  .button-group {\n    display: flex !important;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 24px;\n    padding-bottom: 24px;\n  }\n\n  /* Navbar container */\n  .navbarTop.navbar {\n    display: flex !important;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: nowrap !important;\n    /* 🔑 KEY */\n    width: 100%;\n  }\n\n  /* Brand / title */\n  .navbar-brand {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n  }\n\n\n\n  /* Prevent collapse content from affecting header row */\n  .navbar-collapse {\n    justify-content: flex-start !important;\n  }\n\n  .navbar-text {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  @media (max-width: 768px) {\n\n    .dropdown {\n      display: flex;\n      align-items: center;\n      margin-left: auto;\n      /* 🔑 pushes rest to the right */\n    }\n\n    img.dropbtn {\n      margin: 0 !important;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .navbarTop.navbar {\n      flex-wrap: nowrap !important;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .review-grid {\n      grid-template-columns: 1fr;\n      /* one below another */\n    }\n  }\n\n}\n\n\n\n\n.ps-sidebar-root {\n  width: 260px;\n  min-width: 260px;\n}\n\n.eye-color-kyc {\n  color: #3D79F3;\n  font-size: 20px\n}\n\n.cancel-upload-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cancel-upload-btn:hover {\n  background: #dc2626;\n}\n\n.upload-area {\n  position: relative;\n  /* 🔑 REQUIRED */\n}\n\n/*\n.upload-area.has-file {\n  padding: 20px 16px;\n}\n*/\n\n.file-actions {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  gap: 8px;\n  z-index: 20;\n}\n\n.icon-btn {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n\n  background: #ffffff;\n  color: #111827;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 18px;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n\n.icon-btn.view {\n  color: #3d79f3;\n}\n\n.icon-btn.cancel {\n  color: #dc2626;\n}\n\n.eye-view-color-kyc {\n  color: #3D79F3;\n  font-size: 24px;\n}\n\n.error-msg {\n  color: \"red\";\n  font-size: \"13px\";\n  margin-top: \"4px\"\n}\n\n\n.kyc-status {\n  padding: 8px 14px;\n  border-radius: 20px;\n  background: #fadd91;\n  color: #3a2a00;\n  max-width: 500px;\n  font-size: 15px;\n}\n\n.kyc-reason {\n  margin-top: 4px;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.img-fluid-ekyc {\n  max-width: 25%;\n  height: auto;\n}\n\n.ekyc-btn {\n  border: 1px solid #0d6efd;\n  color: #0d6efd;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 4px 14px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.ekyc-btn:hover {\n  background-color: #0d6efd;\n  color: #fff;\n}\n\n.ekyc-status-badge {\n  background-color: #eaf1ff;\n  color: #0d6efd;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.ekyc-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin: 4px 59px;\n}\n\n/* .ekyc-left, */\n/* .ekyc-right {\n  background: #fff;\n  border-radius: 8px;\n  padding: 16px;\n} */\n\n.section {\n  margin-bottom: 20px;\n}\n\n/* .ekyc-left {\n  background: #fff;\n  border-radius: 8px;\n  padding: 16px;\n  width: 700px !important;\n  height: 200px;\n\n} */\n\n\n\n\n\n.section-header {\n  margin-bottom: 5px;\n}\n\n\n\n/* Line row */\n.section-line {\n  width: 100%;\n  height: 2px;\n  border-radius: 2px;\n}\n\n/* Colors */\n.section-title.blue {\n  color: #2563eb;\n  font-weight: 500;\n}\n\n.section-line.blue {\n  background-color: #2563eb;\n}\n\n.section-title.orange {\n  color: #f00f22;\n  font-weight: 500;\n}\n\n.section-line.orange {\n  background-color: #f00f22;\n}\n\n\n\n.ekyc-cards {\n  min-height: 230px;\n  cursor: pointer;\n  width: 700px !important;\n  background-color: rgb(255, 255, 255) !important;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);\n  margin-top: 20px !important;\n}\n\n\n/* .card { background: var(--card); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: var(--shadow); padding: 16px; }\n.grid { display: grid; gap: 16px; }\n.grid-2 { grid-template-columns: 1fr 1fr; }\n.section-title-ekyc{ margin: 0 0 8px; font-size: 18px; }\n.table-ekyc { width: 100%; border-collapse: collapse; }\n.table-ekyc th, .table-ekyc td { padding: 12px; border-bottom: 1px solid var(--border); text-align: left; }\n.table-ekyc th { color: var(--muted); font-weight: 600; font-size: 12px; text-transform: uppercase; } */\n\n.card-ekyc {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);\n  padding: 16px;\n}\n\n/* GRID LAYOUT */\n.grid {\n  display: grid;\n  gap: 16px;\n}\n\n.grid-2 {\n  grid-template-columns: 1fr;\n}\n\n/* SECTION TITLE */\n.section-title-ekyc {\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n/* TABLE */\n.table-ekyc {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-ekyc th,\n.table-ekyc td {\n  padding: 5px;\n  border-bottom: 1px solid var(--border);\n  text-align: left;\n  vertical-align: top;\n}\n\n.table-ekyc th {\n  color: #64748b;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  width: 160px;\n}\n\n\n\n/* Remove sticky + background from eKYC table */\n.table-ekyc th {\n  position: static;\n  background-color: transparent;\n}\n\n/* Remove zebra striping */\n.table-ekyc tr:nth-child(even) {\n  background-color: transparent;\n}\n\n\n.button-group-ekyc {\n  display: flex;\n  border-top: 3px solid #e5e7eb;\n  margin: 5px 0px;\n}\n\n\n\n.details-grid {\n  display: grid;\n  grid-template-columns: 160px 1fr;\n  /* label | value */\n  row-gap: 12px;\n}\n\n.details-grid .label {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: 3px;\n}\n\n.details-grid .value {\n  color: #1f2937;\n}\n\n\n.tag {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 14px;\n}\n\n.tag-success {\n  background: #acf0c3;\n  color: #166534;\n}\n\n.tag-danger {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.tag-warning {\n  background: #db838ca3;\n  color: #991b1b;\n}\n\n.form-value {\n  word-break: break-word;\n}\n\n.tag-warn {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n\n.thumb {\n  width: 100%;\n  max-width: 280px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n}\n\n.toolbar {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.theme-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  border: 1px solid var(--border);\n  padding: 6px 10px;\n  border-radius: 999px;\n}\n\n.btn-outline-primary {\n  border: 1px solid #3D79F3;\n  color: #3D79F3;\n  background: white;\n  font-weight: 500;\n}\n\n\n.case_action_btn {\n  border: 1px solid #3D79F3;\n  color: #3D79F3;\n  background: white;\n  font-weight: 500;\n  padding: 4px 12px;\n  border-radius: 6px;\n}\n\n.case_action_btn:hover {\n  background: #3D79F3;\n  color: white;\n}\n\n\n.select {\n  width: 302px;\n  height: 38px;\n  padding: 6px 12px;\n  font-size: 14px;\n  border-radius: 6px;\n}\n\n.risk-summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 15px;\n}\n\n.risk-left {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.risk-score {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.risk-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.assessment-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.assessment-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f7f8fa;\n  padding: 12px;\n  border-radius: 8px;\n}\n\n.assessment-left {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.assessment-icon {\n  font-size: 18px;\n}\n\n.assessment-title {\n  font-weight: 600;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.assessment-meta {\n  font-size: 12px;\n  color: #777;\n}\n\n.assessment-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.icon-btn {\n  border: none;\n  background: white;\n  padding: 6px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.approval-card {\n  border: 2px solid #2f6fed;\n  border-radius: 10px;\n  padding: 16px;\n  background: #f9fbff;\n}\n\n.approval-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  color: #2f6fed;\n  margin-bottom: 5px;\n}\n\n.approval-icon {\n  font-size: 16px;\n}\n\n.approval-title {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.approval-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.approval-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.approval-checkbox input[type=\"checkbox\"] {\n  transform: scale(1.5);\n  cursor: pointer;\n}\n\n.approval-comment label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.approval-comment textarea {\n  width: 100%;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  margin-top: 4px;\n}\n\n.required {\n  color: red;\n}\n\n.approval-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n\n\n.ekyc-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 12px;\n}\n\n.ekyc-left {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ekyc-right {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.case-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n  font-size: 16px;\n}\n\n.case-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.case-label {\n  font-weight: 500;\n  color: #555;\n  font-size: 14px\n}\n\n.case-id {\n  background: #eef2ff;\n  color: #2f6fed;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.case-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.case-status {\n  color: #444;\n  font-size: 14px;\n}\n\n.case-btn {\n  background: #2f6fed;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.case-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n.evidence-btn {\n  appearance: none;\n  border: none;\n  border-radius: 8px;\n  padding: 6px 14px;\n  cursor: pointer;\n  font-weight: 600;\n  background: #e2e8f0;\n  color: #111827;\n  text-decoration: none;\n  display: inline-block;\n  margin-top: 0px;\n}\n\n.evidence-btn:hover {\n  background: #cbd5e1;\n}\n\n.evidence-btn:disabled {\n  appearance: none;\n  border: none;\n  border-radius: 8px;\n  padding: 6px 14px;\n  cursor: pointer;\n  font-weight: 600;\n  background: #e2e8f0;\n  color: #111827;\n  text-decoration: none;\n  display: inline-block;\n  margin-top: 0px;\n}\n\n.disabled-open-btn {\n  /* pointer-events: none;\n    opacity: 0.5; */\n  cursor: not-allowed;\n  background-color: #e9ecef !important;\n  border-color: #e9ecef !important;\n  color: #6c757d !important;\n  box-shadow: none;\n}\n\n.ekyc-primary-btn {\n  background-color: #0d6efd;\n  color: #fff;\n  border: none;\n  padding: 6px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ekyc-primary-btn:hover {\n  background-color: #0b5ed7;\n}\n\n.ekyc-primary-btn:disabled {\n  background-color: #bfc6d1;\n  cursor: not-allowed;\n}\n\n.muted {\n  color: #64748b;\n}\n\n.table-section th {\n  background: #eef2ff;\n  color: #1e293b;\n  font-weight: 600;\n  padding: 10px 12px;\n  border-left: 4px solid #2563eb;\n}\n\n\n.case-label-list {\n  font-weight: 500;\n  color: #555;\n  font-size: 25px;\n  margin-top: 35px;\n}\n\n\n.case-select-card {\n  padding: 14px 16px;\n  margin-bottom: 16px;\n}\n\n.case-select-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.case-select {\n  color: #334155;\n}\n\n.case-select:hover {\n  border-color: #2563eb;\n}\n\n.case-filter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.case-filter-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-label {\n  font-weight: 600;\n  color: #334155;\n  font-size: 15px;\n}\n\n.case-select {\n  appearance: none;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 8px 12px;\n  min-width: 220px;\n  background: white;\n  font-size: 14px;\n}\n\n.ekyc-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.section-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.section-right-risk {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.status-badge {\n  background: #e7f1ff;\n  color: #0d6efd;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.id-type {\n  font-size: 13px;\n  color: #555;\n}\n\n\n\n.ekyc-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.section-line {\n  width: 100%;\n  height: 2px;\n  margin-top: 8px;\n  background-color: #0d6efd;\n}\n\n.upload-btn {\n  background: #2f6fed;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.upload-btn:disabled {\n  background-color: #bfc6d1;\n  cursor: not-allowed;\n}\n\n/* .upload-btn:hover {\n  background-color: #f0f6ff;\n} */\n\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n/* .form-group label {\n  font-size: 12px;\n  color: #9aa4b2;\n  margin-bottom: 4px;\n} */\n\n.form-group input {\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  background: #ffffff;\n  color: #101828;\n  font-size: 14px;\n  outline: none;\n  transition: border 0.2s ease, box-shadow 0.2s ease;\n}\n\n\n\n.form-value {\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  color: #101828;\n  font-size: 14px;\n}\n\n\n.ekyc-reset-btn {\n  background: #b2bac2;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n\n\n\n\n\n.fatf-upload-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.fatf-desc {\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 7px;\n}\n\n\n.fatf-storage {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.file-input-wrapper {\n  flex: 1;\n}\n\n.fatf-upload-row input[type=\"file\"] {\n  display: block !important;\n  width: 324px;\n  color: #000;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.upload-btn-risk {\n  background: #2f6fed;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 30px;\n}\n\n.upload-btn-risk:disabled {\n  background-color: #bfc6d1;\n  cursor: not-allowed;\n}\n\n.ekyc-textarea {\n  resize: vertical;\n  white-space: pre-wrap;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  background: #ffffff;\n  color: #101828;\n  font-size: 14px;\n  outline: none;\n  transition: border 0.2s ease, box-shadow 0.2s ease;\n}\n\n.risk-badge {\n  background-color: #e6f7ee;\n  color: #1f9d55;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.risk-info-box {\n  background-color: #e6f0ff;\n  border: 1px solid #bcd3ff;\n  color: #1a4fb5;\n  padding: 7px 11px;\n  border-radius: 6px;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  margin-top: 0px;\n\n}\n\n.risk-info-box .tick {\n  color: #2e7d32;\n  font-weight: bold;\n}\n\n.choose-file-btn {\n  display: inline-block;\n  padding: 8px 24px;\n  margin-bottom: 0;\n  background-color: #ffffff;\n  color: #0d6efd;\n  border: 1px solid #0d6efd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.choose-file-btn:hover {\n  background-color: #0d6efd;\n  color: #ffffff;\n}\n\n.choose-file-btn:active {\n  transform: scale(0.98);\n}\n\n/* Keep the file name area at a fixed width so the Upload button\n   always stays in the same position */\n.selected-file-name {\n  display: inline-block;\n  width: 320px;\n  /* Adjust width as needed */\n  min-width: 320px;\n  max-width: 320px;\n  font-size: 14px;\n  color: #000;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n/* Optional: prevent wrapping of the whole row */\n.fatf-upload-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n}\n\n.upload-history-label {\n  font-weight: 500;\n  color: #212519;\n  font-size: 21px;\n  margin-left: 18px;\n  margin-top: 7px;\n}\n\n.kyc-status-badge.approved {\n  color: #198754;\n  /* Green */\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.kyc-status-badge.pending {\n  color: #0d6efd;\n  /* Blue */\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.kyc-status-badge.rejected {\n  color: #dc3545;\n  /* Red */\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.login-logo {\n  width: 100%;\n  max-width: 400px;\n  height: auto;\n}\n\n.login_input_space {\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 1rem;\n}\n\n/* Stack tab buttons neatly on small screens */\n@media (max-width: 576px) {\n  .login_input_space {\n    padding: 0.75rem;\n  }\n\n  .login-logo {\n    max-width: 280px;\n  }\n\n  .login_btn_outline,\n  .btn-primary {\n    font-size: 14px;\n    padding: 0.5rem 0.75rem !important;\n  }\n\n  .login_btn_outline h5,\n  .btn-primary h5 {\n    font-size: 14px;\n    margin: 0;\n  }\n}\n\n.ekyc-list-reset-btn {\n  background: #2f6fed;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n}\n\n.risk-badge {\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.risk-badge.high {\n  background: #ec5c6a;\n  color: #fff;\n}\n\n\n.tag-risk {\n  background: #f4616f;\n  color: #fff;\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.risk-text {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.tag-risk-high {\n    background: #fee2e2;\n    color: #991b1b;\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 16px;\n}\n\n.tag-risk-medium {\n    background: #fef3c7;\n    color: #92400e;\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 16px;\n}\n\n.tag-risk-low {\n    background: #db838ca3;\n    color: #166534;\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 16px;\n}\n\n.tag-risk-pending {\n    background: #cbd5e180;\n    color: #334155;\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
